<template>
  <div id="student">
    <div class="datatable-edit__header">
      <div class="container">
        <h3>Student Details</h3>
        <a href="/student-list?mode=Search">Student List</a> > Student Edit<br />
        <label style="display: inline !important">Mode: </label><label style="display: inline !important">{{ lblCreateOrEdit }}</label>
        <label style="display: none !important">{{ lblStudentID }}</label>
        <label style="display: none !important">{{ lblParentID }}</label>
        <label style="display: none !important">{{ lblStudentIndexNo }}</label>
      </div>
    </div>
    <div v-if="changeStatusAction" class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 changeStatusArea">
      <div class="student-action-link container">
        <el-button-group>
          <el-button v-b-modal.withdrawModal type="primary" class="btnWithdraw"><i class="material-icons"> forward </i> Withdraw </el-button>
          <el-button v-on:click="showTransferModal('No')" type="primary" class="btnTransfer"><i class="material-icons"> import_export </i> Transfer </el-button>
          <el-button style="display: none !important" v-if="highestLevel" v-on:click="showTransferModal('Yes')" type="primary" class="btnTransfer">
            <i class="material-icons">import_export</i>
            Referral Transfer
          </el-button>
          <el-button type="primary" class="btnUploadDocument" v-on:click="showStudentDocumentManagerModal()">
            <i class="material-icons">folder</i> Document Manager
          </el-button>
          <el-popover placement="bottom" popper-class="student-status-popover student-status-poClassMate">
            <div>
              <input type="text" class="form-control" placeholder="Search Student" v-on:keyup="filterClassMate()" v-model="inputSearchClassMate" />
            </div>
            <div v-for="item in classMateList" class="divClassMate">
              <span @click="selectClassMate(item)">{{ item.Full_Name }}</span>
            </div>
            <el-button slot="reference" type="primary"> <i class="material-icons">perm_contact_calendar</i> Classmates </el-button>
          </el-popover>
        </el-button-group>
      </div>
    </div>
    <div v-if="changeStatusAction && PendingMovementStatusAction" class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 pendingMovementStatusActionArea">
      <div class="student-action-link container">
        <label class="pendingMovementStatusAction">{{ PendingMovementStatusAction }}</label>
      </div>
    </div>
    <div class="profilePictureArea form-group">
      <div class="container">
        <div class="profile_wrap">
          <div class="imgStudentProfile">
            <img v-bind:src="imgStudentProfile" type="file" @click="uploadStudentProfileImg()" class="" />
            <a class="student-profile-edit" @click="uploadStudentProfileImg()">
              <i class="material-icons"> edit </i>
            </a>
          </div>
          <span
            >{{ inputStudentID }} <br />
            {{ inputStudentFirstName }} <br />
            {{ StudentCreatedBy }}
          </span>
        </div>
        <div class="student-status" v-if="changeStatusAction">
          <div class="d-flex align-items-center">
            <span class="student-status-current">{{ lblCurrentStatus }}</span>
            <div v-if="lblCurrentStatus !== 'Withdrawn' && lblCurrentStatus !== 'Graduated' && lblCurrentStatus !== 'Void' && lblCurrentStatus !== 'Rejected'">
              <el-popover placement="bottom" width="200" trigger="click" popper-class="student-status-popover" ref="studentStatusPopOver">
                <label class="lblChangeStatusTo">Status Change To</label>
                <el-select v-model="ddlChangeStatusTo" placeholder="Select" class="ddlChangeStatusTo">
                  <el-option v-for="item in ddlChangeStatusToList" :key="item.StatusValue.trim()" :label="item.Status.trim()" :value="item.StatusValue.trim()">
                  </el-option>
                </el-select>
                <el-button type="primary" round v-on:click="StatusAction">Save</el-button>

                <el-button type="primary" round slot="reference">Change Status</el-button>
              </el-popover>
            </div>
            <div v-if="lblCurrentStatus === 'Withdrawn' || lblCurrentStatus === 'Graduated' || lblCurrentStatus === 'Void' || lblCurrentStatus === 'Rejected'">
              <el-button type="primary" round v-on:click="OpenReActivateModal">Re-Activate</el-button>
            </div>
          </div>
        </div>

        <div class="student-status schoolEmailDiv" v-if="lblCreateOrEdit === 'Edit' && lblStudentIndexNo">
          <div class="d-flex align-items-center">
            <el-popover placement="bottom" width="200" trigger="click" popper-class="student-status-popover" ref="studentEmailPopover">
              <div v-if="!inputStudentSchoolEmail">
                <el-button v-if="!inputStudentSchoolEmail" type="primary" round v-on:click="studentEmailAction('Create')">Create </el-button>
              </div>

              <div v-if="inputStudentSchoolEmail">
                <el-button v-if="inputStudentSchoolEmail" type="primary" round v-on:click="studentEmailAction('Delete')">Delete </el-button>
              </div>

              <div v-if="inputStudentSchoolEmail" class="resetPasswordStudentSchoolEmailDiv">
                <el-button v-if="inputStudentSchoolEmail" type="primary" round v-on:click="resetEmailPasswordShowModel()">Reset Password </el-button>
              </div>

              <el-button v-if="inputStudentSchoolEmail && !inputStudentSchoolEmailPassword" type="primary" round slot="reference"
                >{{ inputStudentSchoolEmail }}
              </el-button>
              <el-button v-if="inputStudentSchoolEmail && inputStudentSchoolEmailPassword" type="primary" round slot="reference"
                >{{ inputStudentSchoolEmail }} - Password:
                {{ inputStudentSchoolEmailPassword }}
              </el-button>
              <el-button v-if="!inputStudentSchoolEmail" type="primary" round slot="reference">No School Email </el-button>
            </el-popover>
          </div>
        </div>
      </div>
      <input type="file" ref="file" accept="image/*" style="display: none" @change="previewImgStudentProfile" />
    </div>
    <div class="mt-3 container">
      <el-tabs v-model="activeTab" class="studentPageBTabs" stretch @tab-click="activeTabHappen">
        <el-tab-pane name="Student">
          <span slot="label">
            <span
              v-if="
                !$v.ddlAgent.$error &&
                !$v.inputStudentFirstName.$error &&
                !$v.inputStudentLastName.$error &&
                !$v.ddlStudentNationality.$error &&
                !$v.inputStudentDateOfBirth.$error &&
                !$v.inputStudentIdentificationNo.$error &&
                !$v.inputStudentIdentificationExpiryDate.$error &&
                !$v.inputStudentBirthCertificate.$error &&
                !$v.inputStudentIC.$error &&
                !$v.inputStudentPassport.$error &&
                !$v.inputStudentPassportExpiryDate.$error &&
                !$v.inputFirstCommencementDate.$error &&
                !$v.inputStudentEnrolledCenterName.$error &&
                !$v.ddlStudentEnrolledCenterType.$error &&
                !$v.inputStudentPostalCode.$error &&
                !$v.inputStudentAddress1.$error
              "
            >
              Student
            </span>
            <el-badge
              value="!"
              class="item"
              v-if="
                $v.ddlAgent.$error ||
                $v.inputStudentFirstName.$error ||
                $v.inputStudentLastName.$error ||
                $v.ddlStudentNationality.$error ||
                $v.inputStudentDateOfBirth.$error ||
                $v.inputStudentIdentificationNo.$error ||
                $v.inputStudentIdentificationExpiryDate.$error ||
                $v.inputStudentBirthCertificate.$error ||
                $v.inputStudentIC.$error ||
                $v.inputStudentPassport.$error ||
                $v.inputStudentPassportExpiryDate.$error ||
                $v.inputFirstCommencementDate.$error ||
                $v.inputStudentEnrolledCenterName.$error ||
                $v.ddlStudentEnrolledCenterType.$error ||
                $v.inputStudentPostalCode.$error ||
                $v.inputStudentAddress1.$error
              "
            >
              Student
            </el-badge>
          </span>
          <div class="form-group">
            <div class="review-content-section">
              <div class="row familyIDAreaDiv">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Family No</label>
                  <input type="text" class="form-control" v-model="inputFamilyID" readonly="readonly" />
                  <input type="text" class="form-control" v-model="inputFamilyParentID" style="display: none" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="divFamilySearch">
                  <label class="lblSearchFamily" id="v-step-StudentSearchFamily">Search Family</label>
                  <b-btn v-on:click="openSearchFamilyModel()" variant="primary" v-bind:disabled="editModeDisable"> Search </b-btn>
                </div>
              </div>
              <div v-if="divEditParentLink" class="row familyIDAreaDiv">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <button v-on:click="EditParentLink" type="button" class="btn btn-primary waves-effect waves-light m-r-10">Edit Parent</button>
                </div>
              </div>
              <div v-if="!divParent" class="row col-lg-12 col-md-12 col-sm-12 col-xs-12 parentAreaDiv">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <button
                    v-on:click="CancelUseFamilyNo"
                    class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch"
                    v-bind:disabled="editModeDisable"
                  >
                    Cancel Use Family No
                  </button>
                  <button
                    v-on:click="ViewParent"
                    class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDViewParent"
                    v-bind:disabled="editModeDisable"
                  >
                    View / Edit Parent Info
                  </button>
                </div>
              </div>
            </div>
            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentPersonalInformation">Student's Personal Information</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* First Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputStudentFirstName"
                    :class="{ requiredFields: $v.inputStudentFirstName.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentFirstName.$error">First name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Middle Name</label>
                  <input type="text" class="form-control" v-model="inputStudentMiddleName" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Family Name</label>
                  <input type="text" class="form-control" v-model="inputStudentLastName" :class="{ requiredFields: $v.inputStudentLastName.$error }" />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentLastName.$error">Last name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Preferred Name</label>
                  <input type="text" class="form-control" v-model="inputStudentPreferredName" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Nationality</label>
                  <select
                    v-model="ddlStudentNationality"
                    class="form-control pro-edt-select form-control-primary"
                    :class="{ requiredFields: $v.ddlStudentNationality.$error }"
                    @change="onChangeNationalityBirthPlace()"
                  >
                    <option v-for="item in countryList" v-bind:value="item.CNYnationality.trim()">{{ item.CNYnationality.trim() }}</option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentNationality.$error">Nationality required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Gender</label>
                  <select
                    v-model="ddlStudentGender"
                    :class="{ requiredFields: $v.ddlStudentGender.$error }"
                    class="form-control pro-edt-select form-control-primary"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentGender.$error">Gender required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Date of Birth</label>
                  <div class="date">
                    <el-date-picker
                      v-model="inputStudentDateOfBirth"
                      format="dd/MM/yyyy"
                      @change="checkStudentAge()"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a date"
                      :class="{ requiredFields: $v.inputStudentDateOfBirth.$error }"
                    ></el-date-picker>
                  </div>
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentDateOfBirth.$error">Date of birth required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Birth Place</label>
                  <select v-model="ddlStudentBirthPlace" class="form-control pro-edt-select form-control-primary" @change="onChangeNationalityBirthPlace()">
                    <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-12">
                  <label style="color: #2196f3; background: #2196f31c; padding: 5px 14px; font-size: 13px">
                    ** Please fill in either Fin/PRIC or Passport.
                  </label>
                </div>
                <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** Fin / PR IC</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentIdentificationNo"
                    :class="{ requiredFields: $v.inputStudentIdentificationNo.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentIdentificationNo.$error">Fin required</div>
                </div>
                <div v-if="finShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** Fin Expiry Date / PR Re-entry Permit Expiry Date</label>
                  <div class="date">
                    <el-date-picker
                      v-model="inputStudentIdentificationExpiryDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a day"
                      :class="{ requiredFields: $v.inputStudentIdentificationExpiryDate.$error }"
                    ></el-date-picker>
                  </div>
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentIdentificationExpiryDate.$error">Fin expiry date required</div>
                </div>
                <div v-if="birthcertShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** Birth Certificate</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentBirthCertificate"
                    :class="{ requiredFields: $v.inputStudentBirthCertificate.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentBirthCertificate.$error">Birth certificate required</div>
                </div>
                <div v-if="icShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** IC</label>
                  <input type="text" class="form-control" v-model="inputStudentIC" :class="{ requiredFields: $v.inputStudentIC.$error }" />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentIC.$error">IC required</div>
                </div>
                <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** Passport</label>
                  <input type="text" class="form-control" v-model="inputStudentPassport" :class="{ requiredFields: $v.inputStudentPassport.$error }" />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentPassport.$error">Passport required</div>
                </div>
                <div v-if="passportShowHide" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>** Passport Expiry Date</label>
                  <div class="date">
                    <el-date-picker
                      v-model="inputStudentPassportExpiryDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a day"
                      :class="{ requiredFields: $v.inputStudentPassportExpiryDate.$error }"
                    ></el-date-picker>
                  </div>
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentPassportExpiryDate.$error">Passport expiry date required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Additional Language</label>
                  <select v-model="ddlStudentAdditionalLanguage" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentAdditionalLanguageList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Meal Preferences</label>
                  <select v-model="ddlStudentMealPreferences" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentMealPreferencesList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Dietary Requirement</label>
                  <input type="text" class="form-control" v-model="inputStudentDietaryRequirement" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>First Language Spoken</label>
                  <input type="text" class="form-control" v-model="inputStudentFirstLanguageSpoken" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Second Language Spoken</label>
                  <input type="text" class="form-control" v-model="inputSecondLanguageSpoken" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" style="display: none">
                  <label>Membership</label>
                  <select v-model="ddlStudentMembership" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlStudentMembershipList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="isLocalSchool || isIntPreSchool">
                  <label>Race</label>
                  <select v-model="ddlStudentRace" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlRaceList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-5">
                  <label>Comment</label>
                  <textarea rows="3" class="textArea" v-model="inputStudentComment"></textarea>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>House</label>
                  <input type="text" class="form-control" v-model="inputStudentHouse" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Media Consent</label>
                  <select v-model="ddlPhotographConsent" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlPhotographConsentList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Signed PDPA Consent</label>
                  <select class="form-control pro-edt-select form-control-primary" v-model="ddlPDPAConsent">
                    <option>No</option>
                    <option>Yes</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Student's Local Residential Address</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Country</label>
                  <select v-model="ddlStudentAddressCountry" @change="onchangeCopyAdd()" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label id="v-step-AddressesLRAPostalCode">* Postal Code</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentPostalCode"
                    :class="{ requiredFields: $v.inputStudentPostalCode.$error }"
                    v-on:blur="GetOneMapAPI('inputStudentPostalCode')"
                    @change="onchangeCopyAdd()"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentPostalCode.$error">Postal code required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Address 1</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentAddress1"
                    @change="onchangeCopyAdd()"
                    :class="{ requiredFields: $v.inputStudentAddress1.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentAddress1.$error">Address 1 required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Address 2</label>
                  <input type="text" class="form-control" v-model="inputStudentAddress2" @change="onchangeCopyAdd()" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Address 3</label>
                  <input type="text" class="form-control" v-model="inputStudentAddress3" @change="onchangeCopyAdd()" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>City</label>
                  <input type="text" class="form-control" v-model="inputStudentCity" @change="onchangeCopyAdd()" />
                </div>
              </div>
            </div>
            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-StudentRegistrationDetails">Student's Registration Details</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-3">
                  <label>* Commencement Date</label>
                  <div class="date" :class="{ inputFirstCommencementDateDiv: deferValid }">
                    <el-date-picker
                      v-model="inputFirstCommencementDate"
                      type="date"
                      @change="getAutoAssignLevelAcademicYear()"
                      format="dd/MM/yyyy"
                      class="inputFirstCommencementDate"
                      value-format="dd/MM/yyyy"
                      placeholder="Pick a day"
                      :class="{ requiredFields: $v.inputFirstCommencementDate.$error }"
                      v-bind:disabled="editModeDisable"
                      :picker-options="firstCommencementDatePickerOptions"
                    ></el-date-picker>

                    <span v-if="deferValid" class="gallery-action__item">
                      <el-popover placement="bottom" width="400" trigger="click" popper-class="student-status-popover">
                        <label class="lblSelectDeferDate">Select Defer Date</label>
                        <el-date-picker
                          v-model="inputDeferDate"
                          type="date"
                          format="dd/MM/yyyy"
                          class="inputDeferDate"
                          value-format="dd/MM/yyyy"
                          placeholder="Select Defer Date"
                          :picker-options="deferDatePickerOptions"
                        ></el-date-picker>
                        <el-button type="primary" class="btnDeferSave" v-on:click="SaveDefer">Save</el-button>

                        <el-button type="primary" icon="el-icon-date" slot="reference">Defer</el-button>
                      </el-popover>
                    </span>
                  </div>
                  <div class="requiredFieldsMsg" v-if="$v.inputFirstCommencementDate.$error">First commencement date required</div>
                  <div v-if="autoLevel" class="autoLevel">Level: {{ autoLevel }}</div>
                  <div v-else-if="!autoLevel && inputFirstCommencementDate && !$route.query.id" class="autoLevel">Level: No Level Found...</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-3">
                  <label>First Billing Notification</label>
                  <el-date-picker
                    v-model="inputFirstBillingNotification"
                    type="date"
                    format="dd/MM/yyyy"
                    class="inputFirstCommencementDate"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                  ></el-date-picker>
                </div>
                <div v-if="currentLevelClassList.length > 0" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Class</label>
                  <select v-model="ddlClass" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in currentLevelClassList" v-bind:value="item.ClassID">{{ item.ClassName }} - {{ item.ClassBatch }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Residency Status</label>
                  <select
                    v-model="ddlStudentResidencyStatus"
                    class="form-control pro-edt-select form-control-primary"
                    :class="{ requiredFields: $v.ddlStudentResidencyStatus.$error }"
                  >
                    <option v-for="item in ddlStudentResidencyStatusList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentResidencyStatus.$error">Residency status required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Authorised Representative (choose NIL if not applicable)</label>
                  <select v-model="ddlAgent" class="form-control pro-edt-select form-control-primary" :class="{ requiredFields: $v.ddlAgent.$error }">
                    <!-- Added by Darren: For Application Form the agent field is a free text, so need to show even if it's not in the dropdown. -->
                    <option :value="ddlAgent" v-if="!ddlAgentList.map(i => i.Name).includes(ddlAgent)">{{ ddlAgent }}</option>
                    <option v-for="item in ddlAgentList" v-bind:value="item.Name">{{ item.Name }}</option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlAgent.$error">Authorised Representative required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <div class="date" v-if="ddlAgent !== 'NIL'">
                    <label>* Agent-Student Onboard Date</label>
                    <el-date-picker
                      v-model="inputAgenStudentOnboardtDate"
                      format="dd/MM/yyyy"
                      :class="{ requiredFields: $v.inputAgenStudentOnboardtDate.$error }"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a date"
                    ></el-date-picker>
                    <div class="requiredFieldsMsg" v-if="$v.inputAgenStudentOnboardtDate.$error">Agent-Student Onboard Date required</div>
                  </div>

                  <div class="date" v-else>
                    <label>Agent-Student Onboard Date</label>
                    <el-date-picker
                      v-model="inputAgenStudentOnboardtDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      type="date"
                      placeholder="Pick a date"
                    ></el-date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="studentAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Before Commencement</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Enrolled in Other Center</label>
                  <select
                    class="form-control pro-edt-select form-control-primary"
                    v-model="ddlStudentEnrolledinOtherCenter"
                    @change="EnrolledinOtherCenterShow()"
                    v-bind:disabled="editModeDisable"
                  >
                    <option>No</option>
                    <option>Yes</option>
                  </select>
                </div>
              </div>
              <div class="row form-group__wrapper" v-if="divEnrolledinOtherCenterShow">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Center Name</label>
                  <input
                    type="text"
                    class="form-control form__input"
                    v-model="inputStudentEnrolledCenterName"
                    :class="{ requiredFields: $v.inputStudentEnrolledCenterName.$error }"
                    v-bind:disabled="editModeDisable"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentEnrolledCenterName.$error">Center name required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Center Type</label>
                  <select
                    v-model="ddlStudentEnrolledCenterType"
                    class="form-control pro-edt-select form-control-primary"
                    :class="{ requiredFields: $v.ddlStudentEnrolledCenterType.$error }"
                    v-bind:disabled="editCenterTypeDisable"
                  >
                    <option v-for="item in ddlStudentEnrolledCenterTypeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentEnrolledCenterType.$error">Center type required</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Parents" v-if="divParent">
          <span slot="label" id="v-step-ParentsTab">
            <span
              v-if="
                !$v.inputFatherFirstName.$error &&
                !$v.inputFatherLastName.$error &&
                !$v.inputFatherOccupation.$error &&
                !$v.inputMotherFirstName.$error &&
                !$v.inputMotherLastName.$error &&
                !$v.inputFatherEmail.$error &&
                !$v.inputFatherCompanyEmail.$error &&
                !$v.inputMotherEmail.$error &&
                !$v.inputMotherCompanyEmail.$error &&
                !$v.inputMotherOccupation.$error &&
                !$v.inputFatherOccupation.$error &&
                !$v.inputFatherCompanyName.$error &&
                !$v.inputFatherCompanyAddresseeName.$error &&
                !$v.inputMotherCompanyName.$error &&
                !$v.inputMotherCompanyAddresseeName.$error
              "
            >
              Parents
            </span>
            <el-badge
              value="!"
              class="item"
              v-if="
                $v.inputFatherFirstName.$error ||
                $v.inputFatherLastName.$error ||
                $v.inputFatherOccupation.$error ||
                $v.inputMotherFirstName.$error ||
                $v.inputMotherLastName.$error ||
                $v.inputFatherEmail.$error ||
                $v.inputFatherCompanyEmail.$error ||
                $v.inputMotherEmail.$error ||
                $v.inputMotherCompanyEmail.$error ||
                $v.inputMotherOccupation.$error ||
                $v.inputFatherOccupation.$error ||
                $v.inputFatherCompanyName.$error ||
                $v.inputFatherCompanyAddresseeName.$error ||
                $v.inputMotherCompanyName.$error ||
                $v.inputMotherCompanyAddresseeName.$error
              "
            >
              Parents
            </el-badge>
          </span>
          <div class="review-content-section">
            <div class="parentAreaDiv">
              <div v-if="divParent && parentRegisteredList.length > 0" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Registered Parents</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div v-for="item in parentRegisteredList" style="margin-bottom: 5px">
                    <div style="display: flex; align-items: center; gap: 10px">
                      <div>{{ item.Type }} Email : {{ item.Email }}</div>
                      <button @click="requestResetPassword(item.Email)" style="border: none; padding: 0 5px">Reset Password</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="divParent && inviteParentRegisterList.length > 0" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Create Parent Account</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Select Email</label>
                    <select v-model="ddlParentInvite" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in inviteParentRegisterList" v-bind:value="[item.Email.trim(), item.Type.trim(), item.ParentID]">
                        {{ item.Type.trim() }} - {{ item.Email.trim() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button v-on:click="openInviteParentModal()" type="button" class="btn btn-primary waves-effect waves-light m-r-10 float-left">Send</button>
                  </div>
                </div>
              </div>
              <div v-if="divParent && studentDeclaredTravel.ParentTravelDeclaration" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Travel Declaration</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div
                    v-for="item in studentDeclaredTravel.ParentTravelDeclaration.Table"
                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                    style="margin-top: 10px; text-align: left"
                  >
                    <div v-if="item.ParTrvDclBringChild === 'No'">
                      <p style="margin-bottom: 0" v-if="item.CreatedByName">Declared By / 申报者 : {{ item.CreatedByName }}</p>
                      <p style="margin-bottom: 0">Not traveling overseas / 没有出国</p>
                      <p style="margin-bottom: 0">
                        From / 从 {{ convertDatetime(item.ParTrvDclFromDate) }} to / 至 {{ convertDatetime(item.ParTrvDclToDate) }}
                      </p>
                      <p style="margin-bottom: 0" v-if="item.ParTrvDclRelLeaveEndDate">
                        Last date of close contact with LOA/HQO/SHN immediate family and friends / 与LOA/HQO/SHN 的家属或朋友有过密切接触的最后一天 :
                        {{ convertDatetime(item.ParTrvDclRelLeaveEndDate) }}
                      </p>
                      <p style="margin-bottom: 0" v-if="item.ParTrvDclRemark">Remarks / 备注 : {{ item.ParTrvDclRemark }}</p>
                    </div>
                    <div v-else-if="showStudentDeclaredTravel(item.ParTrvDclID)">
                      <p style="margin-bottom: 0" v-if="item.CreatedByName">Declared By / 申报者 : {{ item.CreatedByName }}</p>
                      <p style="margin-bottom: 0">
                        From / 从 {{ convertDatetime(item.ParTrvDclFromDate) }} to / 至 {{ convertDatetime(item.ParTrvDclToDate) }}
                      </p>
                      <p style="margin-bottom: 0" v-if="item.ParTrvDclTransCountry">
                        Transit / 过境 : {{ item.ParTrvDclTransCountry }} ({{ item.ParTrvDclTransCity }}) <br />Destination / 国家 :
                        {{ item.ParTrvDclCountry }} ({{ item.ParTrvDclCity }}) <br />Date of transit / 过境日期 :
                        <span v-if="!isNull(item.ParTrvDclTransDate)">{{ convertDatetime(item.ParTrvDclTransDate) }}</span
                        ><span v-else>-</span>
                      </p>
                      <p style="margin-bottom: 0" v-if="item.ParTrvDclCountry && !item.ParTrvDclTransCountry">
                        Travel to / 前往 {{ item.ParTrvDclCountry }} ({{ item.ParTrvDclCity }})
                      </p>
                      <p style="margin-bottom: 0" v-if="item.ParTrvDclRelLeaveEndDate">
                        Last date of close contact with LOA/HQO/SHN immediate family and friends / 与LOA/HQO/SHN 的家属或朋友有过密切接触的最后一天 :
                        {{ convertDatetime(item.ParTrvDclRelLeaveEndDate) }}
                      </p>
                      <p v-if="item.ParTrvDclRemark">Remarks / 备注 : {{ item.ParTrvDclRemark }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="divParent" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Father's Details</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputFatherFirstName"
                      v-bind:disabled="editModeDisable"
                      v-on:blur="CheckParentDup()"
                      :class="{ requiredFields: $v.inputFatherFirstName.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherFirstName.$error">First name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Middle Name</label>
                    <input type="text" class="form-control" v-model="inputFatherMiddleName" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* Last Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputFatherLastName"
                      v-bind:disabled="editModeDisable"
                      v-on:blur="CheckParentDup()"
                      :class="{ requiredFields: $v.inputFatherLastName.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherLastName.$error">Last name required</div>
                    <label v-if="lblFatherNameDuplicated">Father name is duplicated, please double confirm</label>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Date of Birth</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputFatherDateofBirth"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification Type</label>
                    <select v-model="ddlFatherIdentificationType" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlFatherIdentificationTypeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification No</label>
                    <input type="text" class="form-control" v-model="inputFatherIdentificationNo" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification No Expiry Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputFatherIdentificationNoExpiryDate"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Mobile No</label>
                    <input type="text" class="form-control" v-model="inputFatherMobileNo" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Email</label>
                    <input type="text" class="form-control" v-model="inputFatherEmail" v-bind:disabled="editModeDisable" />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherEmail.$error">Invalid email format</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="isLocalSchool || isIntPreSchool">
                    <label>Race</label>
                    <select v-model="ddlFatherRace" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlRaceList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Marital Status</label>
                    <select v-model="ddlFatherMaritalStatus" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlMaritalStatusList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Working</label>
                    <select
                      class="form-control pro-edt-select form-control-primary"
                      v-model="ddlFatherWorking"
                      @change="ParentCompanyAddressShow('Father')"
                      v-bind:disabled="editModeDisable"
                    >
                      <option>No</option>
                      <option>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="divParent & divFatherCompany" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Father's Company</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Occupation</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputFatherOccupation"
                      v-bind:disabled="editModeDisable"
                      :class="{ requiredFields: $v.inputFatherOccupation.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherOccupation.$error">Occupation required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Name</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" v-model="inputFatherCompanyName" />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherCompanyName.$error">Company Name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Addressee Name</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" v-model="inputFatherCompanyAddresseeName" />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherCompanyAddresseeName.$error">Company Addressee Name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 1</label>
                    <input
                      type="text"
                      class="form-control"
                      v-bind:disabled="editModeDisable"
                      @change="onchangeCopyAdd()"
                      v-model="inputFatherCompanyAddress1"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 2</label>
                    <input
                      type="text"
                      class="form-control"
                      v-bind:disabled="editModeDisable"
                      @change="onchangeCopyAdd()"
                      v-model="inputFatherCompanyAddress2"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 3</label>
                    <input
                      type="text"
                      class="form-control"
                      v-bind:disabled="editModeDisable"
                      @change="onchangeCopyAdd()"
                      v-model="inputFatherCompanyAddress3"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company City</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" @change="onchangeCopyAdd()" v-model="inputFatherCompanyCity" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Country</label>
                    <select
                      v-model="ddlFatherCompanyCountry"
                      v-bind:disabled="editModeDisable"
                      @change="onchangeCopyAdd()"
                      class="form-control pro-edt-select form-control-primary"
                    >
                      <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">
                        {{ item.CNYname.trim() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Postal Code</label>
                    <input
                      type="text"
                      class="form-control"
                      v-bind:disabled="editModeDisable"
                      @change="onchangeCopyAdd()"
                      v-model="inputFatherCompanyPostalCode"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Email</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" @change="onchangeCopyAdd()" v-model="inputFatherCompanyEmail" />
                    <div class="requiredFieldsMsg" v-if="$v.inputFatherCompanyEmail.$error">Invalid email format</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Working Commencement Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputFatherWorkingCommencementDate"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="divParent" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Mother's Details</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputMotherFirstName"
                      v-bind:disabled="editModeDisable"
                      v-on:blur="CheckParentDup()"
                      :class="{ requiredFields: $v.inputMotherFirstName.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherFirstName.$error">First name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Middle Name</label>
                    <input type="text" class="form-control" v-model="inputMotherMiddleName" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>* Last Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputMotherLastName"
                      v-bind:disabled="editModeDisable"
                      v-on:blur="CheckParentDup()"
                      :class="{ requiredFields: $v.inputMotherLastName.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherLastName.$error">Last name required</div>
                    <label v-if="lblMotherNameDuplicated">Mother name is duplicated, please double confirm</label>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Date of Birth</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputMotherDateofBirth"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification Type</label>
                    <select v-model="ddlMotherIdentificationType" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlMotherIdentificationTypeList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification No</label>
                    <input type="text" class="form-control" v-model="inputMotherIdentificationNo" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Identification No Expiry Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputMotherIdentificationNoExpiryDate"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Mobile No</label>
                    <input type="text" class="form-control" v-model="inputMotherMobileNo" v-bind:disabled="editModeDisable" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Email</label>
                    <input type="text" class="form-control" v-model="inputMotherEmail" v-bind:disabled="editModeDisable" />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherEmail.$error">Invalid email format</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="isLocalSchool || isIntPreSchool">
                    <label>Race</label>
                    <select v-model="ddlMotherRace" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlRaceList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Marital Status</label>
                    <select v-model="ddlMotherMaritalStatus" v-bind:disabled="editModeDisable" class="form-control pro-edt-select form-control-primary">
                      <option v-for="item in ddlMaritalStatusList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Working</label>
                    <select
                      class="form-control pro-edt-select form-control-primary"
                      v-model="ddlMotherWorking"
                      @change="ParentCompanyAddressShow('Mother')"
                      v-bind:disabled="editModeDisable"
                    >
                      <option>No</option>
                      <option>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div v-if="divParent & divMotherCompany" class="parentAreaDiv">
                <div class="">
                  <h5 class="text-left student-form__title">Mother's Company</h5>
                </div>
                <div class="row form-group__wrapper">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Occupation</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputMotherOccupation"
                      v-bind:disabled="editModeDisable"
                      :class="{ requiredFields: $v.inputMotherOccupation.$error }"
                    />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherOccupation.$error">Occupation required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Name</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" v-model="inputMotherCompanyName" />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherCompanyName.$error">Company Name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Addressee Name</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" v-model="inputMotherCompanyAddresseeName" />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherCompanyAddresseeName.$error">Company Addressee Name required</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 1</label>
                    <input
                      type="text"
                      class="form-control"
                      @change="onchangeCopyAdd()"
                      v-bind:disabled="editModeDisable"
                      v-model="inputMotherCompanyAddress1"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 2</label>
                    <input
                      type="text"
                      class="form-control"
                      @change="onchangeCopyAdd()"
                      v-bind:disabled="editModeDisable"
                      v-model="inputMotherCompanyAddress2"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Address 3</label>
                    <input
                      type="text"
                      class="form-control"
                      @change="onchangeCopyAdd()"
                      v-bind:disabled="editModeDisable"
                      v-model="inputMotherCompanyAddress3"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company City</label>
                    <input type="text" class="form-control" @change="onchangeCopyAdd()" v-bind:disabled="editModeDisable" v-model="inputMotherCompanyCity" />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Country</label>
                    <select
                      v-model="ddlMotherCompanyCountry"
                      @change="onchangeCopyAdd()"
                      v-bind:disabled="editModeDisable"
                      class="form-control pro-edt-select form-control-primary"
                    >
                      <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">
                        {{ item.CNYname.trim() }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Postal Code</label>
                    <input
                      type="text"
                      class="form-control"
                      @change="onchangeCopyAdd()"
                      v-bind:disabled="editModeDisable"
                      v-model="inputMotherCompanyPostalCode"
                    />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Company Email</label>
                    <input type="text" class="form-control" v-bind:disabled="editModeDisable" @change="onchangeCopyAdd()" v-model="inputMotherCompanyEmail" />
                    <div class="requiredFieldsMsg" v-if="$v.inputMotherCompanyEmail.$error">Invalid email format</div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Working Commencement Date</label>
                    <div class="date">
                      <el-date-picker
                        v-model="inputMotherWorkingCommencementDate"
                        v-bind:disabled="editModeDisable"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        type="date"
                        placeholder="Pick a day"
                      ></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="emergencyContact">
          <span slot="label" id="v-step-EmergencyContactTab"> Contact </span>
          <div class="form-group">
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">1st Emergency Contact</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact Person</label>
                  <input type="text" class="form-control" v-model="inputStudent1stEmergencyContact" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact No</label>
                  <input type="text" class="form-control" v-model="inputStudent1stEmergencyContactNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact Relation</label>
                  <select
                    v-model="inputStudent1stEmergencyContactRelation"
                    class="form-control pro-edt-select form-control-primary"
                    @change="onchangeEmerContact('first')"
                  >
                    <option v-for="item in emergencyContactList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div v-if="inputStudent1stEmergencyContactRelation === 'Others'" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>&nbsp;</label>
                  <input type="text" class="form-control" v-model="firstEmerContactRelationOther" />
                </div>
              </div>
            </div>
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">2nd Emergency Contact</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label> Contact Person</label>
                  <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContact" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact No</label>
                  <input type="text" class="form-control" v-model="inputStudent2ndEmergencyContactNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact Relation</label>
                  <select
                    v-model="inputStudent2ndEmergencyContactRelation"
                    class="form-control pro-edt-select form-control-primary"
                    @change="onchangeEmerContact('second')"
                  >
                    <option v-for="item in emergencyContactList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div v-if="inputStudent2ndEmergencyContactRelation === 'Others'" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>&nbsp;</label>
                  <input type="text" class="form-control" v-model="secondEmerContactRelationOther" />
                </div>
              </div>
            </div>
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">3rd Emergency Contact</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label> Contact Person</label>
                  <input type="text" class="form-control" v-model="inputStudent3rdEmergencyContact" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact No</label>
                  <input type="text" class="form-control" v-model="inputStudent3rdEmergencyContactNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Contact Relation</label>
                  <select
                    v-model="inputStudent3rdEmergencyContactRelation"
                    class="form-control pro-edt-select form-control-primary"
                    @change="onchangeEmerContact('third')"
                  >
                    <option v-for="item in emergencyContactList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div v-if="inputStudent3rdEmergencyContactRelation === 'Others'" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>&nbsp;</label>
                  <input type="text" class="form-control" v-model="thirdEmerContactRelationOther" />
                </div>
              </div>
            </div>
            <div class="ecAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Authorized Children Pickup</h5>
              </div>
              <div style="border: 4px solid #eee" v-if="lblStudentID">
                <Academica :url="'https://academica.etonhouse.com/headless/AuthorizedPerson/' + lblStudentID + '/UserId/' + handleUserID()" height="400px" />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Addresses">
          <span slot="label" id="v-step-AddressesTab">
            <span
              v-if="
                !$v.inputStudentCorrespondancePostalCode.$error &&
                !$v.inputStudentCorrespondanceAddress1.$error &&
                !$v.ddlStudentPayer.$error &&
                !$v.inputStudentEmail.$error &&
                !$v.ddlStudentFrequentPayments.$error
              "
              >Billing</span
            >
            <el-badge
              value="!"
              class="item"
              v-if="
                $v.inputStudentCorrespondancePostalCode.$error ||
                $v.inputStudentCorrespondanceAddress1.$error ||
                $v.ddlStudentPayer.$error ||
                $v.inputStudentEmail.$error ||
                $v.ddlStudentFrequentPayments.$error
              "
            >
              Billing</el-badge
            >
          </span>
          <div class="form-group">
            <div class="addAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Billing Info</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Payer</label>
                  <select
                    v-model="ddlStudentPayer"
                    class="form-control pro-edt-select form-control-primary"
                    :class="{ requiredFields: $v.ddlStudentPayer.$error }"
                  >
                    <option
                      v-for="item in ddlStudentPayerList"
                      v-bind:value="item.OPTvalue.trim()"
                      :disabled="
                        (disFatherCompany && item.OPTvalue.trim() === 'Father Company' && divParent) ||
                        (disMotherCompany && item.OPTvalue.trim() === 'Mother Company' && divParent)
                      "
                    >
                      {{ item.OPTvalue.trim() }}
                    </option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentPayer.$error">Payer required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Frequent Payments</label>
                  <select
                    v-model="ddlStudentFrequentPayments"
                    class="form-control pro-edt-select form-control-primary"
                    :class="{ requiredFields: $v.ddlStudentFrequentPayments.$error }"
                  >
                    <option v-for="item in studentFrequentPayments" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                  <div class="requiredFieldsMsg" v-if="$v.ddlStudentFrequentPayments.$error">Frequent Payments required</div>
                </div>
                <div v-if="isIntPreSchool || isLocalSchool" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>CDA</label>
                  <input type="text" class="form-control" v-model="inputStudentCda" />
                </div>
                <div v-if="ddlStudentSubsidyShow" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Subsidy</label>
                  <el-select v-model="ddlStudentSubsidy" multiple class="ddlStudentSubsidy">
                    <el-option v-for="item in ddlStudentSubsidyList" :key="item.OPTid.trim()" :label="item.OPTvalue.trim()" :value="item.OPTid.trim()">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="addAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Billing Address</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label id="v-step-AddressesBACopyAddress">Copy Address From Student's Permanent Address</label>
                  <select v-model="ddlCopyAddToStuCorAdd" class="form-control pro-edt-select form-control-primary" @change="onchangeCopyAdd()">
                    <option v-for="item in copyAddressList" v-bind:value="item">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Country</label>
                  <select
                    v-model="ddlStudentAddressCorrespondanceCountry"
                    @change="onchangeCopyAdd()"
                    v-bind:disabled="stuCorAddCopy"
                    class="form-control pro-edt-select form-control-primary"
                  >
                    <option v-for="item in countryList" v-bind:value="item.CNYname.trim()">{{ item.CNYname.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Postal Code</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentCorrespondancePostalCode"
                    :class="{ requiredFields: $v.inputStudentCorrespondancePostalCode.$error }"
                    v-bind:disabled="stuCorAddCopy"
                    v-on:blur="GetOneMapAPI('inputStudentCorrespondancePostalCode')"
                    @change="onchangeCopyAdd()"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentCorrespondancePostalCode.$error">Postal code required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Address 1</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentCorrespondanceAddress1"
                    @change="onchangeCopyAdd()"
                    v-bind:disabled="stuCorAddCopy"
                    :class="{ requiredFields: $v.inputStudentCorrespondanceAddress1.$error }"
                  />
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentCorrespondanceAddress1.$error">Address 1 required</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Address 2</label>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:disabled="stuCorAddCopy"
                    v-model="inputStudentCorrespondanceAddress2"
                    @change="onchangeCopyAdd()"
                  />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Address 3</label>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:disabled="stuCorAddCopy"
                    v-model="inputStudentCorrespondanceAddress3"
                    @change="onchangeCopyAdd()"
                  />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>City</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="inputStudentCorrespondanceCity"
                    @change="onchangeCopyAdd()"
                    v-bind:disabled="stuCorAddCopy"
                  />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Mobile No</label>
                  <input type="text" class="form-control" v-model="inputStudentMobileNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Home Tel No</label>
                  <input type="text" class="form-control" v-model="inputStudentOfficeTelNo" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>* Email</label>
                  <div>
                    <input
                      type="text"
                      class="form-control inputStudentEmail"
                      disabled
                      :class="{ requiredFields: $v.inputStudentEmail.$error }"
                      v-model="inputStudentEmail"
                    />
                    <span>
                      <i class="material-icons inputStudentEmailDelete" @click="removeBillingEmail" v-if="!stuCorEmailAddCopy"> delete </i>
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    <el-popover placement="bottom" width="500" trigger="click" popper-class="student-status-popover">
                      <div>
                        <input type="text" class="form-control" :class="{ requiredFields: $v.inputStudentEmailAdd.$error }" v-model="inputStudentEmailAdd" />
                        <div class="requiredFieldsMsg" v-if="$v.inputStudentEmailAdd.$error">Email required or Invalid Email Format</div>
                        <el-button v-on:click="billingEmailValidation" type="primary" round> Add </el-button>
                      </div>

                      <el-button type="primary" round slot="reference" v-bind:disabled="stuCorAddCopy && stuCorEmailAddCopy"> Add Email </el-button>
                    </el-popover>
                  </div>
                  <div class="requiredFieldsMsg" v-if="$v.inputStudentEmail.$error">Email required</div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Medical">
          <span slot="label" id="v-step-MedicalTab"> Medical </span>
          <div class="form-group">
            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Medication Allergies List</h5>
              </div>
              <div>
                <div v-if="medicationAllergiesListInt.length > 0">
                  <data-tables :data="medicationAllergiesListInt" :action-col="medicationAllergiesListAcion">
                    <el-table-column
                      v-for="medicationAllergiesListInfo in medicationAllergiesList"
                      :prop="medicationAllergiesListInfo.prop"
                      :label="medicationAllergiesListInfo.label"
                      :key="medicationAllergiesListInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Medication</label>
                  <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesMedication" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Remarks</label>
                  <input type="text" class="form-control" v-model="inputStudentMedicationAllergiesRemarks" />
                </div>
              </div>
              <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addMedicationAllergiesList()">Add</button>
            </div>
            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Food Allergies List</h5>
              </div>
              <div>
                <div v-if="foodAllergiesListInt.length > 0">
                  <data-tables :data="foodAllergiesListInt" :action-col="foodAllergiesListAcion">
                    <el-table-column
                      v-for="foodAllergiesListInfo in foodAllergiesList"
                      :prop="foodAllergiesListInfo.prop"
                      :label="foodAllergiesListInfo.label"
                      :key="foodAllergiesListInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Food</label>
                  <select v-model="ddlStudentFoodAllergiesFood" class="form-control pro-edt-select form-control-primary">
                    <option v-for="item in ddlddlStudentFoodAllergiesFoodList" v-bind:value="item.OPTvalue.trim()">{{ item.OPTvalue.trim() }}</option>
                  </select>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Remarks</label>
                  <input type="text" class="form-control" v-model="inputStudentFoodAllergiesRemarks" />
                </div>
              </div>
              <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="addFoodAllergiesList()">Add</button>
            </div>
            <div class="medAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Student's Medical Details</h5>
              </div>
              <div class="row form-group__wrapper">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Major Ailments List</label>
                  <textarea rows="3" class="textArea" v-model="taMajorAilmentsList"></textarea>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Name of Family Doctor</label>
                  <input type="text" class="form-control" v-model="inputNameofFamilyDoctor" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Clinic Address</label>
                  <input type="text" class="form-control" v-model="inputClinicAddress" />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Clinic Phone No</label>
                  <input type="text" class="form-control" v-model="inputClinicPhoneNo" />
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Siblings" v-if="siblingTab">
          <span slot="label"> Siblings </span>
          <div v-if="siblingList.length > 0">
            <data-tables :data="siblingList">
              <el-table-column
                v-for="siblingListInfo in siblingListAll"
                :prop="siblingListInfo.prop"
                :label="siblingListInfo.label"
                :key="siblingListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column label="Edit">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    :disabled="checkSiblingEditButton(siblingList[scope.$index].School_ID) !== true"
                    @click.native.prevent="editSibling(siblingList[scope.$index].School_ID, siblingList[scope.$index].Student_ID)"
                  >
                    Edit
                  </el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
          <div v-else class="siblingNoRecordArea">
            <label>No Record Found...</label>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Level" v-if="levelTab">
          <span slot="label"> Level </span>
          <div class="form-group">
            <div class="lvlAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-LevelTabTitle">Level</h5>
              </div>
              <div v-if="lvlLevelList_Level.length > 0">
                <data-tables :data="lvlLevelList_Level">
                  <el-table-column
                    v-for="lvlLevelList_LevelAllInfo in lvlLevelList_LevelAll"
                    :prop="lvlLevelList_LevelAllInfo.prop"
                    :label="lvlLevelList_LevelAllInfo.label"
                    :key="lvlLevelList_LevelAllInfo.prop"
                    sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column label="Action" min-width="100px">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="openVoidlevelModal(scope.row)"
                        v-if="scope.row.SCRS_Status == 'Active' || scope.row.SCRS_Status == 'Pending' || scope.row.SCRS_Status == 'Waitlist'"
                      >
                        Void
                      </el-button>
                    </template>
                  </el-table-column>

                  <el-table-column label="Edit Level" min-width="100px">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="openEditLevelModal(scope.row)"
                        v-if="scope.row.SCRS_Status == 'Pending' || scope.row.SCRS_Status == 'Waitlist'"
                      >
                        Edit Level
                      </el-button>
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Hubspot" v-if="lblCreateOrEdit === 'Edit' && hubSpotID && Object.keys(studentHubSpotAll).length > 0">
          <span slot="label"> Hubspot </span>
          <div class="form-group">
            <div class="hsAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title">Hubspot</h5>
              </div>
              <div class="row form-group__wrapper">
                <el-tabs v-model="hubspotActiveTab" class="hubspotBTabs" stretch @tab-click="hubspotActiveTabHappen">
                  <el-tab-pane label="NOTE" name="NOTE" class="hubspotBTabs-pane">
                    <div
                      v-for="item in studentHubSpotAll.Details"
                      v-if="
                        item.HsdType === 'NOTE' &&
                        hubspotNoteTabDetials &&
                        !item.HsdBody.includes('https://ems.etonhouse.com') &&
                        !item.HsdBody.includes('https://kagami.etonhouse.com')
                      "
                    >
                      <div class="hubSpotNote">
                        <div class="hubSpotNoteHeader">
                          <label>Date: {{ item.HsdEngagementCreatedOn_convert }}</label>
                        </div>
                        <div class="hubSpotNoteBody" v-html="item.HsdBody"></div>
                      </div>
                    </div>
                    <div v-if="!hubspotNoteTabDetials">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="TASK" name="TASK" class="hubspotBTabs-pane">
                    <div v-for="item in studentHubSpotAll.Details" v-if="item.HsdType === 'TASK' && hubspotTaskTabDetials">
                      <div class="hubSpotTask">
                        <div class="hubSpotTaskHeader">
                          <label>Date: {{ item.HsdEngagementCreatedOn_convert }}</label>
                          <label>Subject: {{ item.HsdSubject }}</label>
                        </div>
                        <div class="hubSpotTaskBody" v-html="item.HsdBody"></div>
                      </div>
                    </div>
                    <div v-if="!hubspotTaskTabDetials">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="EMAIL" name="EMAIL" class="hubspotBTabs-pane">
                    <div
                      v-for="(item, index) in studentHubSpotAll.Details"
                      v-if="(item.HsdType === 'EMAIL' || item.HsdType === 'INCOMING_EMAIL') && hubspotEmailTabDetials"
                    >
                      <div class="hubSpotEmail">
                        <el-collapse v-model="accordionHubSpotEmail" accordion>
                          <el-collapse-item :title="item.HsdEngagementCreatedOn_convert + ' : ' + item.HsdSubject" :name="index">
                            <div v-for="attachmentItem in gethubSpotAttachmentLink(item.HsdID)">
                              <label class="lblHubspotDownload" @click="downloadHubSpotAttachment(attachmentItem.HsdItemID)">
                                <span class="el-icon-download hubspotDownloadIcon"></span>
                                {{ attachmentItem.HsdItemFileName }}{{ attachmentItem.HsdItemFileExt }}
                              </label>
                            </div>
                            <div class="hubSpotEmailBody" v-html="gethubSpotFirstEmailInThread(item.HsdID)"></div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                    </div>
                    <div v-if="!hubspotEmailTabDetials">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="CALL" name="CALL" class="hubspotBTabs-pane">
                    <div v-for="item in studentHubSpotAll.Details" v-if="item.HsdType === 'CALL' && hubspotCallTabDetials">
                      <div class="hubSpotCall">
                        <div class="hubSpotCallHeader">
                          <label>Date: {{ item.HsdEngagementCreatedOn_convert }}</label>
                        </div>
                        <div class="hubSpotCallBody" v-html="item.HsdBody"></div>
                      </div>
                    </div>
                    <div v-if="!hubspotCallTabDetials">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="MEETING" name="MEETING" class="hubspotBTabs-pane">
                    <div v-for="item in studentHubSpotAll.Details" v-if="item.HsdType === 'MEETING' && hubspotMeetingTabDetials">
                      <div class="hubSpotMeeting">
                        <div class="hubSpotMeetingHeader">
                          <label>Date: {{ item.HsdEngagementCreatedOn_convert }}</label>
                          <label>Subject: {{ item.HsdSubject }}</label>
                        </div>
                        <div class="hubSpotMeetingBody" v-html="item.HsdBody"></div>
                      </div>
                    </div>
                    <div v-if="!hubspotMeetingTabDetials">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="DEAL STAGE" name="DEALSTAGE" class="hubspotBTabs-pane">
                    <div v-for="item in studentHubSpotAll.DealStage" v-if="studentHubSpotAll.DealStage.length > 0">
                      <div class="hubSpotDealStage">
                        <div class="hubSpotDealStageHeader">
                          <label>Date: {{ item.HsdDealStageStageCreatedOn_convert }}</label>
                        </div>
                        <div class="hubSpotDealStageBody">
                          <label>Stage: {{ item.HsdDealStageStage }}</label>
                          <label>Commited by: {{ item.HsdDealStageUser }}</label>
                        </div>
                      </div>
                    </div>
                    <div v-if="studentHubSpotAll.DealStage.length < 1">
                      <label>No record found...</label>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="Meals" v-if="mealsTab">
          <span slot="label"> Meals </span>

          <div class="form-group">
            <div class="mealsAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-mealsTabTitle">
                  Meals
                  <select
                    v-model="ddlMealsStudentCourseID"
                    style="display: inline; width: 50%"
                    class="form-control pro-edt-select form-control-primary"
                    @change="getStudentMeals()"
                  >
                    <option
                      v-for="lvlLevelList_LevelDta in lvlLevelList_Level"
                      v-bind:value="lvlLevelList_LevelDta.PK_Student_Course_ID.trim()"
                      v-if="lvlLevelList_LevelDta.SCRS_Status.trim() != 'Void'"
                      :selected="lvlLevelList_LevelDta.SCRS_Status.trim() == 'Active'"
                    >
                      {{ lvlLevelList_LevelDta.SCH_Short_Name.trim() }} - {{ lvlLevelList_LevelDta.SMT_Code.trim() }}
                    </option>
                  </select>
                  <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="openAddMealsModal()" style="float: right">Add</button>
                </h5>
              </div>
              <div>
                <data-tables :data="lvlMealsList_Meals">
                  <el-table-column
                    v-for="lvlMealsList_MealsAllInfo in lvlMealsList_MealsAll"
                    :prop="lvlMealsList_MealsAllInfo.prop"
                    :label="lvlMealsList_MealsAllInfo.label"
                    :key="lvlMealsList_MealsAllInfo.prop"
                    sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column label="Action" min-width="100px">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="openVoidMealsModal(scope.row)"
                        v-if="scope.row.SML_Status == 'Active' || scope.row.SML_Status == 'Pending' || scope.row.SML_Status == 'Waitlist'"
                      >
                        Cancellation
                      </el-button>
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="AddLang" v-if="addLangTab">
          <span slot="label"> Additional Language </span>

          <div class="form-group">
            <div class="addLangAreaDiv">
              <div class="">
                <h5 class="text-left student-form__title" id="v-step-addLangTabTitle">
                  Additional Language
                  <select
                    v-model="ddlAddLangStudentCourseID"
                    style="display: inline; width: 50%"
                    class="form-control pro-edt-select form-control-primary"
                    @change="getAddLang()"
                  >
                    <option
                      v-for="lvlLevelList_LevelDta in lvlLevelList_Level"
                      v-bind:value="lvlLevelList_LevelDta.PK_Student_Course_ID.trim()"
                      v-if="lvlLevelList_LevelDta.SCRS_Status.trim() != 'Void'"
                      :selected="lvlLevelList_LevelDta.SCRS_Status.trim() == 'Active'"
                    >
                      {{ lvlLevelList_LevelDta.SCH_Short_Name.trim() }} - {{ lvlLevelList_LevelDta.SMT_Code.trim() }}
                    </option>
                  </select>
                  <button class="btn btn-primary waves-effect waves-light m-r-10" v-on:click="openAddLangModal()" style="float: right">Add</button>
                </h5>
              </div>
              <div>
                <data-tables :data="lvlAddLangList_AddLang">
                  <el-table-column
                    v-for="lvlAddLangList_AddLangAllInfo in lvlAddLangList_AddLangAll"
                    :prop="lvlAddLangList_AddLangAllInfo.prop"
                    :label="lvlAddLangList_AddLangAllInfo.label"
                    :key="lvlAddLangList_AddLangAllInfo.prop"
                    sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column label="Action" min-width="100px">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        @click="openVoidAddLangModal(scope.row)"
                        v-if="scope.row.SAL_Status == 'Active' || scope.row.SAL_Status == 'Pending' || scope.row.SML_Status == 'Waitlist'"
                      >
                        Cancellation
                      </el-button>
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="whitespace-30"></div>
      <div class="buttonArea">
        <div class="text-center mg-b-pro-edt custom-pro-edt-ds">
          <button v-on:click="backToPrevious" type="button" class="btn btn-primary waves-effect waves-light m-r-10 float-left">Cancel</button>
          <button
            v-if="btnSave"
            v-on:click="Validation"
            type="button"
            id="v-step-SaveButton"
            class="btn btn-primary waves-effect waves-light m-r-10 float-right"
          >
            Save
          </button>
          <button v-if="btnNext" v-on:click="nextsaveButtonShow" type="button" class="btn btn-primary waves-effect waves-light m-r-10 float-right">Next</button>
          <button v-if="btnPrevious" v-on:click="previousButtonShow" type="button" class="btn btn-primary waves-effect waves-light m-r-10 float-right">
            Previous
          </button>
          <el-button
            type="primary"
            class="btn btn-primary waves-effect waves-light m-r-10 float-left"
            style="display: none"
            v-if="!editModeDisable"
            @click="studentPageVueTourStart()"
          >
            Guided Tour
          </el-button>
          <el-button
            type="primary"
            class="btn btn-primary waves-effect waves-light m-r-10 float-left"
            style="display: none"
            v-if="!editModeDisable"
            @click="studentPageVueUpdateLevelClassTourStart()"
          >
            Guided Tour - UpdateLevelClass
          </el-button>
        </div>
      </div>
      <div class="whitespace-30" style="clear: both"></div>
    </div>
    <div class="whitespace-30" style="clear: both"></div>
    <b-modal
      id="familyModal"
      size="lg"
      class="studentPageBModal"
      title="Search Family ID"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="familyModalShowModal"
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Student Name</label>
          <input type="text" class="form-control" ref="familyIDStudentName" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Family No</label>
          <input type="text" class="form-control" ref="familyIDFamilyNo" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Parent First Name</label>
          <input type="text" class="form-control" ref="familyParentFirstName" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <label>Parent Last Name</label>
          <input type="text" class="form-control" ref="familyParentLastName" />
        </div>
        <div v-if="familyIDList.length > 0" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <data-tables :data="familyIDList" :action-col="actionCol">
            <el-table-column
              v-for="familyIDListInfo in familyIDListAll"
              :prop="familyIDListInfo.prop"
              :label="familyIDListInfo.label"
              :key="familyIDListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button v-on:click="SearchFamilyID" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Search</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="withdrawModal"
      class="studentPageBModal"
      title="Withdraw"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="withdrawShowModal"
      hide-footer
      v-model="withdrawShowModal"
    >
      <div>
        <div class="row form-group__wrapper">
          <student-withdraw-form
            @date="inputWithdrawalDate = $event"
            @main-reason="ddlMainReason = $event"
            @school="ddlInternationalSchool = $event"
            @reason1="ddlReason1 = $event"
            @reason2="ddlReason2 = $event"
            @reason3="ddlReason3 = $event"
            @close="hideModal()"
            @submit="WithdrawSave()"
          />
        </div>
      </div>
    </b-modal>
    <b-modal
      id="transferModal"
      v-model="transferModal"
      class="studentPageBModal"
      :title="referralTransferModeTitle"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="transferShowModal"
      hide-footer
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>{{ referralTransferModeTitle }} to School</label>
          <select v-model="ddlTransferSchool" class="form-control pro-edt-select form-control-primary">
            <option v-for="item in transferSchoolList" v-bind:value="item.PK_SCH_ID">
              {{ item.SCH_Name }}
            </option>
          </select>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Remarks</label>
          <input type="text" class="form-control" v-model="inputTransferSchoolRemark" />
        </div>
        <div class="col-lg-12 mb-5">
          <label>Last day of current campus</label>
          <div class="date">
            <el-date-picker
              v-model="inputTransferSchoolEffDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a day"
              class="fullwidth"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="row custom-modal-footer">
        <div class="col-lg-6">
          <button @click="hideModal()" class="btn btn-secondary float-left">Cancel</button>
        </div>
        <div class="col-lg-6">
          <button v-on:click="transferSave" class="btn btn-primary float-right btnFamilyIDSearch">Confirm Transfer</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="uploadDocumentModal"
      class="studentPageBModal"
      title="Student Document"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="uploadDocumentShowModal"
      v-model="uploadDocumentShowModal"
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="upload-box">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label><i class="material-icons"> attachment </i> Select File</label>
            <div class="file-upload-wrapper" :data-text="studentDocumentModel">
              <input name="file-upload-field" type="file" class="file-upload-field" value="" ref="studentDocument" @change="studentDocumentName" />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label><i class="material-icons"> format_align_left </i> File Description</label>
            <input type="text" class="form-control form__input" v-model="inputStudentFileDescription" />
          </div>
          <div class="col-lg-12" v-if="uploadisLoading">
            <div class="bar"></div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <button class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch" v-on:click="uploadStudentDocument()">Upload</button>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="studentFileListInt.length > 0">
            <data-tables :data="studentFileListInt" :action-col="studentFileListAction">
              <el-table-column
                v-for="studentFileListInfo in studentFileList"
                :prop="studentFileListInfo.prop"
                :label="studentFileListInfo.label"
                :key="studentFileListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column label="Download" min-width="100px">
                <template slot-scope="scope">
                  <el-button @click="studentFileDownload(scope.row)"> Download </el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="uploadImmunizationRecordsModal"
      class="studentPageBModal"
      title="Immunization Records"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="uploadImmunizationRecordsShowModal"
      v-model="uploadImmunizationRecordsShowModal"
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="upload-box">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <!--<input type="file" ref="studentDocument" accept="image/*" multiple>-->
            <label><i class="material-icons"> attachment </i> Select File</label>
            <div class="file-upload-wrapper" :data-text="studentImmunizationModel">
              <input name="file-upload-field" type="file" class="file-upload-field" value="" ref="immunizationRecords" @change="studentImmunizationName" />
            </div>
            <!--<input type="file" ref="studentDocument">-->
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label><i class="material-icons"> format_align_left </i> File Description</label>
            <input type="text" class="form-control form__input" v-model="inputImmunizationRecordsDescription" />
          </div>
          <div class="col-lg-12" v-if="uploadisLoading">
            <div class="bar"></div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <button class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch" v-on:click="uploadImmunizationRecords()">Upload</button>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="studentFileListInt.length > 0">
            <data-tables :data="studentFileListInt" :action-col="studentFileListAction">
              <el-table-column
                v-for="studentFileListInfo in studentFileList"
                :prop="studentFileListInfo.prop"
                :label="studentFileListInfo.label"
                :key="studentFileListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column label="Download" min-width="100px">
                <template slot-scope="scope">
                  <el-button @click="studentFileDownload(scope.row)"> Download </el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="uploadAllAboutMeModal"
      class="studentPageBModal"
      title="All About Me"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="uploadAllAboutMeShowModal"
      v-model="uploadAllAboutMeShowModal"
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="upload-box">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <!--<input type="file" ref="studentDocument" accept="image/*" multiple>-->
            <label><i class="material-icons"> attachment </i> Select File</label>
            <div class="file-upload-wrapper" :data-text="studentMeModel">
              <input name="file-upload-field" type="file" class="file-upload-field" value="" ref="allAboutMe" @change="studentMeName" />
            </div>
            <!--<input type="file" ref="studentDocument">-->
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label><i class="material-icons"> format_align_left </i> File Description</label>
            <input type="text" class="form-control form__input" v-model="inputAllAboutMeDescription" />
          </div>
          <div class="col-lg-12" v-if="uploadisLoading">
            <div class="bar"></div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <button class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch" v-on:click="uploadAllAboutMe()">Upload</button>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div v-if="studentFileListInt.length > 0">
            <data-tables :data="studentFileListInt" :action-col="studentFileListAction">
              <el-table-column
                v-for="studentFileListInfo in studentFileList"
                :prop="studentFileListInfo.prop"
                :label="studentFileListInfo.label"
                :key="studentFileListInfo.prop"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column label="Download" min-width="100px">
                <template slot-scope="scope">
                  <el-button @click="studentFileDownload(scope.row)"> Download </el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="reActivateModal" size="lg" title="Re-Activate" ok-only ok-variant="secondary" ok-title="Cancel" ref="reActivateShowModal" hide-footer>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Date of Commencement</label>
          <div class="date">
            <el-date-picker
              v-model="inputReActivateDateOfCommencement"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a date"
            ></el-date-picker>
          </div>
        </div>
        <hr class="custom-hr" />
        <div class="col-lg-12">
          <button v-on:click="openReActivateConfirmModal()" class="btn btn-primary waves-effect waves-light m-r-10">Re-Activate</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="reActivateConfirmModal"
      size="sm"
      title="Confirm Re-Active"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="reActivateConfirmShowModal"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">Confirm ?</div>
        <div class="col-lg-12">
          <button v-on:click="reActive()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="rejectStatus" size="sm" title="Student Reject" ok-only ok-variant="secondary" ok-title="Cancel" ref="rejectStatusShowModal" hide-footer>
      <div class="row form-group__wrapper">
        <div class="col-lg-12">
          <label>Reject Reason</label>
          <select v-model="ddlRejectReason" class="form-control pro-edt-select form-control-primary">
            <option v-for="item in ddlRejectReasonList" v-bind:value="item.OPTvalue.trim()">
              {{ item.OPTvalue.trim() }}
            </option>
          </select>
        </div>
        <div class="col-lg-12">
          <label>Rejected Date</label>
          <div class="date">
            <el-date-picker v-model="inputRejectDate" format="dd/MM/yyyy" value-format="dd/MM/yyyy" type="date" placeholder="Pick a date"></el-date-picker>
          </div>
        </div>
      </div>
      <div class="row custom-modal-footer">
        <div class="col-lg-12 custom-modal-footer">
          <div class="col-lg-12">
            <button v-on:click="openChangeStatusConfirmModel()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="changeStatusConfirm"
      size="sm"
      title="Confirm Student Change Status"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="changeStatusConfirmShowModal"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12 divConfirmChangeStatusMsg">This action will clear assigned class, Confirm ?</div>
        <div class="col-lg-12">
          <button v-on:click="ChangeStatus()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="inviteParentConfirm"
      size="sm"
      title="Confirm To Invite Parent"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="inviteParentConfirmShowModal"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12 divConfirmChangeStatusMsg">This action will sent Email to selected Email Address to allow parent register, Confirm ?</div>
        <div class="col-lg-12">
          <button v-on:click="InviteParent()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="voidlevelModal" size="sm" title="Void Academic Year Level" ok-only ok-variant="secondary" ok-title="Cancel" ref="voidlevelModal" hide-footer>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Reason</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <input type="text" class="form-control form__input" v-model="currentVoidStudentCourseReason" />
        </div>
        <div class="col-lg-12">
          <button v-on:click="voidStudentLevel()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <!--alexis-->
    <b-modal id="openEditLevelModal" size="sm" title="Edit Level" ok-only ok-variant="secondary" ok-title="Cancel" ref="editlevelModal" hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <label>* Level</label>

          <select
            v-model="ddlStudentLevel"
            class="form-control pro-edt-select form-control-primary"
            :class="{ requiredFields: $v.ddlStudentLevel.$error }"
            @change="bindClassLevel($event)"
          >
            <option v-for="item in ddlStudentLevelList" v-bind:value="item.PK_Course_ID.trim()">
              {{ item.CRS_Course_Name.trim() }}
            </option>
          </select>
          <div class="requiredFieldsMsg" v-if="$v.ddlStudentLevel.$error">Level required</div>
        </div>

        <div class="col-lg-12">
          <label>* Class</label>
          <select v-model="ddlStudentClass" class="form-control pro-edt-select form-control-primary" :class="{ requiredFields: $v.ddlStudentClass.$error }">
            <option v-for="item in ddlStudentClassList" v-bind:value="item.PK_Class_ID.trim()">
              {{ item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim() }}
            </option>
          </select>
          <div class="requiredFieldsMsg" v-if="$v.ddlStudentClass.$error">Class required</div>
        </div>
        <div class="col-lg-12">
          <label>* Level Start Date</label>
          <div class="date">
            <el-date-picker
              v-model="inputStudentClassStartDate"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a date"
              :picker-options="{ disabledDate: time => disabledEndDate(time, '') }"
            ></el-date-picker>
          </div>
        </div>

        <div class="col-lg-12">&nbsp;</div>

        <div class="col-lg-12">
          <K2Confirm title="Are you sure you want to update the level?" theme="2" @confirm="updateStudentLevel()" no-children="true" label="Confirm" />
        </div>
      </div>
    </b-modal>

    <b-modal
      id="StudentDocumentManager"
      class="studentPageBModal"
      title="Document Manager"
      ok-variant="secondary"
      ok-title="Cancel"
      hide-footer
      hide-header
      ok-only
      ref="studentDocumentManagerShowModal"
      v-model="studentDocumentManagerShowModal"
    >
      <div class="row sdmHeader">
        <div class="col-lg-3 col-md-3 sdmHeaderDiv">Document Manager</div>
        <div class="col-lg-9 col-md-9 sdmHeaderDiv" style="text-align: right">
          <button v-if="studentDocumentMove('MULTIPLE')" class="btn btn-secondary btnSdmHeaderDiv" @click="viewStudentFile()">
            <i class="material-icons">visibility</i> View
          </button>
          <button v-if="studentDocumentMove('MULTIPLE')" class="btn btn-secondary btnSdmHeaderDiv" @click="moveFileShowModel()">
            <i class="material-icons">open_with</i> Move
          </button>
          <button v-if="studentDocumentMove('MULTIPLE')" class="btn btn-secondary btnSdmHeaderDiv" @click="deleteFileShowModel()">
            <i class="material-icons">delete</i> Delete
          </button>
          <button v-if="studentDocumentMove('ONE')" class="btn btn-secondary btnSdmHeaderDiv" @click="studentFileDownload()">
            <i class="material-icons">cloud_download</i> Download
          </button>
          <button v-if="studentDocumentCurrentFolder.length > 0" @click="uploadFileShowModel()" class="btn btn-secondary btnSdmHeaderDiv">
            <i class="material-icons">cloud_upload</i> Upload
          </button>
        </div>
      </div>
      <div class="row sdmBody">
        <div class="col-lg-4 col-md-4">
          <div class="sdmBodySC" style="margin-top: 10px">Select Directory</div>
          <div class="sdmBodySC cursorPointer" @click="DMSpanClick('SC')">
            Student Doc
            <span class="sdmBodySCSpan">
              <img v-if="!sdmBodySCSpanSCActive" src="../../assets/Vector22.png" />
              <img v-if="sdmBodySCSpanSCActive" src="../../assets/Vector22-1.png" />
            </span>
          </div>
          <b-collapse v-model="collapseSD" class="mt-2">
            <b-card>
              <div class="sdmFolder cursorPointer" @click="setCurrentFolder('ROOT', 'ROOT', 'Student Doc', 'Root')">
                <i class="material-icons">folder</i> Root
              </div>
              <div class="sdmFolder" v-for="folderItem in sdmCurrentFolder" v-if="folderItem.SFRParID === 'DOCUMENT_FOLDER'">
                <i
                  class="material-icons cursorPointer"
                  v-on:click="setCurrentFolder(folderItem.SF_File_Description, folderItem.PK_SF_ID, 'Student Doc', 'Root')"
                  >folder</i
                >
                {{ folderItem.SF_File_Description }}
              </div>
              <div class="sdmFolder">
                <button @click="createNewFolderShowModel('Student Doc')" class="btn btn-secondary btnCreateNewFolderShowModel">New Folder</button>
              </div>
            </b-card>
          </b-collapse>
          <div v-if="immunizationRecordsUpload" class="sdmBodySC">
            Immunization Records
            <span class="sdmBodySCSpan" @click="DMSpanClick('IR')">
              <img v-if="!sdmBodySCSpanIRActive" src="../../assets/Vector22.png" />
              <img v-if="sdmBodySCSpanIRActive" src="../../assets/Vector22-1.png" />
            </span>
          </div>
          <b-collapse v-model="collapseIR" class="mt-2">
            <b-card>
              <div class="sdmFolder">
                <i class="material-icons cursorPointer" @click="setCurrentFolder('ROOT', 'ROOT', 'Immunization Records', 'Root')">folder</i>
                Root
              </div>
              <div class="sdmFolder" v-for="folderItem in sdmCurrentFolder" v-if="folderItem.SFRParID === 'IMMNUIZATION_FOLDER'">
                <i
                  class="material-icons cursorPointer"
                  v-on:click="setCurrentFolder(folderItem.SF_File_Description, folderItem.PK_SF_ID, 'Immunization Records', 'Root')"
                  >folder</i
                >
                {{ folderItem.SF_File_Description }}
              </div>
              <div class="sdmFolder">
                <button @click="createNewFolderShowModel('Immunization Records')" class="btn btn-secondary btnCreateNewFolderShowModel">New Folder</button>
              </div>
            </b-card>
          </b-collapse>
          <div class="sdmBodySC">
            All About Me
            <span class="sdmBodySCSpan" @click="DMSpanClick('AAM')">
              <img v-if="!sdmBodySCSpanAAMActive" src="../../assets/Vector22.png" />
              <img v-if="sdmBodySCSpanAAMActive" src="../../assets/Vector22-1.png" />
            </span>
          </div>
          <b-collapse v-model="collapseAAM" class="mt-2">
            <b-card>
              <div class="sdmFolder">
                <i class="material-icons cursorPointer" @click="setCurrentFolder('ROOT', 'ROOT', 'All About Me', 'Root')">folder</i> Root
              </div>
              <div class="sdmFolder" v-for="folderItem in sdmCurrentFolder" v-if="folderItem.SFRParID === 'ALLABOUTME_FOLDER'">
                <i
                  class="material-icons cursorPointer"
                  v-on:click="setCurrentFolder(folderItem.SF_File_Description, folderItem.PK_SF_ID, 'All About Me', 'Root')"
                  >folder</i
                >
                {{ folderItem.SF_File_Description }}
              </div>
              <div class="sdmFolder">
                <button @click="createNewFolderShowModel('All About Me')" class="btn btn-secondary btnCreateNewFolderShowModel">New Folder</button>
              </div>
            </b-card>
          </b-collapse>
        </div>
        <div class="col-lg-8 col-md-8" style="background: #e5e5e5">
          <div class="row" style="margin-top: 10px">
            <div v-if="studentDocumentCurrentFolder.length > 0" class="col-lg-12" style="margin-bottom: 10px">
              <div v-if="studentDocumentCurrentFolder[0].folderName !== 'ROOT'">
                <button
                  @click="createNewFolderShowModel(studentDocumentCurrentFolder[0].folderName)"
                  style="width: auto"
                  class="btn btn-secondary btnCreateNewFolderShowModel"
                >
                  New Folder
                </button>
                <button
                  @click="deleteFolderShowModel(studentDocumentCurrentFolder[0].folderID)"
                  style="width: auto; margin-left: 10px"
                  class="btn btn-secondary btnCreateNewFolderShowModel"
                >
                  Delete Folder
                </button>
              </div>
              <div style="font-weight: bold; font-weight: bold">
                {{ studentDocumentCurrentFolder[0].folderType }} ->
                {{ studentDocumentCurrentFolder[0].folderName }}
              </div>
            </div>
            <div class="col-lg-12" v-if="studentDocumentFolder.length > 0">
              <div class="row" style="background: #f8faff; margin: 5px; border: 1px solid #c8e3ff; border-radius: 5px; padding: 5px">
                <div v-for="item in studentDocumentFolder" class="col-lg-3" style="margin-bottom: 10px; text-align: center; padding: 10px">
                  <div
                    v-on:click="setCurrentFolder(item.SF_File_Description, item.PK_SF_ID, studentDocumentCurrentFolder[0].folderType, 'Inner')"
                    style="background: #e4ebf7; border-radius: 6px; padding: 10px 5px"
                  >
                    <img style="width: 50px; cursor: pointer" src="../../assets/Vector26.png" />
                    <span style="display: block">{{ item.SF_File_Description }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-list_image col-lg-12" v-if="studentDocumentFile.length < 1">
              <strong>No File Found...</strong>
              <img src="../../assets/notfound.png" />
            </div>
            <div class="col-lg-12 row" v-if="studentDocumentFile.length > 0">
              <div v-for="item in studentDocumentFile" class="col-lg-4" style="margin-bottom: 10px">
                <div class="sdmBodyEachFileDiv" :class="{ sdmBodySelectedFile: item.fileSelected === true }">
                  <div class="lds-ellipsis" v-if="!item.fileTypeExt">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div v-if="item.fileTypeExt" v-on:click="clickSDMFile(item.PK_SF_ID)" style="cursor: pointer">
                    <img
                      slot="img"
                      class="card-img-top d-block img-fluid w-100"
                      style="width: 100%; height: 200px; overflow: auto"
                      v-if="item.fileTypeExt === 'IMAGE'"
                      :src="item.fullFileString"
                    />
                    <div style="width: 100%; height: 100%; overflow: auto; padding: 20px" v-show="item.fileTypeExt === 'PDF'">
                      <pdf class="pdf preview" :src="item.fullFileString" style="max-width: 100%"></pdf>
                    </div>

                    <div v-if="item.fileTypeExt === 'ZIP'">
                      <img style="width: 100%; height: 200px; overflow: auto" src="../../assets/zip.png" />
                    </div>

                    <LazyVideo
                      slot="img"
                      class="card-img-top d-block img-fluid"
                      v-if="item.fileTypeExt === 'VIDEO'"
                      style="width: 100%; height: 200px; overflow: auto"
                      :src="item.fullFileString"
                    />
                  </div>
                  <div class="sdmBodyEachFileDivDesc">
                    {{ item.SF_File_Description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row custom-modal-footer sdmFooter">
        <div class="col-lg-6">
          <button @click="hideModal()" class="btn btn-secondary float-left">Close</button>
        </div>
        <div class="col-lg-6"></div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerNewFolder"
      class="studentPageBModal"
      title="New Folder"
      ok-variant="secondary"
      ok-title="Cancel"
      hide-footer
      ok-only
      ref="studentDocumentManagerNewFolderShowModel"
      v-model="studentDocumentManagerNewFolderShowModel"
    >
      <div class="row">
        <div class="col-lg-12">
          <label>-New Folder For {{ newFolderType }}-</label>
          <label>Folder Name</label>
          <input type="text" class="form-control" v-model="newFolder" />
        </div>
      </div>
      <div class="row custom-modal-footer">
        <div class="col-lg-12">
          <button v-on:click="createNewFolder()" class="btn btn-primary float-right btnFamilyIDSearch">Save</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerNewFile"
      class="studentPageBModal"
      title="New File"
      ok-only
      hide-footer
      ok-variant="secondary"
      ok-title="Cancel"
      ref="StudentDocumentManagerNewFileShowModal"
      v-model="StudentDocumentManagerNewFileShowModal"
    >
      <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="upload-box">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label><i class="material-icons">attachment</i> Select File</label>
            <div class="file-upload-wrapper" :data-text="uploadFileName">
              <input
                name="file-upload-field[]"
                type="file"
                class="file-upload-field"
                value=""
                ref="studentDocumentManagerNewFileUploadFile"
                @change="uploadFileNameChange"
                multiple
              />
            </div>
          </div>

          <!--disable upload new file description
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label><i class="material-icons">format_align_left</i> File Description</label>
                        <input type="text" class="form-control form__input" v-model="uploadFileDescription">
                    </div>-->

          <div class="col-lg-12" v-if="uploadisLoading">
            <div class="bar"></div>
          </div>
        </div>
      </div>
      <div class="row custom-modal-footer sdmFooter" style="margin-top: 20px">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <button class="btn btn-primary float-right" v-on:click="studentDocumentManagerUploadFile()">Upload</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerMoveFile"
      class="studentPageBModal"
      title="Move File"
      ok-only
      hide-footer
      ok-variant="secondary"
      ok-title="Cancel"
      ref="StudentDocumentManagerMoveFileShowModal"
      v-model="StudentDocumentManagerMoveFileShowModal"
    >
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label style="display: inline !important">Move To Folder</label>
          <span style="margin-left: 20px" v-if="moveFileSelectedFolder.length > 0"> {{ moveFileSelectedFolder[0].FolderName }}</span>
        </div>
        <hr style="width: 100%; margin: 0px" />
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" style="border-right: 1px solid #e4ebf7; padding: 20px">
          <div v-for="item in moveFileSelectedFolderTypeList" @click="selectFolderType(item, 'Root')" class="row" style="margin-bottom: 20px; cursor: pointer">
            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"><i class="material-icons">folder</i> {{ item }}</div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="text-align: right">
              <i class="material-icons">forward</i>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div style="margin-top: 20px; text-align: right" v-if="moveFilePreviousSelectedFolder !== ''">
            <button class="btn btn-primary" v-on:click="selectFolderType(moveFilePreviousSelectedFolder, 'Inner')">
              <i class="material-icons">fast_rewind</i> Back
            </button>
          </div>
          <div class="empty-list_image col-lg-12" v-if="moveFileSelectedFolderList.length < 1">
            <strong>No Folder Found...</strong>
            <img src="../../assets/notfound.png" />
          </div>
          <div v-if="moveFileSelectedFolderList.length > 0">
            <div v-for="item in moveFileSelectedFolderList" class="row" style="margin-top: 20px">
              <div
                class="col-lg-10 col-md-10 col-sm-10 col-xs-10"
                @click="selectMoveFolder(item)"
                :class="selectdMoveFolderActive(item) ? 'selectedFolder' : ''"
                style="cursor: pointer"
              >
                <i class="material-icons">folder</i> {{ item.FolderName }}
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="text-align: right">
                <i
                  v-if="item.FolderID !== 'DOCUMENT_FOLDER' && item.FolderID !== 'IMMNUIZATION_FOLDER' && item.FolderID !== 'ALLABOUTME_FOLDER'"
                  @click="selectFolderType(item.FolderID, 'Inner', item.SFRParID)"
                  style="cursor: pointer"
                  class="material-icons"
                  >fast_forward</i
                >
              </div>
            </div>
          </div>
        </div>
        <hr style="width: 100%; margin: 0px" />
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div style="margin-top: 20px">
            <button class="btn btn-primary float-right" v-on:click="updateStudentDocument('MOVEFILE')">Move</button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerDeleteFileConfirm"
      size="sm"
      title="Delete File"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="studentDocumentManagerDeleteFileConfirm"
      v-model="studentDocumentManagerDeleteFileConfirm"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12 divConfirmChangeStatusMsg">Confirm ?</div>
        <div class="col-lg-12">
          <button v-on:click="updateStudentDocument('DELETE')" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerDeleteFolderConfirm"
      size="sm"
      title="Delete File"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="studentDocumentManagerDeleteFolderConfirm"
      v-model="studentDocumentManagerDeleteFolderConfirm"
      hide-footer
    >
      <div class="row" v-if="studentDocumentCurrentFolder.length > 0">
        <div class="col-lg-12 divConfirmChangeStatusMsg">
          Confirm too delete {{ studentDocumentCurrentFolder[0].folderType }} -> {{ studentDocumentCurrentFolder[0].folderName }} ?
        </div>
        <div class="col-lg-12">
          <button v-on:click="updateStudentDocumentFolder('DELETE')" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="StudentDocumentManagerViewFiles"
      size="sm"
      title="View Files"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="studentDocumentManagerViewFiles"
      v-model="studentDocumentManagerViewFiles"
      hide-footer
    >
      <div>
        <b-carousel style="text-shadow: 1px 1px 2px #333" :controls="viewStudentFileFilter().length > 1" indicators background="#ababab" :interval="0">
          <div>
            <b-carousel-slide v-for="item of viewStudentFileFilter()" style="text-align: center">
              <img
                slot="img"
                class="card-img-top d-block img-fluid w-100"
                style="max-width: 500px"
                v-if="item.fileTypeExt === 'IMAGE'"
                :src="item.fullFileString"
              />

              <pdf
                slot="img"
                class="nonM card-img-top d-block img-fluid"
                style="display: block; width: 100%"
                v-if="item.fileTypeExt === 'PDF'"
                v-for="i in item.numPages"
                :key="i"
                :src="item.pageOfSrc"
                :page="i"
              >
              </pdf>

              <img
                slot="img"
                class="card-img-top d-block img-fluid w-100"
                style="max-width: 500px"
                v-if="item.fileTypeExt === 'ZIP'"
                src="../../assets/zip.png"
              />

              <LazyVideo slot="img" class="card-img-top img-fluid" v-if="item.fileTypeExt === 'VIDEO'" style="max-width: 500px" :src="item.fullFileString" />
            </b-carousel-slide>
          </div>
        </b-carousel>
      </div>
    </b-modal>
    <b-modal
      id="resetEmailPassword"
      size="sm"
      title="Reset Email Password"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="resetEmailPassword"
      v-model="resetEmailPassword"
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">
          <el-checkbox v-model="resetEmailPasswordManualPasswordCheckBox" label="Manual Create Password" border></el-checkbox>
        </div>
        <div class="col-lg-12">
          <hr style="width: 100%" />
        </div>
        <div class="col-lg-12" v-if="!resetEmailPasswordManualPasswordCheckBox">
          <label>Auto Generate Password</label>
        </div>
        <div class="col-lg-12" v-if="resetEmailPasswordManualPasswordCheckBox">
          <label>Password</label>
          <input type="text" class="form-control" v-model="resetEmailPasswordManualPassword" />
          <label>Password Length Must 8 and above</label>
        </div>
        <div class="col-lg-12">
          <el-button v-if="inputStudentSchoolEmail" type="primary" round v-on:click="studentEmailAction('Reset')">Reset Password </el-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="voidMealsModal" size="sm" title="Meal Cancellation" ok-only ok-variant="secondary" ok-title="Cancel" ref="voidMealsModal" hide-footer>
      <div class="row" v-if="currentVoidStudentMealStatus == 'Active'">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Cancellation Date</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <el-date-picker
            v-model="currentVoidStudentMealEndDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select Cancellation Date"
          ></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Remarks</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <input type="text" class="form-control form__input" v-model="currentVoidStudentMealRemarks" />
        </div>
        <div class="col-lg-12">
          <button v-on:click="voidStudentMeals()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="addMealsModal" size="sm" title="Add School Meals" ok-only ok-variant="secondary" ok-title="Cancel" ref="addMealsModal" hide-footer>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">School Meal Period</div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <select @change="setSchoolMealPeriod()" v-model="newSchoolMeal.PK_Course_Fee_Detail_ID" class="form-control pro-edt-select form-control-primary">
            <option v-for="option in ddlSchoolMeal" v-bind:value="option.PK_Course_Fee_Detail_ID">
              {{ option.PPD_Payee_Name }}
            </option>
          </select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <el-checkbox label="Overwrite start date" v-model="newSchoolMeal.isStartDateOverwrite" border></el-checkbox>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="newSchoolMeal.isStartDateOverwrite">
          Overwrite Start Date
          <el-date-picker
            type="date"
            v-if="newSchoolMeal.startDate != undefined"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select start date"
            v-model="newSchoolMeal.overwriteStartDate"
            :picker-options="newMealTermDateRangeOptions"
          ></el-date-picker>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-else>
          Start Date
          <el-date-picker
            v-model="newSchoolMeal.startDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select start date"
            readonly
          ></el-date-picker>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          End Date
          <el-date-picker
            v-model="newSchoolMeal.endDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select end date"
            readonly
          ></el-date-picker>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Remarks</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <select v-model="newSchoolMeal.remarks" class="form-control pro-edt-select form-control-primary">
            <option value="School Meal - Normal">School Meal - Normal</option>
            <option value="School Meal - Vegetarian">School Meal - Vegetarian</option>
            <option value="School Meal - Special">School Meal - Special</option>
            <option value="Packed Lunch">Packed Lunch</option>
          </select>
        </div>
        <div class="col-lg-12">
          <button v-on:click="addStudentMeals()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="voidAddLangModal"
      size="sm"
      title="Additional Language Cancellation"
      ok-only
      ok-variant="secondary"
      ok-title="Cancel"
      ref="voidAddLangModal"
      hide-footer
    >
      <div class="row" v-if="currentVoidAddLangStatus == 'Active'">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Cancellation Date</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <el-date-picker
            v-model="currentVoidAddLangEndDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select Cancellation Date"
          ></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Remarks</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <input type="text" class="form-control form__input" v-model="currentVoidAddLangRemarks" />
        </div>
        <div class="col-lg-12">
          <button v-on:click="voidAddLang()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <b-modal id="addAddLangModal" size="sm" title="Add Additional Language" ok-only ok-variant="secondary" ok-title="Cancel" ref="addAddLangModal" hide-footer>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Additional Language</div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <select @change="setAddLangPeriod()" v-model="newAddLang.PK_Course_Fee_Detail_ID" class="form-control pro-edt-select form-control-primary">
            <option v-for="option in ddlAddLang" v-bind:value="option.PK_Course_Fee_Detail_ID">
              {{ option.PPD_Payee_Name }}
            </option>
          </select>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <el-checkbox label="Overwrite start date" v-model="newAddLang.isStartDateOverwrite" border></el-checkbox>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="newAddLang.isStartDateOverwrite">
          Overwrite Start Date
          <el-date-picker
            type="date"
            v-if="newAddLang.startDate != undefined"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select start date"
            v-model="newAddLang.overwriteStartDate"
            :picker-options="newAddLangTermDateRangeOptions"
          ></el-date-picker>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-else>
          Start Date
          <el-date-picker
            v-model="newAddLang.startDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select start date"
            readonly
          ></el-date-picker>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          End Date
          <el-date-picker
            v-model="newAddLang.endDate"
            type="date"
            format="dd/MM/yyyy"
            class="inputDeferDate"
            value-format="dd/MM/yyyy"
            placeholder="Select end date"
            readonly
          ></el-date-picker>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">Remarks</div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <input type="text" class="form-control form__input" v-model="newAddLang.remarks" />
        </div>
        <div class="col-lg-12">
          <button v-on:click="addAddLang()" class="btn btn-primary waves-effect waves-light m-r-10">Confirm</button>
        </div>
      </div>
    </b-modal>
    <v-tour name="StudentPageVueTourName" :steps="studentPageVueTour" :options="studentPageVueTourOptions" :callbacks="studentPageVueTourCallBacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 2">
              <div slot="actions">
                <button class="v-step__button" @click="tour.stop">Skip</button>
                <button class="v-step__button" @click="tour.previousStep">Previous</button>
                <button class="v-step__button" @click="studentPageVueTourParentTab(tour, 'Next')">Next</button>
              </div>
            </template>
            <template v-if="tour.currentStep === 4">
              <div slot="actions">
                <button class="v-step__button" @click="tour.stop">Skip tour</button>
                <button class="v-step__button" @click="studentPageVueTourParentTab(tour, 'Previous')">Previous</button>
                <button class="v-step__button" @click="tour.nextStep">Next</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <v-tour
      name="StudentPageUpdateLevelClassVueTourName"
      :steps="studentPageUpdateLevelClassVueTour"
      :options="studentPageUpdateLevelClassVueTourOptions"
      :callbacks="studentPageUpdateLevelClassVueTourCallBacks"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button class="v-step__button" @click="tour.stop">Skip</button>
                <button class="v-step__button" @click="studentPageUpdateLevelClassVueTourCallBacksPreviousPage()">Previous</button>
                <button class="v-step__button" @click="tour.nextStep">Next</button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import ProfileImg from '../../assets/boy.png'
import { required, requiredIf, requiredUnless, email } from 'vuelidate/lib/validators'
import promotionComponent from '../../components/Promotion_Component'
import Cookies from 'js-cookie'
import moment from 'moment'
import GlobalFn from '../../components/GlobalFn'
import VueTour from 'vue-tour'
import Vue from 'vue'
import pdf from 'vue-pdf'
import VueLazyLoadVideo from 'vue-lazyload-video'
import K2Confirm from '../../uiComponents/k2Confirm/k2Confirm'
import { getFormatDate } from '@/helper/utily'
import { getUserID } from '@/helper/util_custom'
import Academica from '../academica/Academica'
import StudentWithdrawForm from '@/components/StudentWithdrawForm.vue'
import { studentValidations } from '@/pages/Student/validations/data'

Vue.use(VueLazyLoadVideo)
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)
const API_HOST = process.env.VUE_APP_ROOT_API

export default {
  name: 'Student',
  async created() {
    this.imgStudentProfile = ProfileImg
    this.divParent = true
    this.finShowHide = true
    this.birthcertShowHide = true
    this.icShowHide = true
    this.stuCorAddCopy = false
    this.resBilAddCopy = false
    await this.BindCountryList()
    await this.BindStudentDropdown()
    //await this.BindStudentLevel();
    await this.BindAcademicYear()
    await this.BindStudentIntakeYear()
    await this.BindTransferSchool()
    await this.checkSchoolIsLocalOrInt()
  },
  async mounted() {
    window.debug = this
    await this.LoadStudentParentInfo()
    await this.onChangeNationalityBirthPlace()

    if (this.hubSpotID) {
      await this.getStudentHubSpotDetials()
    }

    if (this.$route.query.tour === 'UpdateLevelClass') {
      this.studentPageVueUpdateLevelClassTourStart()
    }

    if (this.$route.query.generalsearch === 'editclass') {
      this.activeTab = 'Level'
    }

    window.addEventListener('load', () => {
      if (this.$route.query.tour === 'YES') {
        this.studentPageVueTourStart()
      }
    })
  },
  data() {
    return {
      studentData: {}, // Darren: hold all the data from getStudentWithPendingCourse
      countryList: [],
      ddlStudentAdditionalLanguageList: [],
      ddlStudentMealPreferencesList: [],
      ddlStudentMembershipList: [],
      ddlStudentResidencyStatusList: [],
      ddlStudentPayerList: [],
      ddlStudentClassList: [],
      ddlStudentLevelList: [],
      ddlFatherIdentificationTypeList: [],
      ddlMotherIdentificationTypeList: [],
      ddlParentModeList: [],
      levelList: [],
      academicYearList: [],
      studentIntakeYearList: [],
      ddlChangeStatusToList: [],
      levelList_Level: [],
      academicYearList_Level: [],
      studentIntakeYearList_Level: [],
      arrayStudentIDLevelComponent: [],
      strClassIDLevelComponent: '',
      transferSchoolList: [],
      transferSchoolCourseList: [],
      studentFileListInt: [],
      ddlMaritalStatusList: [],
      ddlRaceList: [],
      ddlddlStudentFoodAllergiesFoodList: [],
      ddlStudentEnrolledCenterTypeList: [],

      inputStudentDateOfBirth: '',
      inputStudentClassStartDate: '',

      inputFatherDateofBirth: '',
      inputStudentIdentificationExpiryDate: '',
      inputFirstCommencementDate: '',
      inputFirstBillingNotification: '',
      inputFatherIdentificationNoExpiryDate: '',
      inputMotherDateofBirth: '',
      inputMotherIdentificationNoExpiryDate: '',
      ddlStudentGender: '',
      inputStudentFirstName: '',
      inputStudentMiddleName: '',
      inputStudentLastName: '',
      inputStudentPreferredName: '',
      ddlStudentNationality: '',
      ddlStudentBirthPlace: '',
      inputStudentIdentificationNo: '',
      inputStudent1stEmergencyContactNo: '',
      inputStudent2ndEmergencyContactNo: '',
      inputStudentFirstLanguageSpoken: '',
      inputSecondLanguageSpoken: '',
      ddlStudentSelectLevel: '',
      ddlStudentFirstAcademicYear: '',
      inputStudentID: '',
      ddlStudentIntakeYear: '',
      inputStudentAddress1: '',
      inputStudentAddress2: '',
      inputStudentAddress3: '',
      inputStudentCity: '',
      inputStudentPostalCode: '',
      inputStudentCorrespondanceAddress1: '',
      inputStudentCorrespondanceAddress2: '',
      inputStudentCorrespondanceAddress3: '',
      inputStudentCorrespondanceCity: '',
      ddlStudentAddressCorrespondanceCountry: '',
      inputStudentCorrespondancePostalCode: '',
      inputStudentMobileNo: '',
      inputStudentOfficeTelNo: '',
      inputStudentEmail: '',
      taMajorAilmentsList: '',
      inputNameofFamilyDoctor: '',
      inputClinicAddress: '',
      inputClinicPhoneNo: '',
      inputFamilyID: '',
      divFamilySearch: '',
      divEditParentLink: '',
      inputFamilyParentID: '',
      inputFatherFirstName: '',
      inputFatherMiddleName: '',
      inputFatherLastName: '',
      inputFatherOccupation: '',
      inputFatherIdentificationNo: '',
      inputFatherMobileNo: '',
      inputFatherEmail: '',
      inputMotherFirstName: '',
      inputMotherMiddleName: '',
      inputMotherLastName: '',
      inputMotherOccupation: '',
      inputMotherIdentificationNo: '',
      inputMotherMobileNo: '',
      inputMotherEmail: '',
      ddlStudentAddressCountry: '',
      ddlStudentAdditionalLanguage: '',
      ddlStudentMealPreferences: '',
      ddlStudentMembership: '',
      ddlStudentResidencyStatus: '',
      ddlStudentPayer: '',

      ddlStudentClass: '',
      ddlStudentLevel: '',

      ddlFatherIdentificationType: '',
      ddlMotherIdentificationType: '',
      ddlParentMode: '',
      inputStudentBirthCertificate: '',
      inputStudentIC: '',
      inputStudentPassport: '',
      inputStudentPassportExpiryDate: '',
      ddlChangeStatusTo: '',
      selectedFile: null,
      ddlStudentSelectLevel_Level: '',
      ddlStudentFirstAcademicYear_Level: '',
      ddlStudentIntakeYear_Level: '',
      ddlCopyAddToStuCorAdd: '',
      editModeDisable: true,
      editCenterTypeDisable: true,
      lblCreateOrEdit: '',
      lblStudentID: '',
      lblParentID: '',
      lblMotherNameDuplicated: '',
      lblFatherNameDuplicated: '',
      parentAreaDiv: '',
      lblStudentIndexNo: '',
      lblCurrentStatus: '',
      imgStudentProfile: '',
      finShowHide: '',
      birthcertShowHide: '',
      icShowHide: '',
      passportShowHide: '',
      stuCorAddCopy: '',
      stuCorEmailAddCopy: '',
      resBilAddCopy: '',
      siblingTab: '',
      changeStatusAction: '',
      levelTab: '',
      mealsTab: true,
      addLangTab: true,
      ddlTransferSchool: '',
      ddlTransferSchoolCourse: '',
      inputTransferSchoolRemark: '',
      inputTransferSchoolEffDate: '',
      inputStudentFileDescription: '',
      immunizationRecordsUpload: '',
      inputImmunizationRecordsDescription: '',
      inputAllAboutMeDescription: '',
      ddlFatherWorking: 'No',
      divFatherCompany: '',
      ddlFatherMaritalStatus: '',
      ddlFatherRace: '',
      inputFatherCompanyName: '',
      inputFatherCompanyAddresseeName: '',
      inputFatherCompanyAddress1: '',
      inputFatherCompanyAddress2: '',
      inputFatherCompanyAddress3: '',
      inputFatherCompanyCity: '',
      ddlFatherCompanyCountry: '',
      inputFatherCompanyPostalCode: '',
      inputFatherCompanyEmail: '',
      divMotherCompany: '',
      ddlMotherRace: '',
      ddlMotherMaritalStatus: '',
      ddlMotherWorking: 'No',
      inputMotherCompanyName: '',
      inputMotherCompanyAddresseeName: '',
      inputMotherCompanyAddress1: '',
      inputMotherCompanyAddress2: '',
      inputMotherCompanyAddress3: '',
      inputMotherCompanyCity: '',
      ddlMotherCompanyCountry: '',
      inputMotherCompanyPostalCode: '',
      inputMotherCompanyEmail: '',
      inputFatherWorkingCommencementDate: '',
      inputMotherWorkingCommencementDate: '',
      inputStudent1stEmergencyContact: '',
      inputStudent1stEmergencyContactRelation: '',
      inputStudent2ndEmergencyContact: '',
      inputStudent2ndEmergencyContactRelation: '',
      inputStudentDietaryRequirement: '',
      inputStudentMedicationAllergiesMedication: '',
      inputStudentMedicationAllergiesRemarks: '',
      ddlStudentFoodAllergiesFood: '',
      inputStudentFoodAllergiesRemarks: '',
      isLocalSchool: '',
      isIntSchool: '',
      isIntPreSchool: '',
      ddlStudentRace: '',
      disFatherCompany: true,
      disMotherCompany: true,
      disableIC: true,
      ddlStudentEnrolledinOtherCenter: 'No',
      inputStudentEnrolledCenterName: '',
      divEnrolledinOtherCenterShow: '',
      ddlStudentEnrolledCenterType: '',
      hubSpotID: '',
      hubspotActiveTab: 'NOTE',
      studentHubSpotAll: [],
      hubspotNoteTabDetials: false,
      hubspotTaskTabDetials: false,
      hubspotEmailTabDetials: false,
      hubspotCallTabDetials: false,
      hubspotMeetingTabDetials: false,
      accordionHubSpotEmail: '1',
      ddlWithdrawGraduation: '',
      inputWithdrawalDate: '',
      ddlMainReason: '',
      ddlReason1: '',
      ddlReason2: '',
      ddlReason3: '',
      ddlInternationalSchool: '',
      WithGradReason1: '',
      ddlStudentCourseID: '',
      ddlMealsStudentCourseID: '',
      ddlAddLangStudentCourseID: '',
      ddlSchoolMeal: [],
      newSchoolMeal: [],
      currentVoidStudentMealRemarks: '',
      currentVoidStudentMealEndDate: '',
      currentVoidStudentMealStartDate: '',
      currentVoidStudentMealStatus: '',
      ddlAddLang: [],
      newAddLang: [],
      currentVoidAddLangRemarks: '',
      currentVoidAddLangEndDate: '',
      currentVoidAddLangStartDate: '',
      currentVoidAddLangStatus: '',
      //End withdrawal and graduation

      copyAddressList: ['Manually Input', "Student's Local Residential Address"],

      activeTab: 'Student',
      siblingList: [],
      siblingListAll: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'Regst_date_convert',
          label: 'Regisration Date',
        },
        {
          prop: 'SiblingLevelName',
          label: 'Level',
        },
        {
          prop: 'Status',
          label: 'Status',
        },
        {
          prop: 'SCH_Name',
          label: 'Center Name',
        },
      ],
      actionCol_Sibling: {
        label: 'Edit',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              if (row.School_ID === Cookies.get('schoolSession')) {
                window.location.replace('/student?id=' + row.Student_ID)
              } else {
                this.$notify.error({
                  title: 'Error',
                  message: "You are not authorize to edit this student's info",
                })
              }
            },
            label: 'Edit',
          },
        ],
      },

      familyIDList: [],
      familyIDListAll: [
        {
          prop: 'PAR_Family_Number',
          label: 'Family No',
        },
        {
          prop: 'Parent_FName',
          label: "Father's Name",
        },
        {
          prop: 'Parent_MName',
          label: "Mother's Name",
        },
        {
          prop: 'Parent_GName',
          label: "Guardian's Name",
        },
        {
          prop: 'StudentName',
          label: "Student's Name",
        },
      ],
      actionCol: {
        label: 'Select',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.inputFamilyID = row.PAR_Family_Number
              this.inputFamilyParentID = row.PAR_ID
              this.familyParentFatherContact = row.PAR_Father_Phone
              this.familyParentMotherContact = row.PAR_Mother_Phone

              if (row.PAR_Father_MiddleName) {
                this.familyParentFatherName = row.PAR_Father_FirstName + ' ' + row.PAR_Father_MiddleName + ' ' + row.PAR_Father_LastName
              } else {
                this.familyParentFatherName = row.PAR_Father_FirstName + ' ' + row.PAR_Father_LastName
              }

              if (row.PAR_Mother_MiddleName) {
                this.familyParentMotherName = row.PAR_Mother_FirstName + ' ' + row.PAR_Mother_MiddleName + ' ' + row.PAR_Mother_LastName
              } else {
                this.familyParentMotherName = row.PAR_Mother_FirstName + ' ' + row.PAR_Mother_LastName
              }

              //parents adrress info
              this.stuCorAddCopy = false
              this.ddlCopyAddToStuCorAdd = ''
              this.copyAddressList = this.copyAddressList.filter(item => item !== "Father's Company Address")
              this.copyAddressList = this.copyAddressList.filter(item => item !== "Mother's Company Address")
              this.copyAddressList = this.copyAddressList.filter(item => item !== "Father's Address")
              this.copyAddressList = this.copyAddressList.filter(item => item !== "Mother's Address")

              //father
              this.familyParentFatherCountry = row.PAR_Father_Loc_Country
              this.familyParentFatherPostalCode = row.PAR_Father_Loc_Postalcode
              this.familyParentFatherAddress1 = row.PAR_Father_Loc_Residence_No
              this.familyParentFatherAddress2 = row.PAR_Father_Loc_Address1
              this.familyParentFatherAddress3 = row.PAR_Father_Loc_Address2
              this.familyParentFatherCity = row.PAR_Father_Loc_City
              this.familyParentFatherEmail = row.PAR_Father_Email

              this.copyAddressList.push("Father's Address")
              //father

              //mother
              this.familyParentMotherCountry = row.PAR_Mother_Loc_Country
              this.familyParentMotherPostalCode = row.PAR_Mother_Loc_Postalcode
              this.familyParentMotherAddress1 = row.PAR_Mother_Loc_Residence_No
              this.familyParentMotherAddress2 = row.PAR_Mother_Loc_Address1
              this.familyParentMotherAddress3 = row.PAR_Mother_Loc_Address2
              this.familyParentMotherCity = row.PAR_Mother_Loc_City
              this.familyParentMotherEmail = row.PAR_Mother_Email

              this.copyAddressList.push("Mother's Address")
              //mother

              //father company
              if (row.PAR_Father_Working === 'Yes') {
                this.familyParentFatherCompanyCountry = row.PAR_Father_Country
                this.familyParentFatherCompanyPostalCode = row.PAR_Father_PostalCode
                this.familyParentFatherCompanyAddress1 = row.PAR_Father_Residence_No
                this.familyParentFatherCompanyAddress2 = row.PAR_Father_Address1
                this.familyParentFatherCompanyAddress3 = row.PAR_Father_Address2
                this.familyParentFatherCompanyCity = row.PAR_Father_City
                this.familyParentFatherCompanyEmail = row.PAR_FComp_Email

                this.copyAddressList.push("Father's Company Address")
              }
              //father company

              //mother company
              if (row.PAR_Mother_Working === 'Yes') {
                this.familyParentMotherCompanyCountry = row.PAR_Mother_Country
                this.familyParentMotherCompanyPostalCode = row.PAR_Mother_PostalCode
                this.familyParentMotherCompanyAddress1 = row.PAR_Mother_Residence_No
                this.familyParentMotherCompanyAddress2 = row.PAR_Mother_Address1
                this.familyParentMotherCompanyAddress3 = row.PAR_Mother_Address2
                this.familyParentMotherCompanyCity = row.PAR_Mother_City
                this.familyParentMotherCompanyEmail = row.PAR_MComp_Email

                this.copyAddressList.push("Mother's Company Address")
              }
              //mother company
              //parents adrress info

              this.divParent = false
              this.$refs.familyModalShowModal.hide()
              this.ReferSiblingReligionLanguage(row.PAR_ID)
            },
            label: 'Select',
          },
        ],
      },

      lvlLevelList_Level: [],
      lvlLevelList_LevelAll: [
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'SCH_Short_Name',
          label: 'School Name',
        },
        {
          prop: 'SMT_Code',
          label: 'Academic Year Code',
        },
        {
          prop: 'SCRS_From_Date_convert',
          label: 'Level Start Date',
        },
        {
          prop: 'SCRS_To_Date_convert',
          label: 'Level End Date',
        },
        {
          prop: 'classNameWithBatch',
          label: 'Class',
        },
        {
          prop: 'SCRS_Status',
          label: 'Status',
        },
      ],

      lvlMealsList_Meals: [],
      lvlMealsList_MealsAll: [
        {
          prop: 'SML_Description',
          label: 'Description',
        },
        {
          prop: 'SML_From_Date',
          label: 'Meal Start Date',
        },
        {
          prop: 'SML_To_Date',
          label: 'Meal End Date',
        },
        {
          prop: 'SML_Remarks',
          label: 'Remarks',
        },
        {
          prop: 'SML_Status',
          label: 'Status',
        },
      ],
      lvlAddLangList_AddLang: [],
      lvlAddLangList_AddLangAll: [
        {
          prop: 'SAL_Description',
          label: 'Description',
        },
        {
          prop: 'SAL_From_Date',
          label: 'Start Date',
        },
        {
          prop: 'SAL_To_Date',
          label: 'End Date',
        },
        {
          prop: 'SAL_Remarks',
          label: 'Remarks',
        },
        {
          prop: 'SAL_Status',
          label: 'Status',
        },
      ],
      actionCol_Level: {
        label: 'Class',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              window.location.replace(
                '/student-edit-class?courseid=' +
                  row.PK_Student_Course_ID +
                  '&id=' +
                  this.lblStudentID +
                  '&semid=' +
                  row.PK_Semester_ID +
                  '&subjectcourseid=' +
                  row.SCRS_FK_Course_ID,
              )
            },
            label: 'Class',
          },
        ],
      },

      selectedRow: null,

      studentFileList: [
        {
          prop: 'SF_File_Description',
          label: 'File Description',
        },
        {
          prop: 'SF_Upload_Date_convert',
          label: 'File Uploaded Date',
        },
      ],
      studentFileListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.deleteStudentDocument(row.PK_SF_ID)
            },
            label: 'Delete',
          },
        ],
      },

      medicationAllergiesListInt: [],
      medicationAllergiesList: [
        {
          prop: 'StAllItem',
          label: 'Medication',
        },
        {
          prop: 'StAllRemarks',
          label: 'Remarks',
        },
      ],
      medicationAllergiesListAcion: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.medicationAllergiesListInt.splice(this.medicationAllergiesListInt.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },

      foodAllergiesListInt: [],
      foodAllergiesList: [
        {
          prop: 'StAllItem',
          label: 'Food',
        },
        {
          prop: 'StAllRemarks',
          label: 'Remarks',
        },
      ],
      foodAllergiesListAcion: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.foodAllergiesListInt.splice(this.foodAllergiesListInt.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },
      withdrawShowModal: false,
      transferModal: false,
      uploadisLoading: false,
      studentDocumentModel: 'Select Your File',
      studentImmunizationModel: 'Select Your File',
      studentMeModel: 'Select Your File',
      uploadDocumentShowModal: false,
      uploadImmunizationRecordsShowModal: false,
      uploadAllAboutMeShowModal: false,
      tempPK_Semester_ID: '',
      tempPK_Course_ID: '',
      tempPK_Class_ID: '',

      //vue tour
      //https://github.com/pulsardev/vue-tour
      studentPageVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      studentPageVueTourCallBacks: {
        onPreviousStep: this.studentPageVueTourCallBacksPreviousSteps,
        onNextStep: this.studentPageVueTourCallBacksNextSteps,
      },
      studentPageVueTour: [
        //Student Tab
        {
          target: '#v-step-StudentSearchFamily',
          content: `<div class="studentPageTourDiv">Step 1 / 10 <br>A student with a Sibling? <span class="studentPageTourSpecialColor">Search Family</span></div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#v-step-StudentPersonalInformation',
          content: `<div class="studentPageTourDiv">Step 2 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Student Particular</span></div>`,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '#v-step-StudentRegistrationDetails',
          content: `<div class="studentPageTourDiv">Step 3 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Registration Details</span> <br>Please fill <span class="studentPageTourSpecialColor">Commencement Date</span> and <span class="studentPageTourSpecialColor">Payer</span> correctly as this will impact the billing</div>`,
          params: {
            placement: 'bottom',
          },
        },
        //Parent Tab
        {
          target: '#v-step-ParentsTab',
          content: `<div class="studentPageTourDiv">Step 4 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Parents Particular</span></div>`,
          params: {
            placement: 'top',
          },
        },
        //EmergencyContactTab
        {
          target: '#v-step-EmergencyContactTab',
          content: `<div class="studentPageTourDiv">Step 5 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Contact</span></div>`,
          params: {
            placement: 'top',
          },
        },
        //Addresses Tab
        {
          target: '#v-step-AddressesTab',
          content: `<div class="studentPageTourDiv">Step 6 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Address</span></div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#v-step-AddressesLRAPostalCode',
          content: `<div class="studentPageTourDiv">Step 7 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Postal Code</span> and <span class="studentPageTourSpecialColor">Address 1</span> will be populated (Singapore address only)</div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#v-step-AddressesBACopyAddress',
          content: `<div class="studentPageTourDiv">Step 8 / 10 <br>Select <span class="studentPageTourSpecialColor">Student's Local Residential Address</span> to copy from above</div>`,
          params: {
            placement: 'top',
          },
        },
        //Medical Tab
        {
          target: '#v-step-MedicalTab',
          content: `<div class="studentPageTourDiv">Step 9 / 10 <br>Fill in the <span class="studentPageTourSpecialColor">Student Medical Information</span></div>`,
          params: {
            placement: 'top',
          },
        },
        //Save button
        {
          target: '#v-step-SaveButton',
          content: `<div class="studentPageTourDiv">Step 10 / 10 <br>Click the <span class="studentPageTourSpecialColor">Save</span> button to save</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour

      //vue tour Update Level Class
      studentPageUpdateLevelClassVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish',
        },
      },
      studentPageUpdateLevelClassVueTourCallBacks: {
        onPreviousStep: this.studentPageUpdateLevelClassVueTourCallBacksPreviousSteps,
        onNextStep: this.studentPageUpdateLevelClassVueTourCallBacksNextSteps,
      },
      studentPageUpdateLevelClassVueTour: [
        //Level Tab
        {
          target: '#v-step-LevelTabTitle',
          content: `<div class="studentPageTourDiv">Step 2 / 3 <br>Select <span class="studentPageTourSpecialColor">Academic Year</span> and <span class="studentPageTourSpecialColor">Class</span></div>`,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#v-step-SaveButton',
          content: `<div class="studentPageTourDiv">Step 3 / 3 <br>Click <span class="studentPageTourSpecialColor">Save</span> to save the level with class</div>`,
          params: {
            placement: 'top',
          },
        },
      ],
      //vue tour Update Level Class
      newMealTermDateRangeOptions: {
        disabledDate: time => {
          let start = new Date(this.newSchoolMeal.startDate)
          let end = new Date(this.newSchoolMeal.endDate)
          return !(time <= end && start <= time)
        },
      },
      newAddLangTermDateRangeOptions: {
        disabledDate: time => {
          let start = new Date(this.newAddLang.startDate)
          let end = new Date(this.newAddLang.endDate)
          return !(time <= end && start <= time)
        },
      },

      firstCommencementDatePickerOptions: {
        disabledDate(time) {
          return time.getDay() === 0 || time.getDay() === 6
        },
      },

      deferValid: false,
      inputDeferDate: '',
      deferDatePickerOptions: {
        disabledDate(time) {
          return time <= new Date()
        },
      },

      inputStudentComment: '',
      inputStudentHouse: '',
      highestLevel: false,
      referralTransferMode: '',
      referralTransferModeTitle: '',
      autoLevel: '',
      PendingMovementStatusAction: '',
      inputStudentSchoolEmail: '',
      inputStudentSchoolEmailPassword: '',
      inputReActivateDateOfCommencement: '',
      studentFrequentPayments: ['', 'Termly', 'Monthly'],
      ddlStudentFrequentPayments: '',
      inputStudentCda: '',
      btnSave: false,
      btnNext: false,
      btnPrevious: false,
      inputStudentAuthorizedPickupName: '',
      inputStudentAuthorizedPickupContactNo: '',
      inputStudentAuthorizedPickupIdentifyNo: '',
      inputStudentAuthorizedPickupRelationship: '',

      studentAuthorizedPickupListInt: [],
      studentAuthorizedPickupList: [
        {
          prop: 'AutPickName',
          label: 'Name',
        },
        {
          prop: 'AutPickIdentifyNo',
          label: 'Identify No',
        },
        {
          prop: 'AutPickRelationship',
          label: 'Relationship',
        },
        {
          prop: 'AutPickContactNo',
          label: 'Contact No',
        },
      ],
      studentAuthorizedPickupListAction: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.studentAuthorizedPickupListInt.splice(this.studentAuthorizedPickupListInt.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },

      familyParentFatherName: '',
      familyParentFatherContact: '',
      familyParentMotherName: '',
      familyParentMotherContact: '',
      emergencyContactList: ['Father', 'Mother', 'Guardian', 'Others'],
      ddlRejectReasonList: [],
      ddlRejectReason: '',
      inputRejectDate: '',

      familyParentFatherCompanyCountry: '',
      familyParentFatherCompanyPostalCode: '',
      familyParentFatherCompanyAddress1: '',
      familyParentFatherCompanyAddress2: '',
      familyParentFatherCompanyAddress3: '',
      familyParentFatherCompanyCity: '',
      familyParentFatherCompanyEmail: '',
      familyParentMotherCompanyCountry: '',
      familyParentMotherCompanyPostalCode: '',
      familyParentMotherCompanyAddress1: '',
      familyParentMotherCompanyAddress2: '',
      familyParentMotherCompanyAddress3: '',
      familyParentMotherCompanyCity: '',
      familyParentMotherCompanyEmail: '',
      familyParentFatherCountry: '',
      familyParentFatherPostalCode: '',
      familyParentFatherAddress1: '',
      familyParentFatherAddress2: '',
      familyParentFatherAddress3: '',
      familyParentFatherCity: '',
      familyParentFatherEmail: '',
      familyParentMotherCountry: '',
      familyParentMotherPostalCode: '',
      familyParentMotherAddress1: '',
      familyParentMotherAddress2: '',
      familyParentMotherAddress3: '',
      familyParentMotherCity: '',
      familyParentMotherEmail: '',

      firstEmerContactRelationOther: '',
      secondEmerContactRelationOther: '',

      ddlStudentSubsidy: [],
      ddlStudentSubsidyList: [],
      ddlStudentSubsidyShow: false,

      inviteParentRegisterList: [],
      ddlParentInvite: '',

      currentLevelClassList: [],
      ddlClass: '',
      StudentCreatedBy: '',

      currentStudentAuthorizedPickupImgPreview: '',
      currentStudentAuthorizedPickupImg: '',
      inputStudentEmailAdd: '',

      parentRegisteredList: [],
      studentDeclaredTravel: [],

      currentVoidStudentCourseID: '',
      currentVoidStudentCourseReason: '',
      //alexis
      currentStudentCourseID: '',
      currentClassID: '',
      currentLevelSchoolID: '',
      currentClassName: '',
      currentLevelName: '',
      currentStartDate: '',

      studentDocumentManagerShowModal: false,
      sdmBodySCSpanSCActive: false,
      sdmBodySCSpanIRActive: false,
      sdmBodySCSpanAAMActive: false,
      collapseSD: false,
      collapseIR: false,
      collapseAAM: false,
      sdmCurrentFolder: [],
      studentDocumentManagerNewFolderShowModel: false,
      newFolder: '',
      newFolderType: '',
      studentDocumentFile: [],
      studentDocumentCurrentFolder: [],
      StudentDocumentManagerNewFileShowModal: false,
      uploadFileName: '',
      uploadFileDescription: '',
      StudentDocumentManagerMoveFileShowModal: false,
      moveFileSelectedFolderType: '',
      moveFileSelectedFolderTypeList: ['Student Doc', 'Immunization Records', 'All About Me'],
      moveFileSelectedFolder: [],
      moveFilePreviousSelectedFolder: '',
      moveFileSelectedFolderList: [],
      studentDocumentManagerDeleteFileConfirm: false,
      studentDocumentFolder: [],
      studentDocumentManagerDeleteFolderConfirm: false,
      studentDocumentManagerDeleteFolderSelectedFolderID: '',

      classMateListInt: [],
      classMateList: [],
      inputSearchClassMate: '',

      ddlPhotographConsent: '',
      ddlPhotographConsentList: ['-', 'No', 'Yes'],

      inputStudent3rdEmergencyContact: '',
      inputStudent3rdEmergencyContactNo: '',
      inputStudent3rdEmergencyContactRelation: '',
      thirdEmerContactRelationOther: '',

      ddlAgent: '',
      ddlAgentList: [],
      tempstudentid: '',

      inputAgentOther: '',

      inputAgenStudentOnboardtDate: '',

      studentDocumentManagerViewFiles: false,

      ddlPDPAConsent: 'No',

      resetEmailPassword: false,
      resetEmailPasswordManualPassword: '',
      resetEmailPasswordManualPasswordCheckBox: false,
    }
  },
  computed: {
    isdivParent() {
      if (this.divParent === true && this.lblCreateOrEdit === 'New' && this.inputFamilyID === '') {
        return true
      } else {
        return false
      }
    },
    fatherOccupation() {
      if (this.divParent === true && this.lblCreateOrEdit === 'New' && this.inputFamilyID === '' && this.ddlFatherWorking === 'Yes') {
        return true
      } else {
        return false
      }
    },
    motherOccupation() {
      if (this.divParent === true && this.lblCreateOrEdit === 'New' && this.inputFamilyID === '' && this.ddlMotherWorking === 'Yes') {
        return true
      } else {
        return false
      }
    },
    oneIDType() {
      if (
        this.inputStudentIdentificationExpiryDate === '' &&
        this.inputStudentIdentificationNo === '' &&
        this.inputStudentBirthCertificate === '' &&
        this.inputStudentIC === '' &&
        this.inputStudentPassport === '' &&
        this.inputStudentPassportExpiryDate === ''
      ) {
        return true
      } else {
        return false
      }
    },
    oneFinType() {
      if (
        this.inputStudentIdentificationExpiryDate === '' &&
        this.inputStudentIdentificationNo === '' &&
        this.inputStudentBirthCertificate === '' &&
        this.inputStudentIC === '' &&
        this.inputStudentPassport === '' &&
        this.inputStudentPassportExpiryDate === ''
      ) {
        return true
      } else if (
        (this.inputStudentPassport !== '' && this.inputStudentPassportExpiryDate !== '') ||
        (this.inputStudentIdentificationExpiryDate !== '' && this.inputStudentIdentificationNo !== '')
      ) {
        return false
      } else if (
        (this.inputStudentIdentificationExpiryDate !== '' && this.inputStudentIdentificationNo === '') ||
        (this.inputStudentIdentificationExpiryDate === '' && this.inputStudentIdentificationNo !== '')
      ) {
        return true
      } else {
        return false
      }
    },
    isLevelTab() {
      return this.levelTab
    },
    onePassportType() {
      if (
        this.inputStudentBirthCertificate === '' &&
        this.inputStudentIC === '' &&
        this.inputStudentPassport === '' &&
        this.inputStudentPassportExpiryDate === '' &&
        this.inputStudentIdentificationExpiryDate === '' &&
        this.inputStudentIdentificationNo === ''
      ) {
        return true
      } else if (
        (this.inputStudentPassport !== '' && this.inputStudentPassportExpiryDate !== '') ||
        (this.inputStudentIdentificationExpiryDate !== '' && this.inputStudentIdentificationNo !== '')
      ) {
        return false
      } else if (
        (this.inputStudentPassport !== '' && this.inputStudentPassportExpiryDate === '') ||
        (this.inputStudentPassport === '' && this.inputStudentPassportExpiryDate !== '')
      ) {
        return true
      } else {
        return false
      }
    },
    isdivEnrolledinOtherCenter() {
      if (this.divEnrolledinOtherCenterShow === true) {
        return true
      } else {
        return false
      }
    },
    isNewParent() {
      if (this.inputFamilyID === '') {
        return true
      } else {
        return false
      }
    },
  },
  validations: studentValidations,
  components: {
    Academica,
    K2Confirm,
    promotionComponent,
    StudentWithdrawForm,
    pdf,
  },
  methods: {
    handleUserID() {
      return getUserID()
    },
    async requestResetPassword(email) {
      if (!window.confirm(`Confirm reset password and send email to ${email}?`)) return
      const res = await DataSource.shared.requestResetParentPassword(this.studentData.PAR_ID, email)
      if (res.code === '1') {
        this.$notify.success({
          title: 'Success',
          message: 'Password reset successfully!',
        })
      } else {
        this.$notify.error({
          title: 'error',
          message: String(res?.message || 'An error has occurred!').substring(0, 200) + '...',
        })
      }
    },
    disabledEndDate(date, date2) {
      if (date2) {
        return date.getTime() < date2
      } else {
        return date.getTime() < Date.now()
      }
    },
    hideModal() {
      this.withdrawShowModal = false
      this.transferModal = false
      this.studentDocumentManagerShowModal = false
    },
    backToPrevious() {
      window.location.replace('/student-list?mode=Search')
    },
    async BindCountryList() {
      try {
        const response = await DataSource.shared.getCountryList()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.countryListResponse = response.Table
            this.countryListResponse.forEach(m => {
              this.countryList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentDropdown() {
      try {
        let jsonString = '"Mother Tongue":"Mother Tongue"'
        jsonString = jsonString + ',"Meal Preferences":"Meal Preferences"'
        jsonString = jsonString + ',"Student Membership":"Student Membership"'
        jsonString = jsonString + ',"Residency Status":"Residency Status"'
        jsonString = jsonString + ',"Sponsorship Type":"Sponsorship Type"'
        jsonString = jsonString + ',"ParentID":"ParentID"'
        jsonString = jsonString + ',"Parent Mode":"Parent Mode"'
        jsonString = jsonString + ',"Graduation_Remarks":"Graduation_Remarks"'
        jsonString = jsonString + ',"International School Name":"International School Name"'
        jsonString = jsonString + ',"Widthdrawal Reason":"Widthdrawal Reason"'
        jsonString = jsonString + ',"Parents Martial Status":"Parents Martial Status"'
        jsonString = jsonString + ',"Race":"Race"'
        jsonString = jsonString + ',"Food Allergies":"Food Allergies"'
        jsonString = jsonString + ',"Other Center Type":"Other Center Type"'
        jsonString = jsonString + ',"Rejection Reason":"Rejection Reason"'
        jsonString = jsonString + ',"Subsidies":"Subsidies"'
        jsonString = jsonString + ',"Agent":"Agent"'
        jsonString = '{' + jsonString + '}'

        const responseagent = await DataSource.shared.getAgentList('', '', 'dropdown')

        if (responseagent) {
          if (responseagent.code === '88') {
            window.location.replace('/')
          } else {
            this.AgentListResponse = responseagent.Table
            this.AgentListResponse?.forEach(m => {
              this.ddlAgentList.push(m)
            })
          }
        }

        //load NIL
        var schoolsession = Cookies.get('schoolSession')
        var japanschools = await DataSource.shared.getJapanschoolIDs()

        if (japanschools) {
          if (japanschools.code === '88') {
            window.location.replace('/')
            console.log('error loading japan schools')
          } else {
            this.JapanSchoolsList = japanschools.Table
          }
        }
        //check if japan school then BLANK default to NIL
        var japObjlist = this.JapanSchoolsList.filter(m => m.japanschoolid === schoolsession)
        if (japObjlist.length !== 0) {
          this.ddlAgent = 'NIL'
        }

        const response = await DataSource.shared.getStudentDropDownList(jsonString)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.studentDropDownListResponse = response.Table
            this.studentDropDownListResponse.forEach(m => {
              if (m.OGPname.trim() === 'Mother Tongue') {
                this.ddlStudentAdditionalLanguageList.push(m)
              } else if (m.OGPname.trim() === 'Meal Preferences') {
                this.ddlStudentMealPreferencesList.push(m)
              } else if (m.OGPname.trim() === 'Student Membership') {
                this.ddlStudentMembershipList.push(m)
              } else if (m.OGPname.trim() === 'Residency Status') {
                this.ddlStudentResidencyStatusList.push(m)
              } else if (m.OGPname.trim() === 'Sponsorship Type') {
                this.ddlStudentPayerList.push(m)
              } else if (m.OGPname.trim() === 'ParentID') {
                this.ddlFatherIdentificationTypeList.push(m)
                this.ddlMotherIdentificationTypeList.push(m)
              } else if (m.OGPname.trim() === 'Parent Mode') {
                this.ddlParentModeList.push(m)
              } else if (m.OGPname.trim() === 'Parents Martial Status') {
                this.ddlMaritalStatusList.push(m)
              } else if (m.OGPname.trim() === 'Race') {
                this.ddlRaceList.push(m)
              } else if (m.OGPname.trim() === 'Food Allergies') {
                this.ddlddlStudentFoodAllergiesFoodList.push(m)
              } else if (m.OGPname.trim() === 'Other Center Type') {
                this.ddlStudentEnrolledCenterTypeList.push(m)
              } else if (m.OGPname.trim() === 'Rejection Reason') {
                this.ddlRejectReasonList.push(m)
              } else if (m.OGPname.trim() === 'Subsidies') {
                this.ddlStudentSubsidyList.push(m)
              } else if (m.OGPname.trim() === 'Agent') {
                //this.ddlAgentList.push(m);
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    //alexis
    async bindClassLevel(event) {
      this.ddlStudentClassList = []

      try {
        const response = await DataSource.shared.getClassLevel(this.ddlStudentLevel, this.currentLevelSchoolID)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ClassLevelListResponse = response.Table
            this.ClassLevelListResponse.forEach(m => {
              this.ddlStudentClassList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    //alexis
    async BindStudentAllLevel() {
      try {
        const response = await DataSource.shared.getLevelAll('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.AlllevelListResponse = response.Table
            this.AlllevelListResponse.forEach(m => {
              this.ddlStudentLevelList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindStudentLevel() {
      try {
        const response = await DataSource.shared.getLevel('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelListResponse = response.Table
            this.levelListResponse.forEach(m => {
              this.levelList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async BindStudentLevel_Level(customLevelNotEqual) {
      try {
        let courseID
        const response = await DataSource.shared.getLevel(customLevelNotEqual)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.levelListResponse = response.Table
            this.levelListResponse.forEach(m => {
              this.levelList_Level.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindAcademicYear() {
      try {
        const response = await DataSource.shared.getAcademicYear()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.academicYearListResponse = response.Table
            this.academicYearListResponse.forEach(m => {
              //this.academicYearList.push(m);
              this.academicYearList_Level.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentIntakeYear() {
      try {
        const response = await DataSource.shared.getIntakeYear()
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.studentIntakeYearListResponse = response.Table
            this.studentIntakeYearListResponse.forEach(m => {
              //this.studentIntakeYearList.push(m);
              this.studentIntakeYearList_Level.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudentParentInfo() {
      try {
        if (this.$route.query.id != null || this.$route.query.id !== undefined) {
          this.lblCreateOrEdit = 'Edit'
          this.lblStudentID = this.$route.query.id
          this.siblingTab = true
          this.levelTab = true
          this.divFamilySearch = false
          this.divEditParentLink = true
          this.changeStatusAction = true
          this.btnSave = true
          this.btnNext = false
          this.btnPrevious = false
          this.mealsTab = Cookies.get('userSchoolNameSession').includes('Middleton') ? true : false
          this.addLangTab = Cookies.get('userSchoolNameSession').includes('Middleton') ? true : false
          let parentID
          let courseID

          const stuRes = await DataSource.shared.getStudentWithPendingCourse(this.$route.query.id, '', '', '', '', '', '', '', '', '')
          if (stuRes) {
            if (stuRes.code === '88') {
              window.location.replace('/')
            } else if (stuRes.code === '99') {
              console.log('get Student Error')
            } else if (stuRes.code === '2') {
              window.location.replace('/')
            } else {
              this.BindActiveIntakeYear()
              this.studentData = stuRes.Table[0] ?? {}
              this.BindStudentFields(stuRes.Table)
              try {
                this.bindOnboardDate()
              } catch {
                console.log('no record agent onboard')
              }

              this.BindStudentSibling()
              this.arrayStudentIDLevelComponent.push(stuRes.Table[0].Student_ID)
              if (stuRes.Table[0].Nationality !== 'Singaporean') {
                await this.checkImmunizationRecordsUpload()
              }
              //this.checkAgent(stuRes.Table);
            }
          }

          //TODO get ProfilePicture
          const stuProPic = await DataSource.shared.getStudentProfilePicture(this.$route.query.id)
          if (stuProPic) {
            if (stuProPic.code === '88') {
              window.location.replace('/')
            } else if (stuProPic.code === '99') {
              console.log('get getStudentProfilePicture Error')
            } else if (stuProPic.code === '2') {
              console.log('getStudentProfilePicture No Record')
            } else {
              if (stuProPic.code !== '2' && stuProPic.code !== '99') {
                this.stuProPicLoop = stuProPic.Table
                this.stuProPicLoop.forEach(m => {
                  if (this.isImage(m)) {
                    this.imgStudentProfile = API_HOST + `/External/STUDENTS/${this.lblStudentID}/PROFILE_PHOTO/` + m.SF_File_Name
                  }
                })
              }
            }
          }

          const relRes = await DataSource.shared.getRelationship('', this.$route.query.id, '', '', '')
          if (relRes) {
            if (relRes.code === '88') {
              window.location.replace('/')
            } else if (relRes.code === '99') {
              console.log('get getRelationship Error')
            } else if (relRes.code === '2') {
              console.log('getRelationship No Record')
            } else {
              this.relResLoop = relRes.Table
              this.relResLoop.forEach(m => {
                parentID = m.PAR_ID
              })

              const parRes = await DataSource.shared.getParent(parentID, '', '')
              if (parRes) {
                this.BindParentFields(parRes.Table)

                this.ParentCompanyAddressShow('Father')
                this.ParentCompanyAddressShow('Mother')
              }
            }
          }

          const response = await DataSource.shared.getStudentLevel(this.$route.query.id)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('get getStudentLevel Error')
            } else if (response.code === '2') {
              console.log('getStudentLevel No Record')
            } else {
              this.lvlLevelList_Level = response.Table

              //filter the added level to BindStudentLevel
              let customLevelNotEqual = ''
              this.GetStudentLevelListResponse = response.Table
              this.GetStudentLevelListResponse.forEach(m => {
                if (customLevelNotEqual === '') {
                  customLevelNotEqual = m.PK_Course_ID
                } else {
                  customLevelNotEqual = customLevelNotEqual + ',' + m.PK_Course_ID
                }

                if (m.SCRS_Status === 'Active') {
                  courseID = m.SCRS_FK_Course_ID
                  this.strClassIDLevelComponent = courseID
                  this.ddlMealsStudentCourseID = m.PK_Student_Course_ID
                  this.getStudentMeals()
                  this.ddlAddLangStudentCourseID = m.PK_Student_Course_ID
                  this.getAddLang()
                }
              })
              if (this.ddlMealsStudentCourseID == null && this.GetStudentLevelListResponse.length > 0) {
                this.ddlMealsStudentCourseID = this.GetStudentLevelListResponse[0].PK_Student_Course_ID
                this.getStudentMeals()
              }
              if (this.ddlAddLangStudentCourseID == null && this.GetStudentLevelListResponse.length > 0) {
                this.ddlAddLangStudentCourseID = this.GetStudentLevelListResponse[0].PK_Student_Course_ID
                this.getAddLang()
              }

              this.BindStudentLevel_Level(customLevelNotEqual)
              //filter the added level to BindStudentLevel
            }
          }

          const resalllvl = await DataSource.shared.getStudentAllLevel(this.$route.query.id)
          if (resalllvl) {
            if (resalllvl.code === '88') {
              window.location.replace('/')
            } else if (resalllvl.code === '99') {
              console.log('get getStudentAllLevel Error')
            } else if (resalllvl.code === '2') {
              console.log('getStudentAllLevel No Record')
            } else {
              let customLevelNotEqual = ''
              this.GetStudentAllLevelListResponse = response.Table
              this.BindStudentAllLevel(customLevelNotEqual)
            }
          }

          const alleRes = await DataSource.shared.getStudentAllergies(this.$route.query.id, '')
          if (alleRes) {
            if (alleRes.code === '88') {
              window.location.replace('/')
            } else if (alleRes.code === '99') {
              console.log('get getStudentAllergies Error')
            } else if (alleRes.code === '2') {
              console.log('getStudentAllergies No Record')
            } else {
              this.alleResLoop = alleRes.Table
              this.alleResLoop.forEach(m => {
                if (m.StAllType === 'Medical') {
                  this.medicationAllergiesListInt.push(m)
                } else if (m.StAllType === 'Food') {
                  this.foodAllergiesListInt.push(m)
                }
              })
            }
          }

          const stuPenActRes = await DataSource.shared.getPendingStudentMovementStatusAction(this.$route.query.id)
          if (stuPenActRes) {
            if (stuPenActRes.code === '88') {
              window.location.replace('/')
            } else if (stuPenActRes.code === '99') {
              console.log('get getPendingStudentMovementStatusAction Error')
            } else if (stuPenActRes.code === '2') {
              this.PendingMovementStatusAction = ''
            } else {
              this.PendingMovementStatusAction = stuPenActRes.Table[0].Action + ' on ' + stuPenActRes.Table[0].EffectiveDate
            }
          }

          const resAuthorizedPickup = await DataSource.shared.getStudentAuthorizedPickup(this.$route.query.id)
          if (resAuthorizedPickup) {
            if (resAuthorizedPickup.code === '88') {
              window.location.replace('/')
            } else if (resAuthorizedPickup.code === '99') {
              console.log('get getStudentAuthorizedPickup Error')
            } else if (resAuthorizedPickup.code === '2') {
              console.log('getStudentAuthorizedPickup No Record')
            } else {
              this.studentAuthorizedPickupListInt = resAuthorizedPickup.Table
            }
          }

          const resStudentTravelDeclaration = await DataSource.shared.getStudentTravelDeclaration(this.$route.query.id)
          if (resStudentTravelDeclaration) {
            if (resStudentTravelDeclaration.code === '88') {
              window.location.replace('/')
            } else if (resStudentTravelDeclaration.code === '99') {
              console.log('getStudentTravelDeclaration Error')
            } else if (resStudentTravelDeclaration.code === '2') {
              console.log('getStudentTravelDeclaration No Record')
              this.studentDeclaredTravel = []
            } else {
              this.studentDeclaredTravel = resStudentTravelDeclaration
            }
          }

          const resStudentClassMate = await DataSource.shared.getStudentCurrentClassMate(this.$route.query.id)
          if (resStudentClassMate) {
            if (resStudentClassMate.code === '88') {
              window.location.replace('/')
            } else if (resStudentClassMate.code === '99') {
              console.log('resStudentClassMate Error')
            } else if (resStudentClassMate.code === '2') {
              console.log('resStudentClassMate No Record')
              this.classMateList = []
              this.classMateListInt = []
            } else {
              this.classMateList = resStudentClassMate.Table
              this.classMateListInt = resStudentClassMate.Table
            }
          }

          if (stuRes.Table[0].sponsor_type) {
            this.checkPayerType(stuRes.Table[0].sponsor_type)
          } else {
            this.ddlStudentPayer = ''
          }
        } else {
          this.editModeDisable = false
          this.editCenterTypeDisable = false
          this.lblCreateOrEdit = 'New'
          this.siblingTab = false
          this.levelTab = false
          this.divFamilySearch = true
          this.divEditParentLink = false
          this.changeStatusAction = false
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = false
          this.mealsTab = false
          this.addLangTab = false
          this.ddlStudentAddressCountry = 'Singapore'
          this.ddlStudentAddressCorrespondanceCountry = 'Singapore'

          if (this.$route.query.hsdid != null || this.$route.query.hsdid !== undefined) {
            this.getHubSpotDetails(this.$route.query.hsdid)
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindActiveIntakeYear() {
      try {
        const response = await DataSource.shared.getStudentLevelActiveOnly(this.$route.query.id)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            response.Table.forEach(m => {
              this.ddlStudentIntakeYear = m.SCRS_Course_Year
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentAvailableStatusAction(currentStatus, currentIndexNo, currentStudentID) {
      try {
        const response = await DataSource.shared.getStudentAvailableStatusAction(currentStatus, currentIndexNo, currentStudentID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlChangeStatusToListResponse = response.Table1
            this.ddlChangeStatusToListResponse.forEach(m => {
              this.ddlChangeStatusToList.push(m)
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentFields(resultTable) {
      try {
        resultTable.forEach(m => {
          this.BindStudentAvailableStatusAction(m.Status, m.Index_No, m.Student_ID)
          this.checkDeferValid(m.Student_ID)
          this.checkLevelOrder(m.Student_ID)
          this.lblCurrentStatus = m.Status
          this.lblStudentIndexNo = m.Index_No
          this.inputStudentID = m.Index_No
          this.inputStudentFirstName = m.Full_Name
          this.inputStudentMiddleName = m.Middle_name
          this.inputStudentLastName = m.Last_name
          this.ddlStudentGender = m.Sex
          this.inputStudentCorrespondanceAddress1 = m.st_corr_add_blkNo
          this.inputStudentCorrespondanceAddress2 = m.st_corr_add_flrNo
          this.inputStudentCorrespondanceCity = m.st_corr_add_stName
          this.inputStudentCorrespondancePostalCode = m.st_corr_add_pstcode
          this.inputStudentPostalCode = m.st_prm_add_pstcode
          this.inputStudentAddress1 = m.st_prm_add_blkNo
          this.inputStudentAddress2 = m.st_prm_add_flrNo
          this.inputStudentAddress3 = m.st_prm_add_BlgName
          if (m.DOB_convert !== '01/01/1901') {
            this.inputStudentDateOfBirth = m.DOB_convert
          }
          this.ddlStudentNationality = m.Nationality
          if (m.Regst_date_convert !== '01/01/1901') {
            this.inputFirstCommencementDate = m.Regst_date_convert
          }
          if (m.St_BillingNotificationDate) {
            this.inputFirstBillingNotification = getFormatDate(m.St_BillingNotificationDate)
          }

          this.ddlStudentAddressCountry = m.st_prm_add_country
          this.inputStudentMobileNo = m.Handphone
          this.inputStudentCorrespondanceAddress3 = m.st_corr_add_BlgName
          this.ddlStudentResidencyStatus = m.student_type
          this.ddlStudentPayer = m.sponsor_type

          this.ddlStudentLevel = m.student_level

          this.inputStudentIdentificationNo = m.ID_Number
          this.inputStudentCity = m.st_prm_add_stName
          this.ddlStudentAddressCorrespondanceCountry = m.st_corr_add_country
          this.inputStudent2ndEmergencyContactNo = m.Fax
          this.inputStudentEmail = m?.email?.includes('undefined') ? m?.email?.replace('undefined,', '') : m?.email
          this.inputStudent1stEmergencyContactNo = m.Telephone
          this.inputStudentOfficeTelNo = m.Offphone
          //this.ddlStudentSelectLevel = m.Course_Type;
          this.inputNameofFamilyDoctor = m.Family_Doctor
          this.taMajorAilmentsList = m.Ailments
          this.inputClinicAddress = m.clinic_add
          this.inputClinicPhoneNo = m.clinic_ph_no
          //this.ddlStudentFirstAcademicYear = m.Semester;
          this.inputStudentPreferredName = m.St_Preferred_Name
          this.ddlStudentAdditionalLanguage = m.St_Mother_Tongue
          this.ddlStudentMealPreferences = m.St_Meal_Preferences
          this.ddlStudentBirthPlace = m.St_Birth_Place
          this.inputStudentFirstLanguageSpoken = m.St_AdditionalLanguage
          this.inputSecondLanguageSpoken = m.St_SecondLanguageSpoken
          this.ddlStudentMembership = m.ST_StudentMemership
          if (m.ID_ExpDate_convert !== '01/01/1901') {
            this.inputStudentIdentificationExpiryDate = m.ID_ExpDate_convert
          }
          this.inputStudentBirthCertificate = m.St_BirthCer_Number
          this.inputStudentIC = m.St_IC_ID_Number
          this.inputStudentPassport = m.St_Passport_Number
          if (m.St_Passport_ExpDate_convert !== '01/01/1901') {
            this.inputStudentPassportExpiryDate = m.St_Passport_ExpDate_convert
          }
          this.inputStudent1stEmergencyContact = m.St_EmergencyContact
          if (m.St_EmergencyContactRelation === 'Father' || m.St_EmergencyContactRelation === 'Mother' || m.St_EmergencyContactRelation === 'Guardian') {
            this.inputStudent1stEmergencyContactRelation = m.St_EmergencyContactRelation
          } else {
            this.inputStudent1stEmergencyContactRelation = 'Others'
            this.firstEmerContactRelationOther = m.St_EmergencyContactRelation
          }
          this.inputStudent2ndEmergencyContact = m.St_2ndEmergencyContact
          this.inputStudent2ndEmergencyContactRelation = m.St_2ndEmergencyContactRelation
          if (
            m.St_2ndEmergencyContactRelation === 'Father' ||
            m.St_2ndEmergencyContactRelation === 'Mother' ||
            m.St_2ndEmergencyContactRelation === 'Guardian'
          ) {
            this.inputStudent2ndEmergencyContactRelation = m.St_2ndEmergencyContactRelation
          } else {
            this.inputStudent2ndEmergencyContactRelation = 'Others'
            this.secondEmerContactRelationOther = m.St_2ndEmergencyContactRelation
          }
          this.inputStudent3rdEmergencyContactNo = m.St_3rdEmergencyContactNo
          this.inputStudent3rdEmergencyContact = m.St_3rdEmergencyContact
          this.inputStudent3rdEmergencyContactRelation = m.St_3rdEmergencyContactRelation
          if (
            m.St_3rdEmergencyContactRelation === 'Father' ||
            m.St_3rdEmergencyContactRelation === 'Mother' ||
            m.St_3rdEmergencyContactRelation === 'Guardian'
          ) {
            this.inputStudent3rdEmergencyContactRelation = m.St_3rdEmergencyContactRelation
          } else {
            this.inputStudent3rdEmergencyContactRelation = 'Others'
            this.thirdEmerContactRelationOther = m.St_3rdEmergencyContactRelation
          }
          this.inputStudentDietaryRequirement = m.St_Dietary
          this.ddlStudentRace = m.Race
          this.ddlStudentEnrolledinOtherCenter = m.St_OtherCenter
          if (m.St_OtherCenter === 'Yes') {
            this.divEnrolledinOtherCenterShow = true
            this.inputStudentEnrolledCenterName = m.St_OtherCenterName
            if (m.St_OtherCenterType) {
              this.ddlStudentEnrolledCenterType = m.St_OtherCenterType
            } else {
              this.editCenterTypeDisable = false
            }
          }
          this.inputStudentComment = m.St_Comment
          this.inputStudentHouse = m.St_House
          this.inputStudentSchoolEmail = m.St_SchoolEmail
          this.hubSpotID = m.St_HubSpotDealID
          this.ddlStudentFrequentPayments = m.St_FrequentPayments
          this.inputStudentCda = m.St_Cda
          if (m.St_Subsidy) {
            this.ddlStudentSubsidy.push.apply(this.ddlStudentSubsidy, m.St_Subsidy.split(','))
          }
          this.StudentCreatedBy = 'By: ' + m.studentCreatedBy
          this.ddlPhotographConsent = m.St_PhConsent
          this.ddlPDPAConsent = m.St_Pdpa
          this.ddlAgent = m.St_Agent2

          //this.ddlAgent = m.St_Agent;//Welson

          //alexis
          this.tempstudentid = m.Student_ID
        })
      } catch (e) {
        this.results = e
      }
    },

    async bindOnboardDate() {
      const responseagent1 = await DataSource.shared.getAgentOnboardDate(this.ddlAgent, this.tempstudentid, '', 'get')
      if (responseagent1) {
        if (responseagent1.code === '88') {
          window.location.replace('/')
        } else {
          this.AgentListResponse = responseagent1.Table
          this.AgentListResponse?.forEach(m => {
            this.inputAgenStudentOnboardtDate = m.onboarddate
          })
        }
      }
    },

    async BindParentFields(resultTable) {
      try {
        resultTable.forEach(m => {
          this.lblParentID = m.PAR_ID
          this.ddlParentMode = m.PAR_Mode
          this.inputFatherFirstName = m.PAR_Father_FirstName
          this.inputFatherMiddleName = m.PAR_Father_MiddleName
          this.inputFatherLastName = m.PAR_Father_LastName
          if (m.PAR_Father_DOB_convert !== '01/01/1901') {
            this.inputFatherDateofBirth = m.PAR_Father_DOB_convert
          }
          this.inputFatherOccupation = m.PAR_Father_Occupation
          this.inputFatherMobileNo = m.PAR_Father_Phone
          this.inputFatherEmail = m.PAR_Father_Email
          this.ddlFatherIdentificationType = m.PAR_Father_IDType
          this.inputFatherIdentificationNo = m.PAR_Father_UID
          this.inputMotherFirstName = m.PAR_Mother_FirstName
          this.inputMotherMiddleName = m.PAR_Mother_MiddleName
          this.inputMotherLastName = m.PAR_Mother_LastName
          if (m.PAR_Mother_DOB_convert !== '01/01/1901') {
            this.inputMotherDateofBirth = m.PAR_Mother_DOB_convert
          }
          this.inputMotherOccupation = m.PAR_Mother_Occupation
          this.inputMotherMobileNo = m.PAR_Mother_Phone
          this.inputMotherEmail = m.PAR_Mother_Email
          this.ddlMotherIdentificationType = m.PAR_Mother_IDType
          this.inputMotherIdentificationNo = m.PAR_Mother_UID
          if (m.PAR_Father_IDExpDate_convert !== '01/01/1901') {
            this.inputFatherIdentificationNoExpiryDate = m.PAR_Father_IDExpDate_convert
          }
          if (m.PAR_Mother_IDExpDate_convert !== '01/01/1901') {
            this.inputMotherIdentificationNoExpiryDate = m.PAR_Mother_IDExpDate_convert
          }
          this.inputFamilyID = m.PAR_Family_Number
          this.ddlFatherRace = m.PAR_Father_Race
          this.ddlFatherMaritalStatus = m.PAR_Father_MaritalStatus
          this.ddlFatherWorking = m.PAR_Father_Working
          this.ddlMotherRace = m.PAR_Mother_Race
          this.ddlMotherMaritalStatus = m.PAR_Mother_MaritalStatus
          this.ddlMotherWorking = m.PAR_Mother_Working
          this.inputFatherCompanyName = m.PAR_Father_CompanyName
          this.inputFatherCompanyAddresseeName = m.PAR_Fat_Comp_Addressee
          this.inputFatherCompanyAddress1 = m.PAR_Father_Residence_No
          this.inputFatherCompanyAddress2 = m.PAR_Father_Address1
          this.inputFatherCompanyAddress3 = m.PAR_Father_Address2
          this.inputFatherCompanyCity = m.PAR_Father_City
          this.ddlFatherCompanyCountry = m.PAR_Father_Country
          this.inputFatherCompanyPostalCode = m.PAR_Father_PostalCode
          this.inputFatherCompanyEmail = m.PAR_FComp_Email
          this.inputFatherWorkingCommencementDate = m.PAR_Father_WorkingCommencementDate
          this.inputFatherOccupation = m.PAR_Father_Occupation
          this.inputMotherCompanyName = m.PAR_Mother_CompanyName
          this.inputMotherCompanyAddresseeName = m.PAR_Mot_Comp_Addressee
          this.inputMotherCompanyAddress1 = m.PAR_Mother_Residence_No
          this.inputMotherCompanyAddress2 = m.PAR_Mother_Address1
          this.inputMotherCompanyAddress3 = m.PAR_Mother_Address2
          this.inputMotherCompanyCity = m.PAR_Mother_City
          this.ddlMotherCompanyCountry = m.PAR_Mother_Country
          this.inputMotherCompanyPostalCode = m.PAR_Mother_PostalCode
          this.inputMotherCompanyEmail = m.PAR_MComp_Email
          this.inputMotherWorkingCommencementDate = m.PAR_Mother_WorkingCommencementDate
          this.inputMotherOccupation = m.PAR_Mother_Occupation

          //for emergency contact copy
          this.familyParentFatherContact = m.PAR_Father_Phone
          this.familyParentMotherContact = m.PAR_Mother_Phone

          if (m.PAR_Father_MiddleName) {
            this.familyParentFatherName = m.PAR_Father_FirstName + ' ' + m.PAR_Father_MiddleName + ' ' + m.PAR_Father_LastName
          } else {
            this.familyParentFatherName = m.PAR_Father_FirstName + ' ' + m.PAR_Father_LastName
          }

          if (m.PAR_Mother_MiddleName) {
            this.familyParentMotherName = m.PAR_Mother_FirstName + ' ' + m.PAR_Mother_MiddleName + ' ' + m.PAR_Mother_LastName
          } else {
            this.familyParentMotherName = m.PAR_Mother_FirstName + ' ' + m.PAR_Mother_LastName
          }
          //for emergency contact copy

          //for billing address copy
          //father
          this.familyParentFatherCountry = m.PAR_Father_Loc_Country
          this.familyParentFatherPostalCode = m.PAR_Father_Loc_Postalcode
          this.familyParentFatherAddress1 = m.PAR_Father_Loc_Residence_No
          this.familyParentFatherAddress2 = m.PAR_Father_Loc_Address1
          this.familyParentFatherAddress3 = m.PAR_Father_Loc_Address2
          this.familyParentFatherCity = m.PAR_Father_Loc_City
          this.familyParentFatherEmail = m.PAR_Father_Email

          this.copyAddressList.push("Father's Address")
          //father

          //mother
          this.familyParentMotherCountry = m.PAR_Mother_Loc_Country
          this.familyParentMotherPostalCode = m.PAR_Mother_Loc_Postalcode
          this.familyParentMotherAddress1 = m.PAR_Mother_Loc_Residence_No
          this.familyParentMotherAddress2 = m.PAR_Mother_Loc_Address1
          this.familyParentMotherAddress3 = m.PAR_Mother_Loc_Address2
          this.familyParentMotherCity = m.PAR_Mother_Loc_City
          this.familyParentMotherEmail = m.PAR_Mother_Email

          this.copyAddressList.push("Mother's Address")
          //mother

          //father company
          if (m.PAR_Father_Working === 'Yes') {
            this.familyParentFatherCompanyCountry = m.PAR_Father_Country
            this.familyParentFatherCompanyPostalCode = m.PAR_Father_PostalCode
            this.familyParentFatherCompanyAddress1 = m.PAR_Father_Residence_No
            this.familyParentFatherCompanyAddress2 = m.PAR_Father_Address1
            this.familyParentFatherCompanyAddress3 = m.PAR_Father_Address2
            this.familyParentFatherCompanyCity = m.PAR_Father_City
            this.familyParentFatherCompanyEmail = m.PAR_FComp_Email
          }
          //father company

          //mother company
          if (m.PAR_Mother_Working === 'Yes') {
            this.familyParentMotherCompanyCountry = m.PAR_Mother_Country
            this.familyParentMotherCompanyPostalCode = m.PAR_Mother_PostalCode
            this.familyParentMotherCompanyAddress1 = m.PAR_Mother_Residence_No
            this.familyParentMotherCompanyAddress2 = m.PAR_Mother_Address1
            this.familyParentMotherCompanyAddress3 = m.PAR_Mother_Address2
            this.familyParentMotherCompanyCity = m.PAR_Mother_City
            this.familyParentMotherCompanyEmail = m.PAR_MComp_Email
          }
          //mother company
          //for billing address copy

          //invite parent register list
          if (m.FatherRegistered === 'No') {
            if (m.PAR_Father_Email) {
              let fatherRegisterEmail = {
                ParentID: m.PAR_ID,
                Email: m.PAR_Father_Email,
                Type: 'Father',
              }

              this.inviteParentRegisterList.push(fatherRegisterEmail)
            }
          } else {
            let fatherRegisterEmail = {
              ParentID: m.PAR_ID,
              Email: m.FatherRegisteredEmail,
              Type: 'Father',
            }

            this.parentRegisteredList.push(fatherRegisterEmail)
          }

          if (m.MotherRegistered === 'No') {
            if (m.PAR_Mother_Email) {
              let motherRegisterEmail = {
                ParentID: m.PAR_ID,
                Email: m.PAR_Mother_Email,
                Type: 'Mother',
              }

              this.inviteParentRegisterList.push(motherRegisterEmail)
            }
          } else {
            let motherRegisterEmail = {
              ParentID: m.PAR_ID,
              Email: m.MotherRegisteredEmail,
              Type: 'Mother',
            }

            this.parentRegisteredList.push(motherRegisterEmail)
          }
          //invite parent register list
        })
      } catch (e) {
        this.results = e
      }
    },
    async BindStudentSibling() {
      try {
        const response = await DataSource.shared.getSibling('', this.$route.query.id)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (response.Table.length > 0) {
              this.siblingList = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async Save() {
      this.$vs.loading()
      await this.sleep(1000)

      try {
        let jsonStudent = []

        let jsonStudentDetials = {
          Full_Name: this.inputStudentFirstName,
          Middle_name: this.inputStudentMiddleName,
          Last_name: this.inputStudentLastName,
          Sex: this.ddlStudentGender,
          st_corr_add_blkNo: this.inputStudentCorrespondanceAddress1,
          st_corr_add_flrNo: this.inputStudentCorrespondanceAddress2,
          st_corr_add_stName: this.inputStudentCorrespondanceCity,
          st_corr_add_pstcode: this.inputStudentCorrespondancePostalCode,
          st_prm_add_pstcode: this.inputStudentPostalCode,
          st_prm_add_blkNo: this.inputStudentAddress1,
          st_prm_add_flrNo: this.inputStudentAddress2,
          st_prm_add_BlgName: this.inputStudentAddress3,
          DOB: this.inputStudentDateOfBirth,
          Nationality: this.ddlStudentNationality,
          Regst_date: this.inputFirstCommencementDate,
          St_BillingNotificationDate: this.inputFirstBillingNotification,
          st_prm_add_country: this.ddlStudentAddressCountry,
          Handphone: this.inputStudentMobileNo,
          st_corr_add_BlgName: this.inputStudentCorrespondanceAddress3,
          student_type: this.ddlStudentResidencyStatus,
          sponsor_type: this.ddlStudentPayer,
          student_level: this.ddlStudentLevel,
          ID_Number: this.inputStudentIdentificationNo,
          st_prm_add_stName: this.inputStudentCity,
          st_corr_add_country: this.ddlStudentAddressCorrespondanceCountry,
          Fax: this.inputStudent2ndEmergencyContactNo,
          email: this.inputStudentEmail,
          Telephone: this.inputStudent1stEmergencyContactNo,
          Offphone: this.inputStudentOfficeTelNo,
          Family_Doctor: this.inputNameofFamilyDoctor,
          Ailments: this.taMajorAilmentsList,
          clinic_add: this.inputClinicAddress,
          clinic_ph_no: this.inputClinicPhoneNo,
          St_Preferred_Name: this.inputStudentPreferredName,
          St_Mother_Tongue: this.ddlStudentAdditionalLanguage,
          St_Meal_Preferences: this.ddlStudentMealPreferences,
          St_Birth_Place: this.ddlStudentBirthPlace,
          St_AdditionalLanguage: this.inputStudentFirstLanguageSpoken,
          St_SecondLanguageSpoken: this.inputSecondLanguageSpoken,
          ST_StudentMemership: this.ddlStudentMembership,
          ID_ExpDate: this.inputStudentIdentificationExpiryDate,
          St_BirthCer_Number: this.inputStudentBirthCertificate,
          St_IC_ID_Number: this.inputStudentIC,
          St_Passport_Number: this.inputStudentPassport,
          St_Passport_ExpDate: this.inputStudentPassportExpiryDate,
          St_EmergencyContact: this.inputStudent1stEmergencyContact,
          St_2ndEmergencyContact: this.inputStudent2ndEmergencyContact,
          St_Dietary: this.inputStudentDietaryRequirement,
          Race: this.ddlStudentRace,
          St_OtherCenter: this.ddlStudentEnrolledinOtherCenter,
          St_Comment: this.inputStudentComment,
          St_House: this.inputStudentHouse,
          St_HubSpotDealID: this.hubSpotID,
          St_FrequentPayments: this.ddlStudentFrequentPayments,
          St_Cda: this.inputStudentCda,
          St_PhConsent: this.ddlPhotographConsent,
          St_3rdEmergencyContact: this.inputStudent3rdEmergencyContact,
          St_3rdEmergencyContactNo: this.inputStudent3rdEmergencyContactNo,
          St_Pdpa: this.ddlPDPAConsent,
        }

        if (this.ddlStudentEnrolledinOtherCenter === 'Yes') {
          Vue.set(jsonStudentDetials, 'St_OtherCenterName', this.inputStudentEnrolledCenterName)
          Vue.set(jsonStudentDetials, 'St_OtherCenterType', this.ddlStudentEnrolledCenterType)
        }

        if (this.inputStudent1stEmergencyContactRelation === 'Others') {
          Vue.set(jsonStudentDetials, 'St_EmergencyContactRelation', this.firstEmerContactRelationOther)
        } else {
          Vue.set(jsonStudentDetials, 'St_EmergencyContactRelation', this.inputStudent1stEmergencyContactRelation)
        }

        if (this.inputStudent2ndEmergencyContactRelation === 'Others') {
          Vue.set(jsonStudentDetials, 'St_2ndEmergencyContactRelation', this.secondEmerContactRelationOther)
        } else {
          Vue.set(jsonStudentDetials, 'St_2ndEmergencyContactRelation', this.inputStudent2ndEmergencyContactRelation)
        }

        if (this.inputStudent3rdEmergencyContactRelation === 'Others') {
          Vue.set(jsonStudentDetials, 'St_3rdEmergencyContactRelation', this.thirdEmerContactRelationOther)
        } else {
          Vue.set(jsonStudentDetials, 'St_3rdEmergencyContactRelation', this.inputStudent3rdEmergencyContactRelation)
        }

        //agent save

        Vue.set(jsonStudentDetials, 'St_Agent', this.ddlAgent)
        //previous code when agent was text box
        //} else if (this.ddlAgent === 'Other') {
        //Vue.set(jsonStudentDetials, "St_Agent", this.inputAgentOther);

        let subsidyList = ''
        this.ddlStudentSubsidy.forEach(optid => {
          if (subsidyList === '') {
            subsidyList = optid
          } else {
            subsidyList += ',' + optid
          }
        })
        Vue.set(jsonStudentDetials, 'St_Subsidy', subsidyList)

        //alexis
        const responseagentOnboardsave = DataSource.shared.getAgentOnboardDate(this.ddlAgent, this.tempstudentid, this.inputAgenStudentOnboardtDate, 'save')
        if (responseagentOnboardsave) {
          if (responseagentOnboardsave.code === '99') {
            console.log('error save agent onboard date')
          } else {
            console.log('ok save agent onboard date')
          }
        }
        jsonStudent.push(jsonStudentDetials)
        let jsonParent = []
        let jsonParentDetials = {
          PAR_Mode: 'Combined',
          PAR_Father_FirstName: this.inputFatherFirstName,
          PAR_Father_MiddleName: this.inputFatherMiddleName,
          PAR_Father_LastName: this.inputFatherLastName,
          PAR_Father_DOB: this.inputFatherDateofBirth,
          PAR_Father_Phone: this.inputFatherMobileNo,
          PAR_Father_Email: this.inputFatherEmail,
          PAR_Father_IDType: this.ddlFatherIdentificationType,
          PAR_Father_UID: this.inputFatherIdentificationNo,
          PAR_Mother_FirstName: this.inputMotherFirstName,
          PAR_Mother_MiddleName: this.inputMotherMiddleName,
          PAR_Mother_LastName: this.inputMotherLastName,
          PAR_Mother_DOB: this.inputMotherDateofBirth,
          PAR_Mother_Phone: this.inputMotherMobileNo,
          PAR_Mother_Email: this.inputMotherEmail,
          PAR_Mother_IDType: this.ddlMotherIdentificationType,
          PAR_Mother_UID: this.inputMotherIdentificationNo,
          PAR_Father_IDExpDate: this.inputFatherIdentificationNoExpiryDate,
          PAR_Mother_IDExpDate: this.inputMotherIdentificationNoExpiryDate,
          PAR_Father_Loc_Residence_No: this.inputStudentAddress1,
          PAR_Father_Loc_Address1: this.inputStudentAddress2,
          PAR_Father_Loc_Address2: this.inputStudentAddress3,
          PAR_Father_Loc_Postalcode: this.inputStudentPostalCode,
          PAR_Father_Loc_City: this.inputStudentCity,
          PAR_Father_Loc_Country: this.ddlStudentAddressCountry,
          PAR_Mother_Loc_Residence_No: this.inputStudentAddress1,
          PAR_Mother_Loc_Address1: this.inputStudentAddress2,
          PAR_Mother_Loc_Address2: this.inputStudentAddress3,
          PAR_Mother_Loc_City: this.inputStudentCity,
          PAR_Mother_Loc_Country: this.ddlStudentAddressCountry,
          PAR_Mother_Loc_Postalcode: this.inputStudentPostalCode,
          PAR_Father_Race: this.ddlFatherRace,
          PAR_Mother_Race: this.ddlMotherRace,
          PAR_Father_MaritalStatus: this.ddlFatherMaritalStatus,
          PAR_Mother_MaritalStatus: this.ddlMotherMaritalStatus,
          PAR_Father_Working: this.ddlFatherWorking,
          PAR_Mother_Working: this.ddlMotherWorking,
        }

        if (this.ddlFatherWorking === 'Yes') {
          Vue.set(jsonParentDetials, 'PAR_Father_CompanyName', this.inputFatherCompanyName)
          Vue.set(jsonParentDetials, 'PAR_Fat_Comp_Addressee', this.inputFatherCompanyAddresseeName)
          Vue.set(jsonParentDetials, 'PAR_Father_Residence_No', this.inputFatherCompanyAddress1)
          Vue.set(jsonParentDetials, 'PAR_Father_Address1', this.inputFatherCompanyAddress2)
          Vue.set(jsonParentDetials, 'PAR_Father_Address2', this.inputFatherCompanyAddress3)
          Vue.set(jsonParentDetials, 'PAR_Father_City', this.inputFatherCompanyCity)
          Vue.set(jsonParentDetials, 'PAR_Father_Country', this.ddlFatherCompanyCountry)
          Vue.set(jsonParentDetials, 'PAR_Father_PostalCode', this.inputFatherCompanyPostalCode)
          Vue.set(jsonParentDetials, 'PAR_FComp_Email', this.inputFatherCompanyEmail)
          Vue.set(jsonParentDetials, 'PAR_Father_WorkingCommencementDate', this.inputFatherWorkingCommencementDate)
          Vue.set(jsonParentDetials, 'PAR_Father_Occupation', this.inputFatherOccupation)
        }
        if (this.ddlMotherWorking === 'Yes') {
          Vue.set(jsonParentDetials, 'PAR_Mother_CompanyName', this.inputMotherCompanyName)
          Vue.set(jsonParentDetials, 'PAR_Mot_Comp_Addressee', this.inputMotherCompanyAddresseeName)
          Vue.set(jsonParentDetials, 'PAR_Mother_Residence_No', this.inputMotherCompanyAddress1)
          Vue.set(jsonParentDetials, 'PAR_Mother_Address1', this.inputMotherCompanyAddress2)
          Vue.set(jsonParentDetials, 'PAR_Mother_Address2', this.inputMotherCompanyAddress3)
          Vue.set(jsonParentDetials, 'PAR_Mother_City', this.inputMotherCompanyCity)
          Vue.set(jsonParentDetials, 'PAR_Mother_Country', this.ddlMotherCompanyCountry)
          Vue.set(jsonParentDetials, 'PAR_Mother_PostalCode', this.inputMotherCompanyPostalCode)
          Vue.set(jsonParentDetials, 'PAR_MComp_Email', this.inputMotherCompanyEmail)
          Vue.set(jsonParentDetials, 'PAR_Mother_WorkingCommencementDate', this.inputMotherWorkingCommencementDate)
          Vue.set(jsonParentDetials, 'PAR_Mother_Occupation', this.inputMotherOccupation)
        }

        jsonParent.push(jsonParentDetials)
        //allergies list combining into one whole list//
        let allergiesList = []

        //medical
        this.medicationAllergiesListInt.forEach(item => {
          let medicationAllergiesListIntDetials = {
            Item: item.StAllItem,
            Remarks: item.StAllRemarks,
            Type: 'Medical',
          }

          allergiesList.push(medicationAllergiesListIntDetials)
        })

        //food
        this.foodAllergiesListInt.forEach(item => {
          let foodAllergiesListIntDetials = {
            Item: item.StAllItem,
            Remarks: item.StAllRemarks,
            Type: 'Food',
          }

          allergiesList.push(foodAllergiesListIntDetials)
        })
        //allergies list combining into one whole list//

        if (this.lblCreateOrEdit === 'New') {
          const chkStuRes = await DataSource.shared.checkStudentDuplication(
            this.inputStudentFirstName,
            this.inputStudentLastName,
            this.inputStudentDateOfBirth,
            this.inputStudentIdentificationExpiryDate,
            this.inputStudentIdentificationNo,
            this.inputStudentBirthCertificate,
            this.inputStudentIC,
            this.inputStudentPassport,
            this.inputStudentPassportExpiryDate,
          )
          if (chkStuRes) {
            if (chkStuRes.code === '88') {
              window.location.replace('/')
            } else if (chkStuRes.code === '1') {
              const saveStuRes = await DataSource.shared.saveStudent(
                this.selectedFile,
                JSON.stringify(jsonStudent),
                JSON.stringify(jsonParent),
                this.inputFamilyID,
                this.inputFamilyParentID,
                JSON.stringify(allergiesList),
                JSON.stringify(this.studentAuthorizedPickupListInt),
                this.ddlClass,
              )
              if (saveStuRes) {
                if (saveStuRes.code === '88') {
                  window.location.replace('/')
                } else if (saveStuRes.code === '1') {
                  this.$notify({
                    title: 'Success',
                    message: 'Records Successfully Saved',
                    type: 'success',
                  })
                  window.location.replace('/student?id=' + saveStuRes.studentID)
                } else if (saveStuRes.code === '2') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Commencement date out of range',
                  })
                } else {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Save Student Error - Please try again later',
                  })
                }
              }
            } else if (chkStuRes.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'This student is existing',
              })
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Check Student Error - Please try again later',
              })
            }
          }
        } else if (this.lblCreateOrEdit === 'Edit') {
          try {
            const response = await DataSource.shared.updateStudent(
              this.selectedFile,
              this.lblStudentID,
              JSON.stringify(jsonStudent),
              JSON.stringify(allergiesList),
              JSON.stringify(this.studentAuthorizedPickupListInt),
            )
            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '1') {
                this.$notify({
                  title: 'Success',
                  message: 'Records Successfully Edited',
                  type: 'success',
                })
                window.location.replace('/student?id=' + this.lblStudentID)
              } else {
                this.$notify.error({
                  title: 'Error',
                  message: 'Update Student Error - Please try again later',
                })
              }
            }
          } catch (e) {
            this.results = e
          }
        } else {
          //this.$message("Error! Please try again later")
          this.$notify.error({
            title: 'Error',
            message: 'Error! Please try again later',
          })
        }
      } catch (e) {
        this.results = e
        console.log(e)
      }

      this.$vs.loading.close()
    },
    async SearchFamilyID() {
      try {
        if (
          this.$refs.familyIDFamilyNo.value === '' &&
          this.$refs.familyParentFirstName.value === '' &&
          this.$refs.familyParentLastName.value === '' &&
          this.$refs.familyIDStudentName.value === ''
        ) {
          this.$notify.error({
            title: 'Require',
            message: 'Please search by Student Name / Family No / Parent First Name / Parent Last Name',
          })
        } else {
          const response = await DataSource.shared.getRelationship(
            this.$refs.familyIDFamilyNo.value,
            '',
            this.$refs.familyParentFirstName.value,
            this.$refs.familyParentLastName.value,
            this.$refs.familyIDStudentName.value,
          )
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getRelationship error')
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'No Record',
                message: 'No record found',
              })
            } else {
              this.familyIDList = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async CheckParentDup() {
      try {
        if (this.inputMotherFirstName !== '' && this.inputMotherLastName !== '') {
          const response = await DataSource.shared.checkParentDuplication(this.inputMotherFirstName, this.inputMotherLastName, 'Mother')
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '1') {
              this.lblMotherNameDuplicated = false
            } else if (response.code === '2') {
              this.lblMotherNameDuplicated = true
            }
          }
        }

        if (this.inputFatherFirstName !== '' && this.inputFatherLastName !== '') {
          const response = await DataSource.shared.checkParentDuplication(this.inputFatherFirstName, this.inputFatherLastName, 'Father')
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '1') {
              this.lblFatherNameDuplicated = false
            } else if (response.code === '2') {
              this.lblFatherNameDuplicated = true
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async StatusAction() {
      try {
        if (this.ddlChangeStatusTo === '' || this.ddlChangeStatusTo === null) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select status to change',
          })
        } else if (this.ddlChangeStatusTo === 'Rejected') {
          this.ddlRejectReason = ''
          this.inputRejectDate = ''

          this.$refs.studentStatusPopOver.doClose()
          this.$refs.rejectStatusShowModal.show()
        } else if (this.ddlChangeStatusTo === 'Active') {
          this.ChangeStatus()
        } else {
          this.openChangeStatusConfirmModel()
        }
      } catch (e) {
        this.results = e
      }
    },
    async ChangeStatus() {
      try {
        if (this.ddlChangeStatusTo === 'Rejected' && (this.ddlRejectReason === '' || this.inputRejectDate === '')) {
          this.$notify({
            title: 'Required',
            message: 'Please select rejected reason and date',
          })
        } else {
          const response = await DataSource.shared.updateStudentStatus(this.lblStudentID, this.ddlChangeStatusTo, this.ddlRejectReason, this.inputRejectDate)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Successfully change status',
                type: 'success',
              })
              this.ddlChangeStatusToList = []
              this.LoadStudentParentInfo()
              this.$refs.changeStatusConfirmShowModal.hide()
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    openChangeStatusConfirmModel() {
      this.$refs.rejectStatusShowModal.hide()
      this.$refs.changeStatusConfirmShowModal.show()
    },
    async Validation() {
      try {
        this.$v.validationGroupSave.$touch()
        this.activeTab = 'Student'
        if (this.$v.validationGroupSave.$error) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in all * fields & at least one of ** field',
          })
          return
        }

        const firstCommencementDate_array = this.inputFirstCommencementDate.split('/')
        const studentDateOfBirth_array = this.inputStudentDateOfBirth.split('/')
        let firstCommencementDate = new Date(firstCommencementDate_array[2], firstCommencementDate_array[1] - 1, firstCommencementDate_array[0])
        let studentDateOfBirth = new Date(studentDateOfBirth_array[2], studentDateOfBirth_array[1] - 1, studentDateOfBirth_array[0])
        if (studentDateOfBirth > firstCommencementDate) {
          this.$notify.error({
            title: 'Error',
            message: 'Commencement Date cannot early Date of Birth',
          })
          return
        }

        this.Save()
      } catch (e) {
        this.results = e
      }
    },
    activeTabHappen(tab, event) {
      if (this.lblCreateOrEdit === 'New') {
        if (this.activeTab === 'Student') {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = false
        } else if (this.activeTab === 'Parents') {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
        } else if (this.activeTab === 'emergencyContact') {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
        } else if (this.activeTab === 'Addresses') {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
        } else {
          this.btnSave = true
          this.btnNext = false
          this.btnPrevious = true
        }
      }
    },
    hubspotActiveTabHappen(tab, event) {
      console.log(tab, event)
    },
    async studentPromoteAction(PK_Semester_ID, PK_Course_ID, PK_Class_ID) {
      this.tempPK_Semester_ID = PK_Semester_ID
      this.tempPK_Course_ID = PK_Course_ID
      this.tempPK_Class_ID = PK_Class_ID
    },
    async promoteStudents() {
      let studentID = this.$route.query.id

      if (this.tempPK_Semester_ID !== null && this.tempPK_Course_ID !== null && this.tempPK_Class_ID !== null) {
        await DataSource.shared.saveStudentPromotions(studentID, this.tempPK_Semester_ID, this.tempPK_Course_ID, this.tempPK_Class_ID).then(result => {
          if (result && result.code === '1') {
            this.$notify({
              title: 'Success',
              message: 'Students Promoted',
              type: 'success',
            })
            this.LoadStudentParentInfo()
          } else if (result && result.code === '2') {
            this.$notify({
              title: 'Student Exceeded',
              message: 'Number of students assign to this class have excceded max number of class',
              type: 'success',
            })
          }
        })
      }
    },
    async CancelUseFamilyNo() {
      try {
        this.divParent = true
        this.inputFamilyID = ''
        this.inputFamilyParentID = ''
        this.familyParentFatherName = ''
        this.familyParentFatherContact = ''
        this.familyParentMotherName = ''
        this.familyParentMotherContact = ''

        this.familyParentFatherCompanyCountry = ''
        this.familyParentFatherCompanyPostalCode = ''
        this.familyParentFatherCompanyAddress1 = ''
        this.familyParentFatherCompanyAddress2 = ''
        this.familyParentFatherCompanyAddress3 = ''
        this.familyParentFatherCompanyCity = ''
        this.familyParentFatherCompanyEmail = ''
        this.familyParentMotherCompanyCountry = ''
        this.familyParentMotherCompanyPostalCode = ''
        this.familyParentMotherCompanyAddress1 = ''
        this.familyParentMotherCompanyAddress2 = ''
        this.familyParentMotherCompanyAddress3 = ''
        this.familyParentMotherCompanyCity = ''
        this.familyParentMotherCompanyEmail = ''
        this.familyParentFatherCountry = ''
        this.familyParentFatherPostalCode = ''
        this.familyParentFatherAddress1 = ''
        this.familyParentFatherAddress2 = ''
        this.familyParentFatherAddress3 = ''
        this.familyParentFatherCity = ''
        this.familyParentFatherEmail = ''
        this.familyParentMotherCountry = ''
        this.familyParentMotherPostalCode = ''
        this.familyParentMotherAddress1 = ''
        this.familyParentMotherAddress2 = ''
        this.familyParentMotherAddress3 = ''
        this.familyParentMotherCity = ''
        this.familyParentMotherEmail = ''

        this.stuCorAddCopy = false
        this.ddlCopyAddToStuCorAdd = ''
        this.copyAddressList = this.copyAddressList.filter(item => item !== "Father's Company Address")
        this.copyAddressList = this.copyAddressList.filter(item => item !== "Mother's Company Address")
        this.copyAddressList = this.copyAddressList.filter(item => item !== "Father's Address")
        this.copyAddressList = this.copyAddressList.filter(item => item !== "Mother's Address")
        this.ParentCompanyAddressShow('Father')
        this.ParentCompanyAddressShow('Mother')
      } catch (e) {
        this.results = e
      }
    },
    async uploadStudentProfileImg() {
      try {
        this.$refs.file.click()
      } catch (e) {
        this.results = e
      }
    },
    previewImgStudentProfile: function (event) {
      try {
        var input = event.target
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.imgStudentProfile = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.selectedFile = event.target.files
        }
      } catch (e) {
        this.results = e
      }
    },
    async onChangeNationalityBirthPlace() {
      try {
        if (this.ddlStudentNationality === '' && this.ddlStudentBirthPlace === '') {
          this.finShowHide = false
          this.birthcertShowHide = false
          this.icShowHide = false
          this.passportShowHide = false
        } else if (
          (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace === '') ||
          (this.ddlStudentNationality === '' && this.ddlStudentBirthPlace === 'Singapore') ||
          (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace === 'Singapore')
        ) {
          this.finShowHide = false
          this.inputStudentIdentificationNo = ''
          this.inputStudentIdentificationExpiryDate = ''

          this.birthcertShowHide = true

          this.icShowHide = true

          if (this.ddlStudentNationality === 'Singaporean') {
            this.passportShowHide = false
            this.inputStudentPassport = ''
            this.inputStudentPassportExpiryDate = ''
          } else {
            this.passportShowHide = true
          }
        } else if (this.ddlStudentNationality !== 'Singaporean' && this.ddlStudentBirthPlace === 'Singapore') {
          this.finShowHide = true

          this.birthcertShowHide = true

          this.icShowHide = false
          this.inputStudentIC = ''

          this.passportShowHide = true
        } else if (this.ddlStudentNationality === 'Singaporean' && this.ddlStudentBirthPlace !== 'Singapore') {
          this.finShowHide = false
          this.inputStudentIdentificationNo = ''
          this.inputStudentIdentificationExpiryDate = ''

          this.birthcertShowHide = false
          ;((this.inputStudentBirthCertificate = ''), (this.icShowHide = true))

          this.passportShowHide = false
          this.inputStudentPassport = ''
          this.inputStudentPassportExpiryDate = ''
        } else if (this.ddlStudentNationality !== 'Singaporean' && this.ddlStudentBirthPlace !== 'Singapore') {
          this.finShowHide = true

          this.birthcertShowHide = false
          ;((this.inputStudentBirthCertificate = ''), (this.icShowHide = false))
          this.inputStudentIC = ''

          this.passportShowHide = true
        }

        if (this.ddlStudentNationality === 'Singaporean') {
          this.ddlStudentSubsidyShow = true
        } else {
          this.ddlStudentSubsidy = []
          this.ddlStudentSubsidyShow = false
        }
      } catch (e) {
        this.results = e
      }
    },
    async EditParentLink() {
      window.location.replace('/parent?id=' + this.lblParentID)
    },
    async GetGoogleAPI(postcodeModel) {
      try {
        if (postcodeModel === 'inputStudentPostalCode' && this.inputStudentPostalCode !== '' && this.inputStudentAddress1 === '') {
          const response = await DataSource.shared.getStudentAddressGoogleAPI(this.inputStudentPostalCode, this.ddlStudentAddressCountry)
          if (response !== '') {
            this.inputStudentAddress1 = response
          }
        } else if (
          postcodeModel === 'inputStudentCorrespondancePostalCode' &&
          this.inputStudentCorrespondancePostalCode !== '' &&
          this.inputStudentCorrespondanceAddress1 === ''
        ) {
          const response = await DataSource.shared.getStudentAddressGoogleAPI(
            this.inputStudentCorrespondancePostalCode,
            this.ddlStudentAddressCorrespondanceCountry,
          )
          if (response !== '') {
            this.inputStudentCorrespondanceAddress1 = response
          }
        }

        this.onchangeCopyAdd()
      } catch (e) {
        this.results = e
      }
    },
    async GetOneMapAPI(postcodeModel) {
      try {
        if (postcodeModel === 'inputStudentPostalCode' && this.inputStudentPostalCode !== '' && this.inputStudentAddress1 === '') {
          if (this.ddlStudentAddressCountry === 'Singapore') {
            //to take out S in front of postcode
            let postcode = this.inputStudentPostalCode
            if (postcode.substring(0, 1).toUpperCase() === 'S') {
              postcode = postcode.substring(1, postcode.length)
            }
            //to take out S in front of postcode

            const response = await DataSource.shared.oneMapCommonApiSearchVal(postcode)
            if (response.found > 0) {
              this.inputStudentAddress1 = response.results[0].BLK_NO.trim() + ' ' + response.results[0].ROAD_NAME.trim()
            }
          }
        } else if (
          postcodeModel === 'inputStudentCorrespondancePostalCode' &&
          this.inputStudentCorrespondancePostalCode !== '' &&
          this.inputStudentCorrespondanceAddress1 === ''
        ) {
          if (this.ddlStudentAddressCorrespondanceCountry === 'Singapore') {
            //to take out S in front of postcode
            let postcode = this.inputStudentCorrespondancePostalCode
            if (postcode.substring(0, 1).toUpperCase() === 'S') {
              postcode = postcode.substring(1, postcode.length)
            }
            //to take out S in front of postcode

            const response = await DataSource.shared.oneMapCommonApiSearchVal(postcode)
            if (response.found > 0) {
              this.inputStudentCorrespondanceAddress1 = response.results[0].BLK_NO.trim() + ' ' + response.results[0].ROAD_NAME.trim()
            }
          }
        }

        this.onchangeCopyAdd()
      } catch (e) {
        this.results = e
      }
    },
    async ReferSiblingReligionLanguage(parentID) {
      try {
        const response = await DataSource.shared.getStudentSiblingReligionLanguages(parentID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.ddlStudentAdditionalLanguage = response.Table[0].St_Mother_Tongue
            this.inputStudentFirstLanguageSpoken = response.Table[0].St_AdditionalLanguage
            this.inputSecondLanguageSpoken = response.Table[0].St_SecondLanguageSpoken

            //address
            this.ddlStudentAddressCountry = response.Table[0].st_prm_add_country
            this.inputStudentPostalCode = response.Table[0].st_prm_add_pstcode
            this.inputStudentAddress1 = response.Table[0].st_prm_add_blkNo
            this.inputStudentAddress2 = response.Table[0].st_prm_add_flrNo
            this.inputStudentAddress3 = response.Table[0].st_prm_add_BlgName
            this.inputStudentCity = response.Table[0].st_prm_add_stName

            this.ddlStudentAddressCorrespondanceCountry = response.Table[0].st_corr_add_country
            this.inputStudentCorrespondancePostalCode = response.Table[0].st_corr_add_pstcode
            this.inputStudentCorrespondanceAddress1 = response.Table[0].st_corr_add_blkNo
            this.inputStudentCorrespondanceAddress2 = response.Table[0].st_corr_add_flrNo
            this.inputStudentCorrespondanceAddress3 = response.Table[0].st_corr_add_BlgName
            this.inputStudentCorrespondanceCity = response.Table[0].st_corr_add_stName
            //address
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async onchangeCopyAdd() {
      this.stuCorAddCopy = true
      this.stuCorEmailAddCopy = true

      if (this.ddlCopyAddToStuCorAdd === "Student's Local Residential Address") {
        this.ddlStudentAddressCorrespondanceCountry = this.ddlStudentAddressCountry
        this.inputStudentCorrespondancePostalCode = this.inputStudentPostalCode
        this.inputStudentCorrespondanceAddress1 = this.inputStudentAddress1
        this.inputStudentCorrespondanceAddress2 = this.inputStudentAddress2
        this.inputStudentCorrespondanceAddress3 = this.inputStudentAddress3
        this.inputStudentCorrespondanceCity = this.inputStudentCity
        this.stuCorEmailAddCopy = false
      } else if (this.ddlCopyAddToStuCorAdd === "Father's Company Address") {
        if (this.inputFamilyID === '') {
          this.ddlStudentAddressCorrespondanceCountry = this.ddlFatherCompanyCountry
          this.inputStudentCorrespondancePostalCode = this.inputFatherCompanyPostalCode
          this.inputStudentCorrespondanceAddress1 = this.inputFatherCompanyAddress1
          this.inputStudentCorrespondanceAddress2 = this.inputFatherCompanyAddress2
          this.inputStudentCorrespondanceAddress3 = this.inputFatherCompanyAddress3
          this.inputStudentCorrespondanceCity = this.inputFatherCompanyCity
          this.inputStudentEmail = this.inputFatherCompanyEmail
        } else {
          this.ddlStudentAddressCorrespondanceCountry = this.familyParentFatherCompanyCountry
          this.inputStudentCorrespondancePostalCode = this.familyParentFatherCompanyPostalCode
          this.inputStudentCorrespondanceAddress1 = this.familyParentFatherCompanyAddress1
          this.inputStudentCorrespondanceAddress2 = this.familyParentFatherCompanyAddress2
          this.inputStudentCorrespondanceAddress3 = this.familyParentFatherCompanyAddress3
          this.inputStudentCorrespondanceCity = this.familyParentFatherCompanyCity
          this.inputStudentEmail = this.familyParentFatherCompanyEmail
        }
      } else if (this.ddlCopyAddToStuCorAdd === "Mother's Company Address") {
        if (this.inputFamilyID === '') {
          this.ddlStudentAddressCorrespondanceCountry = this.ddlMotherCompanyCountry
          this.inputStudentCorrespondancePostalCode = this.inputMotherCompanyPostalCode
          this.inputStudentCorrespondanceAddress1 = this.inputMotherCompanyAddress1
          this.inputStudentCorrespondanceAddress2 = this.inputMotherCompanyAddress2
          this.inputStudentCorrespondanceAddress3 = this.inputMotherCompanyAddress3
          this.inputStudentCorrespondanceCity = this.inputMotherCompanyCity
          this.inputStudentEmail = this.inputMotherCompanyEmail
        } else {
          this.ddlStudentAddressCorrespondanceCountry = this.familyParentMotherCompanyCountry
          this.inputStudentCorrespondancePostalCode = this.familyParentMotherCompanyPostalCode
          this.inputStudentCorrespondanceAddress1 = this.familyParentMotherCompanyAddress1
          this.inputStudentCorrespondanceAddress2 = this.familyParentMotherCompanyAddress2
          this.inputStudentCorrespondanceAddress3 = this.familyParentMotherCompanyAddress3
          this.inputStudentCorrespondanceCity = this.familyParentMotherCompanyCity
          this.inputStudentEmail = this.familyParentMotherCompanyEmail
        }
      } else if (this.ddlCopyAddToStuCorAdd === "Father's Address") {
        if (this.inputFamilyID !== '') {
          this.ddlStudentAddressCorrespondanceCountry = this.familyParentFatherCountry
          this.inputStudentCorrespondancePostalCode = this.familyParentFatherPostalCode
          this.inputStudentCorrespondanceAddress1 = this.familyParentFatherAddress1
          this.inputStudentCorrespondanceAddress2 = this.familyParentFatherAddress2
          this.inputStudentCorrespondanceAddress3 = this.familyParentFatherAddress3
          this.inputStudentCorrespondanceCity = this.familyParentFatherCity
          this.inputStudentEmail = this.familyParentFatherEmail
        } else {
          this.stuCorAddCopy = false
          this.stuCorEmailAddCopy = false
        }
      } else if (this.ddlCopyAddToStuCorAdd === "Mother's Address") {
        if (this.inputFamilyID !== '') {
          this.ddlStudentAddressCorrespondanceCountry = this.familyParentMotherCountry
          this.inputStudentCorrespondancePostalCode = this.familyParentMotherPostalCode
          this.inputStudentCorrespondanceAddress1 = this.familyParentMotherAddress1
          this.inputStudentCorrespondanceAddress2 = this.familyParentMotherAddress2
          this.inputStudentCorrespondanceAddress3 = this.familyParentMotherAddress3
          this.inputStudentCorrespondanceCity = this.familyParentMotherCity
          this.inputStudentEmail = this.familyParentMotherEmail
        } else {
          this.stuCorAddCopy = false
          this.stuCorEmailAddCopy = false
        }
      } else {
        this.stuCorAddCopy = false
        this.stuCorEmailAddCopy = false
      }
    },
    promotionResult(result) {
      if (result === 'true') {
        this.$notify({
          title: 'Success',
          message: 'Records Successfully Saved',
          type: 'success',
        })
        window.location.replace('/student?id=' + this.lblStudentID)
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Error promotion',
        })
      }
    },
    checkSiblingEditButton(value) {
      if (value === Cookies.get('schoolSession')) {
        return true
      } else {
        return false
      }
    },
    editSibling(schID, siblingStudentID) {
      if (schID === Cookies.get('schoolSession')) {
        window.location.replace('/student?id=' + siblingStudentID)
      } else {
        this.$notify.error({
          title: 'Error',
          message: `You are not authorize to edit this student's info`,
        })
      }
    },
    async BindTransferSchool() {
      try {
        const reGloUniCode = await DataSource.shared.getGlobalUniversityCode()
        if (reGloUniCode) {
          if (reGloUniCode.code === '88') {
            window.location.replace('/')
          } else if (reGloUniCode.code === '99') {
            console.log('getAllActiveSchool Error')
          } else {
            let globalUniversityCode = reGloUniCode.GlobalUniversityCode

            const response = await DataSource.shared.getAllActiveSchool('', '')
            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else {
                this.transferSchoolListResponse = response.Table
                this.transferSchoolListResponse.forEach(m => {
                  if (m.PK_SCH_ID !== 'SCH20120000001') {
                    this.transferSchoolList.push(m)
                  }
                })
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async transferSave() {
      try {
        if (
          this.inputTransferSchoolEffDate === '' ||
          this.inputTransferSchoolEffDate === null ||
          this.inputTransferSchoolRemark === '' ||
          this.ddlTransferSchool === ''
        ) {
          this.$notify.error({
            title: 'Require',
            message: 'Required All Fields...',
          })
        } else {
          this.$vs.loading()
          const response = await DataSource.shared.saveTransferSchoolAllowToday(
            this.lblStudentID,
            this.ddlTransferSchool,
            this.inputTransferSchoolRemark,
            this.inputTransferSchoolEffDate,
            this.referralTransferMode,
          )
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Commencement Date cannot be less than today!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Invalid Action',
                message: 'Student cannot transfer due to other pending action',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Error',
                message: 'Cannot transfer to same school!',
              })
            } else if (response.code === '5') {
              this.$notify.error({
                title: 'Error',
                message: 'Cannot transfer without active year level!',
              })
            } else {
              this.$notify({
                title: 'Success',
                message: 'Student has been provisionally transfered!',
                type: 'success',
              })
              this.hideModal()
            }
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async WithdrawSave() {
      try {
        var withdrawObj = {
          studentID: this.lblStudentID,
          GRD_Remarks: this.ddlMainReason,
          GRD_Remarks1: this.ddlReason1,
          GRD_Remarks2: this.ddlReason2,
          GRD_Remarks3: this.ddlReason3,
          GRD_Date: this.inputWithdrawalDate,
          GRD_Withdraw_Date: this.inputWithdrawalDate,
          GRD_SchoolName: this.ddlInternationalSchool,
        }
        //check student withdraw status
        if (this.lblCurrentStatus === 'Withdrawn') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot Withdraw student who is already Withdrawn',
          })
        } else if (this.ddlMainReason === '' || this.ddlMainReason === null || this.ddlMainReason === undefined) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select withdraw reason',
          })
        } else if (this.inputWithdrawalDate === '' || this.inputWithdrawalDate === null || this.inputWithdrawalDate === undefined) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select datetime',
          })
        } else {
          const response = await DataSource.shared.saveStudentWithdraw(JSON.stringify(withdrawObj))

          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Student Withdraw Error!',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'Invalid Action',
              message: 'Student cannot withdraw due to other pending action',
            })
          } else if (response.code === '3') {
            this.$notify.error({
              title: 'Invalid Date',
              message: 'Withdraw Date out of range',
            })
          } else if (response.code === '1') {
            this.$notify({
              title: 'Success',
              message: 'Withdraw Successful',
              type: 'success',
            })
            window.location.replace('/student?id=' + this.lblStudentID)
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async showStudentDocumentModal() {
      this.$vs.loading()
      try {
        this.studentFileListInt = []
        this.studentDocumentModel = 'Select Your File'

        const response = await DataSource.shared.getStudentDocument(this.lblStudentID, 'DOCUMENT')

        if (response) {
          if (response.code === '99') {
            console.log('getStudentDocument: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentDocument: No record!')
          } else {
            this.studentFileListInt = response.Table
          }
        }

        this.$refs.uploadDocumentShowModal.show()
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    studentDocumentName() {
      for (let file of event.target.files) {
        this.studentDocumentModel = file.name
      }
    },
    studentImmunizationName(event) {
      for (let file of event.target.files) {
        this.studentImmunizationModel = file.name
      }
    },
    studentMeName(event) {
      for (let file of event.target.files) {
        this.studentMeModel = file.name
      }
    },
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
    async uploadStudentDocument() {
      try {
        if (this.$refs.studentDocument.files.length === 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select file!',
          })
        } else if (this.inputStudentFileDescription === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in file description!',
          })
        } else {
          this.uploadisLoading = true

          await this.sleep(500)
          const response = await DataSource.shared.saveStudentDocument(
            this.$refs.studentDocument.files,
            this.lblStudentID,
            this.inputStudentFileDescription,
            'Upload Student Documents',
            'Primary',
          )

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No files being upload!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Error',
                message: 'Upload files error! Please try again',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid file format',
              })
            } else if (response.code === '1') {
              this.inputStudentFileDescription = ''
              this.studentFileListInt = []
              this.$refs.studentDocument.value = null

              this.$notify({
                title: 'Success',
                message: 'File Successfuly saved!',
                type: 'success',
              })
              this.studentDocumentModel = 'Select Your File'
              this.showStudentDocumentModal()
            }
            this.uploadisLoading = false
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deleteStudentDocument(studentFilesID) {
      try {
        const response = await DataSource.shared.updateStudentDocument(studentFilesID, 'DELETE')

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error!',
            })
          } else if (response.code === '1') {
            this.inputStudentFileDescription = ''
            this.studentFileListInt = []
            this.$notify({
              title: 'Success',
              message: 'File Deleted!',
              type: 'success',
            })
            if (this.uploadDocumentShowModal === true) {
              this.showStudentDocumentModal()
            } else if (this.uploadImmunizationRecordsShowModal === true) {
              this.showImmunizationRecordsModal()
            } else if (this.uploadAllAboutMeShowModal === true) {
              this.showAllAboutMeModal()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async studentFileDownload() {
      try {
        let tempStudentFilesID = this.studentDocumentFile.filter(m => m.fileSelected === true)

        if (tempStudentFilesID.length > 0) {
          const response = await DataSource.shared.getStudentDocumentBase64String(tempStudentFilesID[0].PK_SF_ID)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('Get Student Document Base64String: Error')
            } else if (response.code === '2') {
              console.log('Get Student Document Base64String: No Record')
            } else {
              let linkSource = tempStudentFilesID[0].fullFileString
              if (response.Table[0].SF_File) {
                linkSource = 'data:' + response.Table[0].SF_FileType + ';base64,' + response.Table[0].SF_File
              }

              const downloadLink = document.createElement('a')
              const fileName = response.Table[0].SF_File_Description + response.Table[0].SF_FileExt

              downloadLink.href = linkSource
              downloadLink.download = fileName
              downloadLink.click()
            }
          }
        } else {
          this.$notify({
            title: 'Required',
            message: 'Please select File!',
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    fileDownload(response, fileName, fileExt) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName + fileExt)
      document.body.appendChild(link)
      link.click()
    },
    async checkImmunizationRecordsUpload() {
      try {
        const response = await DataSource.shared.getSchoolInfoBySchoolID(Cookies.get('schoolSession'))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('no school found in checkImmunizationRecordsUpload')
          } else {
            if (response.Table[0].SCH_SchoolType.includes('International')) {
              this.immunizationRecordsUpload = true
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async showImmunizationRecordsModal() {
      this.$vs.loading()
      try {
        this.studentFileListInt = []
        this.studentImmunizationModel = 'Select Your File'

        const response = await DataSource.shared.getStudentDocument(this.lblStudentID, 'IMMNUIZATION')

        if (response) {
          if (response.code === '99') {
            console.log('getStudentDocument: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentDocument: No record!')
          } else {
            this.studentFileListInt = response.Table
          }
        }

        this.$refs.uploadImmunizationRecordsShowModal.show()
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async uploadImmunizationRecords() {
      try {
        if (this.$refs.immunizationRecords.files.length === 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select file!',
          })
        } else if (this.inputImmunizationRecordsDescription === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in file description!',
          })
        } else {
          this.uploadisLoading = true

          await this.sleep(500)
          const response = await DataSource.shared.saveStudentDocument(
            this.$refs.immunizationRecords.files,
            this.lblStudentID,
            this.inputImmunizationRecordsDescription,
            'Upload Student Immunization Records',
          )

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No files being upload!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Error',
                message: 'Upload files error! Please try again',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid file format',
              })
            } else if (response.code === '1') {
              this.inputImmunizationRecordsDescription = ''
              this.studentFileListInt = []
              this.$refs.immunizationRecords.value = null

              this.$notify({
                title: 'Success',
                message: 'File Successfuly saved!',
                type: 'success',
              })
              this.studentImmunizationModel = 'Select Your File'
              this.showImmunizationRecordsModal()
            }

            this.uploadisLoading = false
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async showAllAboutMeModal() {
      this.$vs.loading()
      try {
        this.studentFileListInt = []
        this.studentMeModel = 'Select Your File'

        const response = await DataSource.shared.getStudentDocument(this.lblStudentID, 'ALLABOUTME')

        if (response) {
          if (response.code === '99') {
            console.log('getStudentDocument: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentDocument: No record!')
          } else {
            this.studentFileListInt = response.Table
          }
        }

        this.$refs.uploadAllAboutMeShowModal.show()
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async uploadAllAboutMe() {
      try {
        if (this.$refs.allAboutMe.files.length === 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select file!',
          })
        } else if (this.inputAllAboutMeDescription === '') {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill in file description!',
          })
        } else {
          this.uploadisLoading = true

          await this.sleep(500)
          const response = await DataSource.shared.saveStudentDocument(
            this.$refs.allAboutMe.files,
            this.lblStudentID,
            this.inputAllAboutMeDescription,
            'Upload All About Me',
          )

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No files being upload!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Error',
                message: 'Upload files error! Please try again',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid file format',
              })
            } else if (response.code === '1') {
              this.inputAllAboutMeDescription = ''
              this.studentMeModel = 'Select Your File'
              this.studentFileListInt = []
              this.$refs.allAboutMe.value = null
              this.$notify({
                title: 'Success',
                message: 'File Successfuly saved!',
                type: 'success',
              })
              this.showAllAboutMeModal()
            }
            this.uploadisLoading = false
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    ParentCompanyAddressShow(value) {
      if (value === 'Father') {
        if (this.ddlFatherWorking === 'Yes') {
          this.divFatherCompany = true
          this.disFatherCompany = false
          this.copyAddressList.push("Father's Company Address")
        } else {
          this.divFatherCompany = false
          this.disFatherCompany = true
          this.copyAddressList = this.copyAddressList.filter(item => item !== "Father's Company Address")
          if (this.ddlCopyAddToStuCorAdd === "Father's Company Address") {
            this.ddlCopyAddToStuCorAdd = 'Manually Input'
            this.onchangeCopyAdd()
          }
          if (this.ddlStudentPayer === 'Father Company') {
            this.ddlStudentPayer = ''
          }
        }
      } else if (value === 'Mother') {
        if (this.ddlMotherWorking === 'Yes') {
          this.divMotherCompany = true
          this.disMotherCompany = false
          this.copyAddressList.push("Mother's Company Address")
        } else {
          this.divMotherCompany = false
          this.disMotherCompany = true
          this.copyAddressList = this.copyAddressList.filter(item => item !== "Mother's Company Address")
          if (this.ddlCopyAddToStuCorAdd === "Mother's Company Address") {
            this.ddlCopyAddToStuCorAdd = 'Manually Input'
            this.onchangeCopyAdd()
          }
          if (this.ddlStudentPayer === 'Mother Company') {
            this.ddlStudentPayer = ''
          }
        }
      }
    },
    addMedicationAllergiesList() {
      if (this.inputStudentMedicationAllergiesMedication !== '' && this.inputStudentMedicationAllergiesRemarks !== '') {
        let addNewRowList = {
          StAllItem: this.inputStudentMedicationAllergiesMedication,
          StAllRemarks: this.inputStudentMedicationAllergiesRemarks,
        }

        this.medicationAllergiesListInt.push(addNewRowList)

        this.inputStudentMedicationAllergiesMedication = ''
        this.inputStudentMedicationAllergiesRemarks = ''
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Please fill Medication and Remarks',
        })
      }
    },
    addFoodAllergiesList() {
      if (this.ddlStudentFoodAllergiesFood !== '' && this.inputStudentFoodAllergiesRemarks !== '') {
        let addNewRowList = {
          StAllItem: this.ddlStudentFoodAllergiesFood,
          StAllRemarks: this.inputStudentFoodAllergiesRemarks,
        }

        this.foodAllergiesListInt.push(addNewRowList)

        this.ddlStudentFoodAllergiesFood = ''
        this.inputStudentFoodAllergiesRemarks = ''
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Please fill Food and Remarks',
        })
      }
    },
    async checkSchoolIsLocalOrInt() {
      try {
        const response = await DataSource.shared.getSchoolInfoBySchoolID(Cookies.get('schoolSession'))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('no school found in getSchoolInfoBySchoolID')
          } else {
            if (response.Table[0].SCH_SchoolType === 'International' || response.Table[0].SCH_SchoolType === 'Japanese Pre-School') {
              this.isIntSchool = true
            } else if (response.Table[0].SCH_SchoolType === 'International Pre-School') {
              this.isIntPreSchool = true
            } else {
              this.isLocalSchool = true
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    checkStudentAge() {
      if (this.inputStudentDateOfBirth === '' || this.inputStudentDateOfBirth === null) {
        this.disableIC = true
        this.inputStudentIC = ''
      } else {
        //convert dd/mm/yyyy to mm/dd/yyyy for convert into new date to calculate age
        let splittedDate = this.inputStudentDateOfBirth.split('/')
        let bDay = [splittedDate[1], splittedDate[0], splittedDate[2]].join('/')

        //calculate age
        let today = new Date()
        let birthDate = new Date(bDay)
        let age = today.getFullYear() - birthDate.getFullYear()
        let m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }

        if (age >= 16) {
          this.disableIC = false
        } else {
          this.disableIC = true
          this.inputStudentIC = ''
        }
      }

      this.getAutoAssignLevelAcademicYear()
    },
    EnrolledinOtherCenterShow() {
      if (this.ddlStudentEnrolledinOtherCenter === 'No') {
        this.divEnrolledinOtherCenterShow = false
        this.inputStudentEnrolledCenterName = ''
        this.ddlStudentEnrolledCenterType = ''
      } else {
        this.divEnrolledinOtherCenterShow = true
      }
    },
    studentPageVueTourStart() {
      this.activeTab = 'Student'
      this.$tours['StudentPageVueTourName'].start()
      this.windowsSroll(0)
    },
    studentPageVueTourParentTab(tour, nextOrPreviousStep) {
      if (this.divParent === false) {
        if (nextOrPreviousStep === 'Next') {
          this.$tours['StudentPageVueTourName'].currentStep = tour.currentStep + 1
          tour.nextStep()
        } else if (nextOrPreviousStep === 'Previous') {
          this.$tours['StudentPageVueTourName'].currentStep = tour.currentStep - 1
          tour.previousStep()
        }
      } else {
        if (nextOrPreviousStep === 'Next') {
          tour.nextStep()
        } else if (nextOrPreviousStep === 'Previous') {
          tour.previousStep()
        }
      }

      //setTimeout ( () => tour.nextStep(), 2000);
    },
    studentPageVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1

      this.windowsSroll(finalSteps)
    },
    studentPageVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1

      this.windowsSroll(finalSteps)
    },
    windowsSroll(finalSteps) {
      if (finalSteps >= 0 && finalSteps <= 2) {
        this.activeTab = 'Student'
      } else if (finalSteps >= 3 && finalSteps <= 3) {
        this.activeTab = 'Parents'
      } else if (finalSteps >= 4 && finalSteps <= 4) {
        this.activeTab = 'emergencyContact'
      } else if (finalSteps >= 5 && finalSteps <= 7) {
        this.activeTab = 'Addresses'
      } else if (finalSteps >= 8 && finalSteps <= 8) {
        this.activeTab = 'Medical'
      }

      if (finalSteps >= 0 && finalSteps <= 8) {
        this.btnSave = false
        this.btnNext = true
      } else {
        this.btnSave = true
        this.btnNext = false
      }

      if (finalSteps >= 0 && finalSteps <= 2) {
        this.btnPrevious = false
      } else {
        this.btnPrevious = true
      }
    },
    studentPageVueUpdateLevelClassTourStart() {
      this.activeTab = 'Level'
      this.$tours['StudentPageUpdateLevelClassVueTourName'].start()
      this.windowsSrollUpdateLevelClass(0)
    },
    studentPageUpdateLevelClassVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1

      this.windowsSrollUpdateLevelClass(finalSteps)
    },
    studentPageUpdateLevelClassVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1

      this.windowsSrollUpdateLevelClass(finalSteps)
    },
    studentPageUpdateLevelClassVueTourCallBacksPreviousPage() {
      window.location.replace('/student-list?mode=Search&tour=UpdateLevelClass')
    },
    windowsSrollUpdateLevelClass(finalSteps) {
      if (finalSteps >= 0 && finalSteps <= 1) {
        this.activeTab = 'Level'
      }
    },
    ViewParent() {
      window.open('/parent?id=' + this.inputFamilyParentID, '_blank')
    },
    async checkDeferValid(studentID) {
      try {
        const response = await DataSource.shared.checkDeferActionValid(studentID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '1') {
            this.deferValid = true
          } else {
            this.deferValid = false
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async SaveDefer() {
      try {
        if (this.inputDeferDate === '' || this.inputDeferDate === null) {
          this.$notify({
            title: 'Error',
            message: 'Please select defer date',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.setDeferDate(this.lblStudentID, this.inputDeferDate)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Save Deffer Error!',
              })
            } else if (response.code === '2') {
              this.$notify({
                title: 'Error',
                message: 'Defer date out of academic year date range...',
              })
            } else if (response.code === '3') {
              this.$notify({
                title: 'Error',
                message: 'Student current academic year is not active...',
              })
            } else if (response.code === '1') {
              this.$notify({
                title: 'Done',
                message: 'Successfully Saved!',
              })

              this.inputFirstCommencementDate = response.newCommencementDate
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async checkLevelOrder(studentID) {
      try {
        const response = await DataSource.shared.checkCourseOrderByLevelIDStudentID('', studentID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('checkCourseOrderByLevelIDStudentID error')
          } else {
            if (response.Table[0].HighestLevel === 'Yes') {
              this.highestLevel = true
            } else {
              this.highestLevel = false
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    showTransferModal(value) {
      if (value === 'Yes') {
        this.referralTransferModeTitle = 'Referral Transfer'
      } else {
        this.referralTransferModeTitle = 'Transfer'
      }

      this.referralTransferMode = value
      this.$refs.transferShowModal.show()
    },
    async getAutoAssignLevelAcademicYear() {
      try {
        this.currentLevelClassList = []
        this.ddlClass = ''

        if (
          this.lblCreateOrEdit === 'New' &&
          this.inputStudentDateOfBirth !== null &&
          this.inputStudentDateOfBirth !== '' &&
          this.inputFirstCommencementDate !== null &&
          this.inputFirstCommencementDate !== ''
        ) {
          const response = await DataSource.shared.getAutoAssignLevelAcademicYear(this.inputFirstCommencementDate, this.inputStudentDateOfBirth)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getAutoAssignLevelAcademicYear Error!')
            } else {
              this.autoLevel = response.Table[0].level

              //get class
              const response2 = await DataSource.shared.getClassBySemesterLevel(response.Table[0].levelID, response.Table[0].academicYearID)
              if (response2.code === '88') {
                window.location.replace('/')
              } else if (response2.code === '99') {
                console.log('getAutoAssignLevelAcademicYear Error!')
              } else if (response2.code === '3') {
                console.log('getAutoAssignLevelAcademicYear No Record!')
              } else {
                //add a empty class for user to remove
                let tempRow = {
                  ClassID: '',
                  ClassName: '',
                  ClassBatch: '',
                }

                this.currentLevelClassList.push(tempRow)

                response2.Table.forEach(m => {
                  let tempRow = {
                    ClassID: m.PK_Class_ID,
                    ClassName: m.CLS_ClassName,
                    ClassBatch: m.CLS_Batch,
                  }

                  this.currentLevelClassList.push(tempRow)
                })
                //add a empty class for user to remove
              }
              //get class
            }
          }
        } else {
          this.autoLevel = ''
        }
      } catch (e) {
        this.results = e
      }
    },
    async studentEmailAction(mode) {
      try {
        if (this.resetEmailPasswordManualPasswordCheckBox && this.resetEmailPasswordManualPassword === '') {
          this.$notify({
            title: 'Required',
            message: 'Please key in Password!',
          })
        } else if (this.resetEmailPasswordManualPasswordCheckBox && this.resetEmailPasswordManualPassword.length < 8) {
          this.$notify({
            title: 'Required',
            message: 'Password Length must 8 and above!',
          })
        } else {
          this.$vs.loading()

          let password

          if (this.resetEmailPasswordManualPasswordCheckBox && mode === 'Reset') {
            password = this.resetEmailPasswordManualPassword
          } else {
            password = ''
          }

          const response = await DataSource.shared.studentEmailActionManualPassword(mode, this.lblStudentIndexNo, password)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Email Action Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'Email Action Error!',
              })
            } else if (response.code === '3') {
              if (mode === 'Create') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Email is existing!',
                })
              } else if (mode === 'Delete') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Email is not existing!',
                })
              }
            } else {
              if (mode === 'Create') {
                this.$notify({
                  title: 'Success',
                  message: 'Email successfully created!',
                })

                this.inputStudentSchoolEmailPassword = response.emailPassword
                this.inputStudentSchoolEmail = response.emailAddress
              } else if (mode === 'Delete') {
                this.$notify({
                  title: 'Success',
                  message: 'Email successfully deleted!',
                })

                this.inputStudentSchoolEmailPassword = ''
                this.inputStudentSchoolEmail = ''
              } else if (mode === 'Reset') {
                this.$notify({
                  title: 'Success',
                  message: 'Email password successfully reseted!',
                })

                this.resetEmailPassword = false

                this.inputStudentSchoolEmailPassword = response.emailPassword
                this.inputStudentSchoolEmail = response.emailAddress
              }
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getHubSpotDetails(dealID) {
      try {
        this.hubSpotID = dealID

        const response = await DataSource.shared.getHubSpotDetails(dealID)
        if (response) {
          //student info
          if (response.deal.properties) {
            if (response.deal.properties.hasOwnProperty('child_name_sw')) {
              this.inputStudentFirstName = response.deal.properties.child_name_sw.value
            }
            if (response.deal.properties.hasOwnProperty('deal_last_name')) {
              this.inputStudentLastName = response.deal.properties.deal_last_name.value
            }
            if (response.deal.properties.hasOwnProperty('commencement_date')) {
              this.inputFirstCommencementDate = moment(response.deal.properties.commencement_date.value, 'x').format('DD/MM/YYYY')
            }
            if (response.deal.properties.hasOwnProperty('n1stdob')) {
              this.inputStudentDateOfBirth = moment(response.deal.properties.n1stdob.value, 'x').format('DD/MM/YYYY')
            }

            this.checkStudentAge() //to check age for ic and show level
          }

          if (response.contact) {
            if (response.contact[0].properties.hasOwnProperty('youraddress')) {
              this.inputStudentAddress1 = response.contact[0].properties.youraddress.value
            }
            if (response.contact[0].properties.hasOwnProperty('zip')) {
              this.inputStudentPostalCode = response.contact[0].properties.zip.value
            }
            if (response.contact[0].properties.hasOwnProperty('contactus_country')) {
              this.ddlStudentAddressCountry = response.contact[0].properties.contactus_country.value
            }
            if (response.contact[0].properties.hasOwnProperty('child_s_nationality_middleton')) {
              this.ddlStudentNationality = response.contact[0].properties.child_s_nationality_middleton.value
              this.onChangeNationalityBirthPlace()
            }
          }
          //student info

          //parent info
          let foundParent = true
          let emailList = []

          response.contact.forEach(m => {
            let newRow = {
              Email: m.properties.email.value,
            }
            emailList.push(newRow)
          })

          if (emailList.length > 0) {
            const checkParentsEmails = await DataSource.shared.getParent('', '', JSON.stringify(emailList))
            if (checkParentsEmails) {
              if (checkParentsEmails.code === '99') {
                console.log('checkParentsEmails: Error!')
              } else if (checkParentsEmails.code === '88') {
                window.location.replace('/')
              } else if (checkParentsEmails.code === '2') {
                foundParent = false
                console.log('HubSpot no parent email found...')
              } else {
                foundParent = true

                this.inputFamilyID = checkParentsEmails.Table[0].PAR_Family_Number
                this.inputFamilyParentID = checkParentsEmails.Table[0].PAR_ID
                this.divParent = false
              }
            }
          }

          if (foundParent === false) {
            //set parent contact id
            let fatherContactID = ''
            let montherContactID = ''

            response.contact.forEach(m => {
              if (m.properties.hasOwnProperty('relationship')) {
                if (fatherContactID === '' && m.properties.relationship.value === 'Father') {
                  fatherContactID = m.vid
                } else if (montherContactID === '' && m.properties.relationship.value === 'Mother') {
                  montherContactID = m.vid
                }
              }
            })

            if (fatherContactID === '') {
              response.contact.forEach(m => {
                if (m.properties.hasOwnProperty('relationship')) {
                  if (
                    fatherContactID === '' &&
                    m.properties.relationship.value !== 'Guardian' &&
                    m.properties.relationship.value !== 'Mother' &&
                    m.vid !== montherContactID
                  ) {
                    fatherContactID = m.vid
                  }
                } else {
                  if (fatherContactID === '' && m.vid !== montherContactID) {
                    fatherContactID = m.vid
                  }
                }
              })
            }

            if (montherContactID === '') {
              response.contact.forEach(m => {
                if (m.properties.hasOwnProperty('relationship')) {
                  if (
                    montherContactID === '' &&
                    m.properties.relationship.value !== 'Guardian' &&
                    m.properties.relationship.value !== 'Father' &&
                    m.vid !== fatherContactID
                  ) {
                    montherContactID = m.vid
                  }
                } else {
                  if (montherContactID === '' && m.vid !== fatherContactID) {
                    montherContactID = m.vid
                  }
                }
              })
            }
            //set parent contact id

            //insert to parent info to input
            if (fatherContactID !== '') {
              response.contact.forEach(m => {
                if (m.vid === fatherContactID) {
                  this.inputFatherFirstName = m.properties.firstname.value
                  this.inputFatherLastName = m.properties.lastname.value
                  this.inputFatherMobileNo = m.properties.phone.value
                  this.inputFatherEmail = m.properties.email.value
                }
              })
            }

            if (montherContactID !== '') {
              response.contact.forEach(m => {
                if (m.vid === montherContactID) {
                  this.inputMotherFirstName = m.properties.firstname.value
                  this.inputMotherLastName = m.properties.lastname.value
                  this.inputMotherMobileNo = m.properties.phone.value
                  this.inputMotherEmail = m.properties.email.value
                }
              })
            }
            //insert to parent info to input

            this.CheckParentDup() //to check parent duplication
          }
          //parent info
        }
      } catch (e) {
        this.results = e
      }
    },
    async getStudentHubSpotDetials() {
      try {
        const response = await DataSource.shared.getStudentHubSpotDetials(this.lblStudentID, this.hubSpotID)
        if (response) {
          if (response.code === '99') {
            console.log('getStudentHubSpotDetials: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            this.studentHubSpotAll = []
            console.log('getStudentHubSpotDetials: No record!')
          } else {
            this.studentHubSpotAll = response

            response.Details.forEach(m => {
              if (m.HsdType === 'NOTE') {
                this.hubspotNoteTabDetials = true
              } else if (m.HsdType === 'TASK') {
                this.hubspotTaskTabDetials = true
              } else if (m.HsdType === 'EMAIL' || m.HsdType === 'INCOMING_EMAIL') {
                this.hubspotEmailTabDetials = true
              } else if (m.HsdType === 'CALL') {
                this.hubspotCallTabDetials = true
              } else if (m.HsdType === 'MEETING') {
                this.hubspotMeetingTabDetials = true
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    gethubSpotFirstEmailInThread(hsdID) {
      let result = ''

      this.studentHubSpotAll.EmailThread.forEach(m => {
        if (m.HsdID === hsdID) {
          if (m.EmaiContent !== '') {
            result = m.EmaiContent
          } else {
            result = '<div>Tracking data is not available for this email</div>'
          }
        }
      })

      return result
    },
    gethubSpotAttachmentLink(hsdID) {
      let result = []

      this.studentHubSpotAll.Item.forEach(m => {
        if (m.HsdItemHsdID === hsdID) {
          let newRow = {
            HsdItemFileName: m.HsdItemFileName,
            HsdItemID: m.HsdItemID,
            HsdItemFileExt: m.HsdItemFileExt,
          }
          result.push(newRow)
        }
      })

      return result
    },
    async downloadHubSpotAttachment(HsdItemID) {
      try {
        const response = await DataSource.shared.getStudentHubSpotAttachment(HsdItemID)
        if (response) {
          if (response.code === '99') {
            console.log('getStudentHubSpotAttachment: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentHubSpotAttachment: No record!')
          } else {
            this.$vs.loading.close()

            var byteChar = atob(response.Table[0].HsdItemFile)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: response.Table[0].HsdItemFileType + ';base64' })
            var fileUrl = URL.createObjectURL(file)
            window.open(fileUrl, '_blank', 'width=500, height=500')

            this.$vs.loading.close()
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    OpenReActivateModal() {
      this.inputReActivateDateOfCommencement = ''
      this.$refs.reActivateShowModal.show()
    },
    openReActivateConfirmModal() {
      if (this.inputReActivateDateOfCommencement === null || this.inputReActivateDateOfCommencement === '') {
        this.$notify({
          title: 'Require',
          message: 'Please select Date of Commencement...',
        })
      } else {
        this.$refs.reActivateShowModal.hide()
        this.$refs.reActivateConfirmShowModal.show()
      }
    },
    async reActive() {
      const response = await DataSource.shared.setLevel('ReActivate', this.lblStudentID, '', '', this.inputReActivateDateOfCommencement, '')
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '1') {
          this.$notify({
            title: 'Success',
            message: 'Re-Activate Successfully!',
            type: 'success',
          })
          window.location.replace('/student?id=' + this.lblStudentID)
        } else if (response.code === '3') {
          this.$notify.error({
            title: 'Error',
            message: 'Commencement Date out of range...',
          })
        } else if (response.code === '4') {
          this.$notify.error({
            title: 'Invalid',
            message: 'Invalid Action',
          })
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Re-Activate: Error...',
          })
        }
      }
    },
    nextsaveButtonShow() {
      if (this.activeTab === 'Student') {
        if (this.divParent) {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
          this.activeTab = 'Parents'
        } else {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
          this.activeTab = 'emergencyContact'
        }

        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'Parents') {
        this.btnSave = false
        this.btnNext = true
        this.btnPrevious = true
        this.activeTab = 'emergencyContact'
        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'emergencyContact') {
        this.btnSave = false
        this.btnNext = true
        this.btnPrevious = true
        this.activeTab = 'Addresses'
        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'Addresses') {
        this.btnSave = true
        this.btnNext = false
        this.btnPrevious = true
        this.activeTab = 'Medical'
        this.windowsSrollToTabHeader()
      } else {
        this.btnSave = true
        this.btnNext = false
        this.btnPrevious = true
        this.btnPrevious = true
      }
    },
    previousButtonShow() {
      if (this.activeTab === 'Medical') {
        this.btnSave = false
        this.btnNext = true
        this.btnPrevious = true
        this.activeTab = 'Addresses'
        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'Addresses') {
        this.btnSave = false
        this.btnNext = true
        this.btnPrevious = true
        this.activeTab = 'emergencyContact'
        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'emergencyContact') {
        if (this.divParent) {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = true
          this.activeTab = 'Parents'
        } else {
          this.btnSave = false
          this.btnNext = true
          this.btnPrevious = false
          this.activeTab = 'Student'
        }

        this.windowsSrollToTabHeader()
      } else if (this.activeTab === 'Parents') {
        this.btnSave = false
        this.btnNext = true
        this.btnPrevious = false
        this.activeTab = 'Student'
        this.windowsSrollToTabHeader()
      }
    },
    windowsSrollToTabHeader() {
      window.scrollTo(0, 400)
    },
    addStudentAuthorizedPickupList() {
      if (
        this.inputStudentAuthorizedPickupName !== '' &&
        this.inputStudentAuthorizedPickupContactNo !== '' &&
        this.inputStudentAuthorizedPickupIdentifyNo !== '' &&
        this.inputStudentAuthorizedPickupRelationship !== ''
      ) {
        const currentExisted = this.studentAuthorizedPickupListInt.find(d => d.AutPickIdentifyNo === this.inputStudentAuthorizedPickupIdentifyNo)

        if (currentExisted) {
          this.$notify.error({
            title: 'Duplicated',
            message: 'Duplicated Authorized Person',
          })
        } else if (this.inputStudentAuthorizedPickupIdentifyNo.length < 5) {
          this.$notify.error({
            title: 'Invalid Identify No',
            message: 'Identify No must have more than 4 characters',
          })
        } else {
          if (this.currentStudentAuthorizedPickupImg === '') {
            let addNewRowList = {
              AutPickName: this.inputStudentAuthorizedPickupName,
              AutPickIdentifyNo: this.inputStudentAuthorizedPickupIdentifyNo,
              AutPickRelationship: this.inputStudentAuthorizedPickupRelationship,
              AutPickContactNo: this.inputStudentAuthorizedPickupContactNo,
              AutPickImage: '',
            }

            this.studentAuthorizedPickupListInt.push(addNewRowList)

            this.inputStudentAuthorizedPickupName = ''
            this.inputStudentAuthorizedPickupContactNo = ''
            this.inputStudentAuthorizedPickupIdentifyNo = ''
            this.inputStudentAuthorizedPickupRelationship = ''
            this.currentStudentAuthorizedPickupImgPreview = ''
            this.currentStudentAuthorizedPickupImg = ''
          } else {
            let imgBase64String = ''

            var reader = new FileReader()
            reader.onload = e => {
              imgBase64String = e.target.result

              let addNewRowList = {
                AutPickName: this.inputStudentAuthorizedPickupName,
                AutPickIdentifyNo: this.inputStudentAuthorizedPickupIdentifyNo,
                AutPickRelationship: this.inputStudentAuthorizedPickupRelationship,
                AutPickContactNo: this.inputStudentAuthorizedPickupContactNo,
                AutPickImage: imgBase64String,
              }

              this.studentAuthorizedPickupListInt.push(addNewRowList)

              this.inputStudentAuthorizedPickupName = ''
              this.inputStudentAuthorizedPickupContactNo = ''
              this.inputStudentAuthorizedPickupIdentifyNo = ''
              this.inputStudentAuthorizedPickupRelationship = ''
              this.currentStudentAuthorizedPickupImgPreview = ''
              this.currentStudentAuthorizedPickupImg = ''
            }
            //TODO reader as URL
            reader.readAsDataURL(this.currentStudentAuthorizedPickupImg[0])
          }
        }
      } else {
        this.$notify.error({
          title: 'Required',
          message: 'Required all fields',
        })
      }
    },
    onchangeEmerContact(value) {
      if (value === 'first') {
        if (this.inputStudent1stEmergencyContactRelation === 'Father') {
          if (this.inputFamilyID !== '') {
            this.inputStudent1stEmergencyContact = this.familyParentFatherName
            this.inputStudent1stEmergencyContactNo = this.familyParentFatherContact
          } else {
            this.inputStudent1stEmergencyContact = ''

            if (this.inputFatherFirstName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputFatherFirstName
            }
            if (this.inputFatherMiddleName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputFatherMiddleName
            }
            if (this.inputFatherLastName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputFatherLastName
            }

            this.inputStudent1stEmergencyContactNo = this.inputFatherMobileNo
          }
        } else if (this.inputStudent1stEmergencyContactRelation === 'Mother') {
          if (this.inputFamilyID !== '') {
            this.inputStudent1stEmergencyContact = this.familyParentMotherName
            this.inputStudent1stEmergencyContactNo = this.familyParentMotherContact
          } else {
            this.inputStudent1stEmergencyContact = ''

            if (this.inputMotherFirstName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputMotherFirstName
            }
            if (this.inputMotherMiddleName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputMotherMiddleName
            }
            if (this.inputMotherLastName !== '') {
              this.inputStudent1stEmergencyContact += ' ' + this.inputMotherLastName
            }

            this.inputStudent1stEmergencyContactNo = this.inputMotherMobileNo
          }
        } else {
          this.inputStudent1stEmergencyContact = ''
          this.inputStudent1stEmergencyContactNo = ''
        }
      } else if (value === 'second') {
        if (this.inputStudent2ndEmergencyContactRelation === 'Father') {
          if (this.inputFamilyID !== '') {
            this.inputStudent2ndEmergencyContact = this.familyParentFatherName
            this.inputStudent2ndEmergencyContactNo = this.familyParentFatherContact
          } else {
            this.inputStudent2ndEmergencyContact = ''

            if (this.inputFatherFirstName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputFatherFirstName
            }
            if (this.inputFatherMiddleName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputFatherMiddleName
            }
            if (this.inputFatherLastName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputFatherLastName
            }

            this.inputStudent2ndEmergencyContactNo = this.inputFatherMobileNo
          }
        } else if (this.inputStudent2ndEmergencyContactRelation === 'Mother') {
          if (this.inputFamilyID !== '') {
            this.inputStudent2ndEmergencyContact = this.familyParentMotherName
            this.inputStudent2ndEmergencyContactNo = this.familyParentMotherContact
          } else {
            this.inputStudent2ndEmergencyContact = ''

            if (this.inputMotherFirstName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputMotherFirstName
            }
            if (this.inputMotherMiddleName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputMotherMiddleName
            }
            if (this.inputMotherLastName !== '') {
              this.inputStudent2ndEmergencyContact += ' ' + this.inputMotherLastName
            }

            this.inputStudent2ndEmergencyContactNo = this.inputMotherMobileNo
          }
        } else {
          this.inputStudent2ndEmergencyContact = ''
          this.inputStudent2ndEmergencyContactNo = ''
        }
      } else if (value === 'third') {
        if (this.inputStudent3rdEmergencyContactRelation === 'Father') {
          if (this.inputFamilyID !== '') {
            this.inputStudent3rdEmergencyContact = this.familyParentFatherName
            this.inputStudent3rdEmergencyContactNo = this.familyParentFatherContact
          } else {
            this.inputStudent3rdEmergencyContact = ''

            if (this.inputFatherFirstName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputFatherFirstName
            }
            if (this.inputFatherMiddleName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputFatherMiddleName
            }
            if (this.inputFatherLastName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputFatherLastName
            }

            this.inputStudent3rdEmergencyContactNo = this.inputFatherMobileNo
          }
        } else if (this.inputStudent3rdEmergencyContactRelation === 'Mother') {
          if (this.inputFamilyID !== '') {
            this.inputStudent3rdEmergencyContact = this.familyParentMotherName
            this.inputStudent3rdEmergencyContactNo = this.familyParentMotherContact
          } else {
            this.inputStudent3rdEmergencyContact = ''

            if (this.inputMotherFirstName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputMotherFirstName
            }
            if (this.inputMotherMiddleName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputMotherMiddleName
            }
            if (this.inputMotherLastName !== '') {
              this.inputStudent3rdEmergencyContact += ' ' + this.inputMotherLastName
            }

            this.inputStudent3rdEmergencyContactNo = this.inputMotherMobileNo
          }
        } else {
          this.inputStudent3rdEmergencyContact = ''
          this.inputStudent3rdEmergencyContactNo = ''
        }
      }
    },
    openSearchFamilyModel() {
      this.familyIDList = []
      this.$refs.familyModalShowModal.show()
    },
    openInviteParentModal() {
      this.$refs.inviteParentConfirmShowModal.show()
    },
    async InviteParent() {
      try {
        this.$vs.loading()

        const response = await DataSource.shared.InviteParentRegister(this.ddlParentInvite[0], this.ddlParentInvite[1], this.ddlParentInvite[2])
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Invite Parent Fail...',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'Duplicated',
              message: 'Parent already registered....',
            })
          } else {
            this.$notify({
              title: 'Succeeded',
              message: 'Successfully Send Email Invite Parent',
            })

            const parRes = await DataSource.shared.getParent(this.ddlParentInvite[2], '', '')
            if (parRes) {
              this.inviteParentRegisterList = []

              parRes.Table.forEach(m => {
                if (m.FatherRegistered === 'No') {
                  let fatherRegisterEmail = {
                    ParentID: m.PAR_ID,
                    Email: m.PAR_Father_Email,
                    Type: 'Father',
                  }

                  this.inviteParentRegisterList.push(fatherRegisterEmail)
                }

                if (m.MotherRegistered === 'No') {
                  let motherRegisterEmail = {
                    ParentID: m.PAR_ID,
                    Email: m.PAR_Mother_Email,
                    Type: 'Mother',
                  }

                  this.inviteParentRegisterList.push(motherRegisterEmail)
                }
              })
            }
          }
        }

        this.$vs.loading.close()

        this.$refs.inviteParentConfirmShowModal.hide()
      } catch (e) {
        this.results = e
      }
    },
    previewtudentAuthorizedPickupImage: function (event) {
      try {
        var input = event.target
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.currentStudentAuthorizedPickupImgPreview = e.target.result
          }
          reader.readAsDataURL(input.files[0])
          this.currentStudentAuthorizedPickupImg = event.target.files
        }
      } catch (e) {
        this.results = e
      }
    },
    StudentAuthorizedPickupChooseClick() {
      try {
        this.$refs.StudentAuthorizedPickupChoose.click()
      } catch (e) {
        this.results = e
      }
    },
    billingEmailValidation() {
      if (this.inputStudentEmailAdd !== '') {
        this.$v.validationGroupBillingEmail.$touch()

        if (this.$v.validationGroupBillingEmail.$error) {
          return
        } else {
          if (this.inputStudentEmail === '') {
            this.inputStudentEmail = this.inputStudentEmailAdd
          } else {
            this.inputStudentEmail += ',' + this.inputStudentEmailAdd
          }

          this.inputStudentEmailAdd = ''
        }
      }
    },
    removeBillingEmail() {
      this.inputStudentEmail = ''
    },
    /*#region file from base64String*/
    isImage(obj_File) {
      let ext = String(obj_File.SF_FileExt).toUpperCase()
      let isImage = false

      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
        case '.JFIF':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },
    getHighSource(file) {
      return 'data:' + file.SF_FileType + ';base64,' + file.SF_File
    },
    /*#endregion*/
    showStudentDeclaredTravel(ParTrvDclID) {
      let result = false

      let get = this.studentDeclaredTravel.ParentTravelDeclaration.Table.filter(m => m.ParTrvDclID === ParTrvDclID)

      if (get.length > 0) {
        if (get[0].ParTrvDclBringChild === 'No') {
          result = true
        } else {
          let getDetails = this.studentDeclaredTravel.ParentTravelDeclarationStudents.Table.filter(
            m2 => m2.ParTrvDclID === ParTrvDclID && m2.StudentID === this.lblStudentID,
          )

          if (getDetails.length > 0) {
            result = true
          }
        }
      }

      return result
    },
    convertDatetime(val) {
      return moment(val).format('DD MMM YYYY')
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0
    },
    openVoidlevelModal(row) {
      this.currentVoidStudentCourseID = row.PK_Student_Course_ID
      this.currentVoidStudentCourseReason = ''
      if (row.PK_Student_Course_ID) {
        if (row.PK_Student_Course_ID !== '') {
          this.$refs.voidlevelModal.show()
        }
      }
    },
    openEditLevelModal(row) {
      //console.log(row);
      this.currentVoidStudentCourseID = row.PK_Student_Course_ID
      if (row.PK_Student_Course_ID) {
        if (row.PK_Student_Course_ID !== '') {
          this.currentStudentCourseID = row.PK_Student_Course_ID
          this.currentClassID = row.classID
          this.currentLevelSchoolID = row.PK_SCH_ID
          this.$refs.editlevelModal.show()
        }
      }
    },
    async voidStudentLevel() {
      try {
        if (this.currentVoidStudentCourseReason === '') {
          this.$notify({
            title: 'Require',
            message: 'Plese fill in reason',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.updateLevel(this.currentVoidStudentCourseID, 'Void', this.currentVoidStudentCourseReason)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Update fail...',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Invalid',
                message: 'You are Not Authorized to Void the Year Level...',
              })
            } else {
              window.location.replace('/student?id=' + this.lblStudentID)
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },

    async updateStudentLevel() {
      try {
        if (this.ddlStudentLevel === '') {
          this.$notify({
            title: 'Require',
            message: 'Plese select Student Level',
          })
        } else if (this.ddlStudentClass === '') {
          this.$notify({
            title: 'Require',
            message: 'Plese select Student Class in Level',
          })
        } else if (this.inputStudentClassStartDate === '') {
          this.$notify({
            title: 'Require',
            message: 'Plese select Level Start Date',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.updateLevelClass(
            this.currentVoidStudentCourseID,
            'Void',
            'Changed Level',
            this.ddlStudentLevel,
            this.ddlStudentClass,
            this.inputStudentClassStartDate,
          )

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Update fail...',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Invalid',
                message: 'You are Not Authorized to Edit the Year Level...',
              })
            } else {
              this.$notify({
                title: 'Successful Update',
                message: 'Success updating this Student Level',
                type: 'success',
              })

              var strurl = '/student?id=' + this.lblStudentID
              setTimeout(function () {
                window.location.replace(strurl)
              }, 2000)
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
        this.$vs.loading.close()
      }
    },

    checkPayerType(payerValue) {
      let checkPayerTypeExisting = this.ddlStudentPayerList.filter(m => m.OPTvalue === payerValue)
      if (checkPayerTypeExisting.length < 1) {
        this.ddlStudentPayer = ''
      }
    },
    async getStudentDocument() {
      this.$vs.loading()

      try {
        const response = await DataSource.shared.getStudentDocument(this.lblStudentID, 'FOLDER', '')

        if (response) {
          if (response.code === '99') {
            console.log('getStudentDocument: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            if (response.code === '2') {
              console.log('getStudentDocument: No record!')
            }

            this.sdmBodySCSpanSCActive = false
            this.sdmBodySCSpanIRActive = false
            this.sdmBodySCSpanAAMActive = false

            this.collapseSD = false
            this.collapseIR = false
            this.collapseAAM = false

            this.moveFileSelectedFolderType = ''
            this.moveFileSelectedFolder = []
            this.moveFileSelectedFolderList = []

            this.studentDocumentManagerDeleteFolderSelectedFolderID = ''

            this.sdmCurrentFolder = response.Table
          }
        }
        this.$vs.loading.close()

        return response
      } catch (e) {
        console.log(e, 'getStudentDocument err')
      }
    },
    async showStudentDocumentManagerModal() {
      let resp = await this.getStudentDocument()
      if (resp?.code !== ('88' || '99')) {
        this.studentDocumentCurrentFolder = []
        this.studentDocumentFolder = []
        this.studentDocumentFile = []
        this.$refs.studentDocumentManagerShowModal.show()
      }
    },
    DMSpanClick(value) {
      let currentValue = false

      //get current value
      if (value === 'SC') {
        currentValue = this.sdmBodySCSpanSCActive
      } else if (value === 'IR') {
        currentValue = this.sdmBodySCSpanIRActive
      } else if (value === 'AAM') {
        currentValue = this.sdmBodySCSpanAAMActive
      }
      //get current value

      //clear
      this.sdmBodySCSpanSCActive = false
      this.sdmBodySCSpanIRActive = false
      this.sdmBodySCSpanAAMActive = false
      this.collapseSD = false
      this.collapseIR = false
      this.collapseAAM = false
      //clear

      if (value === 'SC') {
        if (currentValue) {
          this.sdmBodySCSpanSCActive = false
          this.collapseSD = false
        } else {
          this.sdmBodySCSpanSCActive = true
          this.collapseSD = true
        }
      } else if (value === 'IR') {
        if (currentValue) {
          this.sdmBodySCSpanIRActive = false
          this.collapseIR = false
        } else {
          this.sdmBodySCSpanIRActive = true
          this.collapseIR = true
        }
      } else if (value === 'AAM') {
        if (currentValue) {
          this.sdmBodySCSpanAAMActive = false
          this.collapseAAM = false
        } else {
          this.sdmBodySCSpanAAMActive = true
          this.collapseAAM = true
        }
      }
    },
    createNewFolderShowModel(value) {
      this.newFolder = ''
      this.studentDocumentManagerNewFolderShowModel = true
      this.newFolderType = value
    },
    async createNewFolder() {
      try {
        if (this.newFolder === '') {
          this.$notify.error({
            title: 'Required',
            message: 'Please fill in Folder Name!',
          })
        } else {
          this.$vs.loading()

          await this.sleep(500)

          let parentFolder = ''
          if (this.newFolderType === 'Student Doc') {
            parentFolder = 'DOCUMENT_FOLDER'
          } else if (this.newFolderType === 'Immunization Records') {
            parentFolder = 'IMMNUIZATION_FOLDER'
          } else if (this.newFolderType === 'All About Me') {
            parentFolder = 'ALLABOUTME_FOLDER'
          } else {
            parentFolder = this.studentDocumentCurrentFolder[0].folderID
          }

          //TODO Filesave
          const response = await DataSource.shared.saveStudentDocument([], this.lblStudentID, this.newFolder, 'New Folder', parentFolder)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No files being upload!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Error',
                message: 'Upload files error! Please try again',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid file format',
              })
            } else if (response.code === '5') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Duplicated folder name',
              })
            } else if (response.code === '1') {
              this.$notify({
                title: 'Succesfully',
                message: 'New Folder Created',
              })

              this.showStudentDocumentManagerModal()
              this.studentDocumentManagerNewFolderShowModel = false
            }
          }

          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async setCurrentFolder(folderName, folderID, folderType, mode) {
      this.$vs.loading()

      await this.sleep(500)
      try {
        let finalFolderName
        if (mode !== 'reset') {
          if (mode === 'Inner') {
            finalFolderName = this.studentDocumentCurrentFolder[0].folderName + ' -> ' + folderName
          } else {
            finalFolderName = folderName
          }

          this.studentDocumentCurrentFolder = [
            {
              folderID: folderID,
              folderName: finalFolderName,
              folderType: folderType,
              folderMode: mode,
              oriFolderName: folderName,
            },
          ]
        }

        let fileMode = this.getFileMode()

        this.studentDocumentFile = []
        this.studentDocumentFolder = []

        //get folder
        const resFolder = await DataSource.shared.getStudentDocument(this.lblStudentID, 'FOLDER', fileMode[0].ParFolderID)
        if (resFolder) {
          if (resFolder.code === '99') {
            console.log('get Student Document Folder: Error!')
          } else if (resFolder.code === '88') {
            window.location.replace('/')
          } else if (resFolder.code === '2') {
            console.log('get Student Document Folder: No record!')
          } else {
            this.studentDocumentFolder = resFolder.Table
          }
        }
        //get folder

        //get file
        const response = await DataSource.shared.getStudentDocument(this.lblStudentID, fileMode[0].GetFileMode, fileMode[0].ParFolderID)
        if (response) {
          if (response.code === '99') {
            console.log('getStudentDocument: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentDocument: No record!')
            this.studentDocumentFile = []
          } else {
            this.studentDocumentFile = response.Table
            this.studentDocumentFile.forEach(m => {
              this.getStudentFile(m.PK_SF_ID)
            })
            console.log(this.studentDocumentFile)

            if (stuProPic.code !== '2' && stuProPic.code !== '99') {
              this.stuProPicLoop = stuProPic.Table
              this.stuProPicLoop.forEach(m => {
                if (this.isImage(m)) {
                  this.imgStudentProfile = API_HOST + `/External/STUDENTS/${this.lblStudentID}/PROFILE_PHOTO/` + m.SF_File_Name
                }
              })
            }

            //TODO StudentFile Fetched
          }
        }
        //get file
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },
    uploadFileShowModel() {
      this.uploadFileName = ''
      this.uploadFileDescription = ''
      this.StudentDocumentManagerNewFileShowModal = true
      this.$refs.studentDocumentManagerNewFileUploadFile = null
    },
    uploadFileNameChange() {
      for (let file of event.target.files) {
        let name = file?.name?.split('.')
        this.uploadFileName = name?.[0]
      }
    },
    async studentDocumentManagerUploadFile() {
      try {
        if (this.$refs.studentDocumentManagerNewFileUploadFile.files.length === 0) {
          this.$notify.error({
            title: 'Required',
            message: 'Please select file!',
          })
        }
        // disable upload new file description
        // else if (this.uploadFileDescription === '') {
        //     this.$notify.error({
        //         title: 'Required',
        //         message: 'Please fill in File Description!'
        //     });
        // }
        else if (this.studentDocumentCurrentFolder.length < 1) {
          this.$notify.error({
            title: 'Required',
            message: 'Please select Folder!',
          })
        } else {
          this.$vs.loading()

          await this.sleep(500)

          let fileMode = this.getFileMode()

          const response = await DataSource.shared.saveStudentDocument(
            this.$refs.studentDocumentManagerNewFileUploadFile.files,
            this.lblStudentID,
            this.uploadFileName,
            fileMode[0].FileMode,
            fileMode[0].ParFolderID,
          )

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: response?.message,
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No files being upload!',
              })
            } else if (response.code === '3') {
              this.$notify.error({
                title: 'Error',
                message: 'Upload files error! Please try again',
              })
            } else if (response.code === '4') {
              this.$notify.error({
                title: 'Invalid',
                message: 'Invalid file format',
              })
            } else if (response.code === '5') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Folder duplicated',
              })
            } else if (response.code === '1') {
              this.$refs.StudentDocumentManagerNewFileShowModal.hide()
              await this.getStudentDocument()
              await this.setCurrentFolder('', '', '', 'reset')
            }
          } else {
            window.location.reload()
          }
        }
      } catch (e) {
        console.log('studentDocumentManagerUploadFile err', e)
        window.location.reload()
      }
      this.$vs.loading.close()
    },
    getFileMode() {
      //get upload mode
      let uploadFileMode = ''
      let getFileMode = ''

      if (this.studentDocumentCurrentFolder[0].folderType === 'Student Doc') {
        uploadFileMode = 'Upload Student Documents'
        getFileMode = 'DOCUMENT'
      } else if (this.studentDocumentCurrentFolder[0].folderType === 'Immunization Records') {
        uploadFileMode = 'Upload Student Immunization Records'
        getFileMode = 'IMMNUIZATION'
      } else if (this.studentDocumentCurrentFolder[0].folderType === 'All About Me') {
        uploadFileMode = 'Upload All About Me'
        getFileMode = 'ALLABOUTME'
      } else {
        uploadFileMode = 'Error'
        getFileMode = 'Error'
      }
      //get upload mode

      //get par folder if
      let uploadParFolderID = ''

      if (this.studentDocumentCurrentFolder[0].folderID.toUpperCase() === 'ROOT') {
        if (this.studentDocumentCurrentFolder[0].folderType === 'Student Doc') {
          uploadParFolderID = 'DOCUMENT_FOLDER'
        } else if (this.studentDocumentCurrentFolder[0].folderType === 'Immunization Records') {
          uploadParFolderID = 'IMMNUIZATION_FOLDER'
        } else if (this.studentDocumentCurrentFolder[0].folderType === 'All About Me') {
          uploadParFolderID = 'ALLABOUTME_FOLDER'
        } else {
          uploadParFolderID = this.studentDocumentCurrentFolder[0].folderType
        }
      } else {
        uploadParFolderID = this.studentDocumentCurrentFolder[0].folderID
      }
      //get par folder if

      let finalResult = [
        {
          FileMode: uploadFileMode,
          ParFolderID: uploadParFolderID,
          GetFileMode: getFileMode,
        },
      ]

      return finalResult
    },
    async getStudentFile(fileID) {
      try {
        //TODO fetch base 64 files
        const response = await DataSource.shared.getStudentDocumentBase64String(fileID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Get Student Document Base64String: Error')
          } else if (response.code === '2') {
            console.log('Get Student Document Base64String: No Record')
          } else {
            let fileTypeExt = GlobalFn.FileType(response.Table[0].SF_FileExt)
            this.studentDocumentFile = this.studentDocumentFile.map(m => {
              if (m.PK_SF_ID === fileID) {
                m.fileTypeExt = fileTypeExt
                if (response.Table[0].SF_File) {
                  console.log('have base 64 file')
                  if (fileTypeExt === 'PDF') {
                    m.fullFileString = 'data:' + response.Table[0].SF_FileType + ';base64,' + response.Table[0].SF_File
                    m.numPages = undefined
                    let src = pdf.createLoadingTask('data:' + response.Table[0].SF_FileType + ';base64,' + response.Table[0].SF_File)
                    m.pageOfSrc = src
                    src.promise.then(pdf => {
                      m.numPages = pdf.numPages
                    })
                  }
                } else {
                  m.fullFileString = `${API_HOST}/External/STUDENTS/${this.lblStudentID}/DOCUMENTS/${m.SF_File_Name}`

                  if (fileTypeExt === 'PDF') {
                    console.log('no base 64 file')
                    let src = pdf.createLoadingTask(m.fullFileString)
                    m.pageOfSrc = src
                    src.promise.then(pdf => {
                      m.numPages = pdf.numPages
                    })
                  }
                  //disable change to base64
                  // this.urltoFile(m.fullFileString, m.SF_File_Description, m.SF_FileType).then((blobFile) => {
                  //     var url = window.URL.createObjectURL(blobFile);
                  //     m.fullFileString = url;
                  // });
                }
              }
              m.fileSelected = false

              return m
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    clickSDMFile(fileID) {
      this.studentDocumentFile = this.studentDocumentFile.map(m => {
        if (m.PK_SF_ID === fileID) {
          if (m.fileSelected === true) {
            m.fileSelected = false
          } else {
            m.fileSelected = true
          }
        }

        return m
      })
    },
    studentDocumentMove(mode) {
      let check = this.studentDocumentFile.filter(m => m.fileSelected === true)

      if (mode === 'MULTIPLE') {
        if (check.length < 1) {
          return false
        } else {
          return true
        }
      } else if (mode === 'ONE') {
        if (check.length === 1) {
          return true
        } else {
          return false
        }
      }
    },
    moveFileShowModel() {
      this.StudentDocumentManagerMoveFileShowModal = true
      this.moveFileSelectedFolder = []
      this.moveFileSelectedFolderList = []
      this.moveFilePreviousSelectedFolder = ''
      this.moveFileSelectedFolderType = ''
    },
    async selectFolderType(value, type) {
      this.moveFileSelectedFolder = []
      this.moveFileSelectedFolderList = []
      this.moveFilePreviousSelectedFolder = ''

      let parFolderID = 'Error'

      if (type === 'Root') {
        //add root folder
        if (value === 'Student Doc') {
          let tempValue = {
            FolderID: 'DOCUMENT_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'DOCUMENT_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
          this.moveFileSelectedFolderType = 'DOCUMENT'
        } else if (value === 'Immunization Records') {
          let tempValue = {
            FolderID: 'IMMNUIZATION_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'IMMNUIZATION_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
          this.moveFileSelectedFolderType = 'IMMNUIZATION'
        } else if (value === 'All About Me') {
          let tempValue = {
            FolderID: 'ALLABOUTME_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'ALLABOUTME_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
          this.moveFileSelectedFolderType = 'ALLABOUTME'
        }
        //add root folder

        //get folder type
        if (value === 'Student Doc') {
          parFolderID = 'DOCUMENT_FOLDER'
        } else if (value === 'Immunization Records') {
          parFolderID = 'IMMNUIZATION_FOLDER'
        } else if (value === 'All About Me') {
          parFolderID = 'ALLABOUTME_FOLDER'
        }
        //get folder type
      } else if (type === 'Inner') {
        parFolderID = value

        //add root folder
        if (value === 'DOCUMENT_FOLDER') {
          let tempValue = {
            FolderID: 'DOCUMENT_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'DOCUMENT_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
        } else if (value === 'IMMNUIZATION_FOLDER') {
          let tempValue = {
            FolderID: 'IMMNUIZATION_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'IMMNUIZATION_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
        } else if (value === 'ALLABOUTME_FOLDER') {
          let tempValue = {
            FolderID: 'ALLABOUTME_FOLDER',
            FolderName: 'Root',
            ParFolderID: 'ALLABOUTME_FOLDER',
          }
          this.moveFileSelectedFolderList.push(tempValue)
        }
        //add root folder
      }

      //get parent folder parent id
      const resParFolParID = await DataSource.shared.getStudentFileParentID(parFolderID)
      if (resParFolParID) {
        if (resParFolParID.code === '99') {
          console.log('get Student File Parent ID: Error!')
        } else if (resParFolParID.code === '88') {
          window.location.replace('/')
        } else if (resParFolParID.code === '2') {
          console.log('get Student File Parent ID: No record!')
        } else {
          this.moveFilePreviousSelectedFolder = resParFolParID.Table[0].SFRParID
        }
      }
      //get parent folder parent id

      //add folder
      const resFolder = await DataSource.shared.getStudentDocument(this.lblStudentID, 'FOLDER', parFolderID)
      if (resFolder) {
        if (resFolder.code === '99') {
          console.log('get Student Document Folder: Error!')
        } else if (resFolder.code === '88') {
          window.location.replace('/')
        } else if (resFolder.code === '2') {
          console.log('get Student Document Folder: No record!')
        } else {
          resFolder.Table.forEach(m => {
            let tempValue = {
              FolderID: m.PK_SF_ID,
              FolderName: m.SF_File_Description,
              ParFolderID: m.SFRParID,
            }

            this.moveFileSelectedFolderList.push(tempValue)
          })
        }
      }
      //add folder
    },
    async updateStudentDocument(mode) {
      try {
        if (mode === 'MOVEFILE') {
          if (this.moveFileSelectedFolder.length < 1 || this.moveFileSelectedFolderType === '') {
            this.$notify({
              title: 'Required',
              message: 'Please select Folder!',
            })
          } else {
            let studentFilesID = []

            let tempStudentFilesID = this.studentDocumentFile.filter(m => m.fileSelected === true)

            if (tempStudentFilesID.length > 0) {
              tempStudentFilesID.forEach(m => {
                let tempValue = {
                  fileID: m.PK_SF_ID,
                  fileRelationID: m.SFRID,
                  NewFolderID: this.moveFileSelectedFolder[0].FolderID,
                  fileType: this.moveFileSelectedFolderType,
                }

                studentFilesID.push(tempValue)
              })

              const response = await DataSource.shared.updateStudentDocument(JSON.stringify(studentFilesID), mode)

              if (response) {
                if (response.code === '88') {
                  window.location.replace('/')
                } else if (response.code === '99') {
                  this.$notify.error({
                    title: 'Error',
                    message: 'Error!',
                  })
                } else if (response.code === '1') {
                  this.StudentDocumentManagerMoveFileShowModal = false
                  this.showStudentDocumentManagerModal()
                }
              }
            } else {
              this.$notify({
                title: 'Required',
                message: 'Please select File!',
              })
            }
          }
        } else if (mode === 'DELETE') {
          let studentFilesID = []

          let tempStudentFilesID = this.studentDocumentFile.filter(m => m.fileSelected === true)

          if (tempStudentFilesID.length > 0) {
            tempStudentFilesID.forEach(m => {
              let tempValue = {
                fileID: m.PK_SF_ID,
              }

              studentFilesID.push(tempValue)
            })

            const response = await DataSource.shared.updateStudentDocument(JSON.stringify(studentFilesID), mode)

            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '99') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Error!',
                })
              } else if (response.code === '1') {
                this.studentDocumentManagerDeleteFileConfirm = false
                this.showStudentDocumentManagerModal()
              }
            }
          } else {
            this.$notify({
              title: 'Required',
              message: 'Please select File!',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    selectMoveFolder(item) {
      let temp = {
        FolderID: item.FolderID,
        FolderName: item.FolderName,
        ParFolderID: item.ParFolderID,
      }

      if (this.moveFileSelectedFolder.length > 0) {
        if (this.moveFileSelectedFolder[0].FolderID === item.FolderID) {
          this.moveFileSelectedFolder = []
        } else {
          this.moveFileSelectedFolder = []
          this.moveFileSelectedFolder.push(temp)
        }
      } else {
        this.moveFileSelectedFolder = []
        this.moveFileSelectedFolder.push(temp)
      }
    },
    selectdMoveFolderActive(item) {
      if (this.moveFileSelectedFolder.length > 0) {
        if (this.moveFileSelectedFolder[0].FolderID === item.FolderID) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    async updateStudentDocumentFolder(mode) {
      try {
        if (mode === 'DELETE') {
          if (this.studentDocumentManagerDeleteFolderSelectedFolderID !== '') {
            let studentFolderID = []

            let tempValue = {
              fileID: this.studentDocumentManagerDeleteFolderSelectedFolderID,
            }

            studentFolderID.push(tempValue)

            const response = await DataSource.shared.updateStudentDocument(JSON.stringify(studentFolderID), mode)

            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '99') {
                this.$notify.error({
                  title: 'Error',
                  message: 'Error!',
                })
              } else if (response.code === '1') {
                this.studentDocumentManagerDeleteFolderConfirm = false
                this.studentDocumentManagerDeleteFolderSelectedFolderID = ''
                this.showStudentDocumentManagerModal()
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    deleteFileShowModel() {
      this.studentDocumentManagerDeleteFileConfirm = true
    },
    deleteFolderShowModel(folderID) {
      this.studentDocumentManagerDeleteFolderSelectedFolderID = folderID
      this.studentDocumentManagerDeleteFolderConfirm = true
    },
    filterClassMate() {
      if (this.inputSearchClassMate !== '') {
        this.classMateList = this.classMateListInt.filter(data => data.Full_Name.toUpperCase().includes(this.inputSearchClassMate.toUpperCase()))
      } else {
        this.classMateList = this.classMateListInt
      }
    },
    selectClassMate(value) {
      window.location.replace('/student?id=' + value.Student_ID)
    },
    viewStudentFile() {
      this.studentDocumentManagerViewFiles = true
    },
    viewStudentFileFilter() {
      if (!this.studentDocumentManagerViewFiles) {
        return []
      } else {
        return this.studentDocumentFile.filter(m => m.fileSelected === true)
      }
    },
    resetEmailPasswordShowModel() {
      this.$refs['studentEmailPopover'].doClose()
      this.resetEmailPassword = true
      this.resetEmailPasswordManualPassword = ''
      this.resetEmailPasswordManualPasswordCheckBox = false
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    async getStudentMealsOption(courseID, semesterID) {
      this.$vs.loading()
      try {
        const studentMealOptionResponse = await DataSource.shared.getFeeDetailsOptionList(this.$route.query.id, courseID, semesterID, 'School Meal')

        if (studentMealOptionResponse) {
          if (studentMealOptionResponse.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (studentMealOptionResponse.code === '88') {
            window.location.replace('/')
          } else if (studentMealOptionResponse.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
            this.ddlSchoolMeal = studentMealOptionResponse.Table
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async getStudentMeals() {
      this.$vs.loading()
      try {
        const studentMealResponse = await DataSource.shared.getStudentMeals(this.$route.query.id, this.ddlMealsStudentCourseID)
        if (studentMealResponse) {
          if (studentMealResponse.code === '99') {
            console.log('getStudentMeals: Error!')
          } else if (studentMealResponse.code === '88') {
            window.location.replace('/')
          } else if (studentMealResponse.code === '2') {
            console.log('getStudentMeals: No record!')
          } else {
            this.lvlMealsList_Meals = studentMealResponse.Table
            this.lvlMealsList_Meals.forEach((value, index) => {
              value.SML_From_Date = this.convertDatetime(value.SML_From_Date)
              value.SML_To_Date = this.convertDatetime(value.SML_To_Date)
            })
            this.GetStudentLevelListResponse.forEach(m => {
              if (this.ddlMealsStudentCourseID == m.PK_Student_Course_ID) {
                this.getStudentMealsOption(m.SCRS_FK_Course_ID, m.SCRS_FK_Semester_ID)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    openAddMealsModal() {
      this.$refs.addMealsModal.show()
    },
    openVoidMealsModal(row) {
      this.currentVoidStudentMealID = row.PK_Student_Meal_ID
      this.currentVoidStudentMealRemarks = ''
      this.currentVoidStudentMealStartDate = row.SML_TO_Date
      this.currentVoidStudentMealStatus = row.SML_Status
      if (row.PK_Student_Meal_ID) {
        if (row.PK_Student_Meal_ID !== '') {
          this.$refs.voidMealsModal.show()
        }
      }
    },
    setSchoolMealPeriod() {
      let selectedRow = this.ddlSchoolMeal.filter(m => m.PK_Course_Fee_Detail_ID == this.newSchoolMeal.PK_Course_Fee_Detail_ID)
      this.newSchoolMeal.startDate = new Date(selectedRow[0].SEMD_FromDate)
      this.newSchoolMeal.endDate = new Date(selectedRow[0].SEMD_ToDate)
    },
    async voidStudentMeals() {
      this.$vs.loading()
      try {
        this.newSchoolMeal = []
        this.newSchoolMeal.studentMealID = this.currentVoidStudentMealID
        this.newSchoolMeal.mealRemarks = this.currentVoidStudentMealRemarks
        this.newSchoolMeal.mealEndDate = this.currentVoidStudentMealEndDate
        this.newSchoolMeal.mealStartDate = this.currentVoidStudentMealStartDate
        this.newSchoolMeal.actionMode = this.currentVoidStudentMealStatus == 'Pending' ? 'Void' : 'Cancellation'
        this.newSchoolMeal.studentID = this.$route.query.id

        const response = await DataSource.shared.updateStudentMeal(this.newSchoolMeal)

        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      this.getStudentMeals()
      this.newSchoolMeal = []
      this.$refs.voidMealsModal.hide()
      this.$vs.loading.close()
    },
    async addStudentMeals() {
      this.$vs.loading()
      try {
        this.newSchoolMeal.studentID = this.$route.query.id
        this.newSchoolMeal.studentCourseID = this.ddlMealsStudentCourseID
        this.newSchoolMeal.courseFeeDetailID = this.newSchoolMeal.PK_Course_Fee_Detail_ID
        this.newSchoolMeal.courseFeeSchemeID = this.ddlSchoolMeal[0].FK_Course_Fee_Scheme_ID

        const response = await DataSource.shared.saveStudentMeal(this.newSchoolMeal)

        if (response) {
          if (response.code === '99') {
            console.log('getStudentMealsOption: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('getStudentMealsOption: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      this.getStudentMeals()
      this.newSchoolMeal = []
      this.$refs.addMealsModal.hide()
      this.$vs.loading.close()
    },
    async getAddLangOption(courseID, semesterID) {
      this.$vs.loading()
      try {
        const addLangResponse = await DataSource.shared.getFeeDetailsOptionList(this.$route.query.id, courseID, semesterID, 'Additional Language')

        if (addLangResponse) {
          if (addLangResponse.code === '99') {
            console.log('getAddLangOption: Error!')
          } else if (addLangResponse.code === '88') {
            window.location.replace('/')
          } else if (addLangResponse.code === '2') {
            console.log('getAddLangOption: No record!')
          } else {
            this.ddlAddLang = addLangResponse.Table
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async getAddLang() {
      this.$vs.loading()
      try {
        const AddLangResponse = await DataSource.shared.getAddLang(this.$route.query.id, this.ddlAddLangStudentCourseID)
        if (AddLangResponse) {
          if (AddLangResponse.code === '99') {
            console.log('getStudentMeals: Error!')
          } else if (AddLangResponse.code === '88') {
            window.location.replace('/')
          } else if (AddLangResponse.code === '2') {
            console.log('getStudentMeals: No record!')
          } else {
            this.lvlAddLangList_AddLang = AddLangResponse.Table
            this.lvlAddLangList_AddLang.forEach((value, index) => {
              value.SAL_From_Date = this.convertDatetime(value.SAL_From_Date)
              value.SAL_To_Date = this.convertDatetime(value.SAL_To_Date)
            })

            this.GetStudentLevelListResponse.forEach(m => {
              if (this.ddlAddLangStudentCourseID == m.PK_Student_Course_ID) {
                this.getAddLangOption(m.SCRS_FK_Course_ID, m.SCRS_FK_Semester_ID)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    openAddLangModal() {
      this.$refs.addAddLangModal.show()
    },
    openVoidAddLangModal(row) {
      this.currentVoidAddLangID = row.PK_Student_Add_Lang_ID
      this.currentVoidAddLangRemarks = ''
      this.currentVoidAddLangStartDate = row.SAL_TO_Date
      this.currentVoidAddLangStatus = row.SAL_Status
      if (row.PK_Student_Add_Lang_ID) {
        if (row.PK_Student_Add_Lang_ID !== '') {
          this.$refs.voidAddLangModal.show()
        }
      }
    },
    setAddLangPeriod() {
      let selectedRow = this.ddlAddLang.filter(m => m.PK_Course_Fee_Detail_ID == this.newAddLang.PK_Course_Fee_Detail_ID)
      this.newAddLang.startDate = new Date(selectedRow[0].SEMD_FromDate)
      this.newAddLang.endDate = new Date(selectedRow[0].SEMD_ToDate)
    },
    async voidAddLang() {
      this.$vs.loading()
      try {
        this.newAddLang = []
        this.newAddLang.studentAddLangID = this.currentVoidAddLangID
        this.newAddLang.stuAddLangRemarks = this.currentVoidAddLangRemarks
        this.newAddLang.stuAddLangEndDate = this.currentVoidAddLangEndDate
        this.newAddLang.stuAddLangStartDate = this.currentVoidAddLangStartDate
        this.newAddLang.actionMode = this.currentVoidAddLangStatus === 'Pending' ? 'Void' : 'Cancellation'
        this.newAddLang.studentID = this.$route.query.id

        const response = await DataSource.shared.updateAddLang(this.newAddLang)

        if (response) {
          if (response.code === '99') {
            console.log('voidAddLang: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('voidAddLang: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      this.getAddLang()
      this.newAddLang = []
      this.$refs.voidAddLangModal.hide()
      this.$vs.loading.close()
    },
    async addAddLang() {
      this.$vs.loading()
      try {
        this.newAddLang.studentID = this.$route.query.id
        this.newAddLang.studentCourseID = this.ddlAddLangStudentCourseID
        this.newAddLang.courseFeeDetailID = this.newAddLang.PK_Course_Fee_Detail_ID
        this.newAddLang.courseFeeSchemeID = this.ddlAddLang[0].FK_Course_Fee_Scheme_ID

        const response = await DataSource.shared.saveAddLang(this.newAddLang)

        if (response) {
          if (response.code === '99') {
            console.log('addAddLang: Error!')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '2') {
            console.log('addAddLang: No record!')
          } else {
          }
        }
      } catch (e) {
        this.results = e
      }
      this.getAddLang()
      this.newAddLang = []
      this.$refs.addAddLangModal.hide()
      this.$vs.loading.close()
    },
  },
}
</script>

<style scoped>
.studentPageBTabs {
  position: relative;
}

.alert-badge {
  background: red;
  width: 14px;
  height: 14px;
  text-align: center;
  display: block;
  border-radius: 50%;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: 3px;
  line-height: 1.2;
  font-size: 12px;
}

.alert-badge2 {
  background: red;
  border-radius: 50%;
  font-weight: bold;
  color: #fff;
  padding: 5px 10px;
}

.badge1 {
  left: 83px;
}

.badge2 {
  left: 185px;
}

.badge4 {
  left: 503px;
}

.studentAreaDiv,
.familyIDAreaDiv,
.parentAreaDiv,
.amAreaDiv,
.ecAreaDiv {
  left: 0;
}

.btnFamilyIDSearch {
  margin-top: 10px;
}

.requiredFields {
  border-color: #f79483;
}

.requiredFieldsMsg {
  color: red;
  font-weight: bold;
}

.buttonArea {
  margin: 20px 0 0 0;
}

.buttonArea .btn-primary {
  margin: 0 0 0 20px;
}

.btn-primary {
  display: inline;
}

.modeArea {
  text-align: left;
}

.textArea {
  width: 100%;
  resize: none;
}

::-webkit-scrollbar-track {
  background-color: whitesmoke;
}

.lblSearchFamily {
  width: 100%;
}

.siblingNoRecordArea {
  padding: 20px;
}

.changeStatusArea {
  background-color: #6171dc;
  text-align: left;
  padding: 0;
  display: table;
  border: 2px solid #6171dc;
  margin-top: -10px;
  margin-bottom: 11px;
}

.pendingMovementStatusActionArea {
  background-color: #9b1123;
  text-align: left;
  padding: 0;
  display: table;
  border: 2px solid #9b1123;
  margin-top: -11px;
  margin-bottom: 11px;
}

.pendingMovementStatusAction {
  color: white;
}

.ddlChangeStatusTo,
.lblChangeStatusTo,
.btnChangeStatus,
.btnWithdraw,
.btnTransfer,
.btnUploadDocument,
.btnImmunizationRecords,
.btnAllAboutMe {
  width: auto;
  display: inline !important;
}

.imgStudentProfile:hover {
  cursor: pointer;
}

.imgStudentProfile {
  display: flex;
  width: 200px;
  height: 200px;
  border-radius: 100%;
  background-color: #ffffff;
  margin-top: 16px;
  overflow: hidden;
  position: relative;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
}

.profilePictureArea {
  text-align: left;
  position: relative;
}

.familyIDAreaDiv button {
  margin-bottom: 20px;
}

.profile_wrap span {
  font-size: 20px;
  margin-left: auto;
  letter-spacing: 7px;
  text-transform: uppercase;
}

.profile_wrap {
  display: flex;
  align-items: center;
  position: relative;
}

.profilePictureArea:before {
  content: '';
  background: white;
  display: block;
  height: 75%;
  position: absolute;
  width: 100%;
  top: -10px;
}

.fa-clone {
  font-size: 30px;
  border-radius: 40%;
  padding: 10px;
  background-color: #4caf50;
  cursor: pointer;
}

.fa-clone:hover {
  background-color: #5fb962;
}

.ttStuCorAddCopy {
  text-align: left;
}

.ttStuCorAddCopy .ttnStuCorAddCopy {
  visibility: hidden;
  width: auto;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.ttStuCorAddCopy:hover .ttnStuCorAddCopy {
  visibility: visible;
}

.btnFamilyIDViewParent {
  margin-left: 10px;
  margin-top: 10px;
}

.lblSelectDeferDate,
.inputDeferDate {
  margin-bottom: 5px;
}

.btnDeferSave {
  width: auto !important;
}

.inputFirstCommencementDateDiv .el-date-editor.el-input {
  width: 80% !important;
}

.autoLevel {
  text-align: left;
  color: blue;
}

.schoolEmailDiv,
.resetPasswordStudentSchoolEmailDiv {
  margin-top: 10px;
}

.hubspotBTabs {
  width: 100%;
}

.hubspotBTabs-pane {
  padding: 20px;
}

.hubSpotNote,
.hubSpotTask,
.hubSpotCall,
.hubSpotMeeting,
.hubSpotEmail,
.hubSpotDealStage {
  margin-bottom: 10px;
}

.hubSpotNoteBody,
.hubSpotTaskBody,
.hubSpotCallBody,
.hubSpotMeetingBody,
.hubSpotEmailBody,
.hubSpotDealStageBody {
  background: #dee2e661;
  padding: 10px;
  text-align: left;
}

.lblHubspotDownload {
  cursor: pointer;
  text-decoration: underline;
}

.hubspotDownloadIcon {
  font-size: 20px;
  border-radius: 50%;
  background: #5565cf;
  padding: 5px;
  font-weight: bold;
  color: white;
}

.ddlStudentSubsidy {
  width: 100%;
}

.divConfirmChangeStatusMsg {
  margin-bottom: 10px;
}

.myaccount-image_wrap {
  position: unset !important;
  margin: 0 auto 20px !important;
}

.myaccount-image_overlay {
  background: unset !important;
  opacity: 1 !important;
  color: black;
}

.inputStudentEmail {
  display: inline;
  width: 90%;
}

.inputStudentEmailDelete {
  cursor: pointer;
}

.sdmHeader {
  border-bottom: 1px solid #e4ebf7;
}

.sdmHeaderDiv {
  margin-bottom: 20px;
}

.sdmFooter {
  background: #f8faff;
}

.sdmBodySC {
  margin-bottom: 20px;
}

.sdmBodySCSpan {
  float: right;
  text-align: right;
  cursor: pointer;
}

.sdmBodySCSpan img {
  width: 20px;
  height: 20px;
}

.sdmBody .card-body {
  padding: 0px 10px;
}

.sdmBody .card {
  border: none;
}

.sdmFolder {
  margin-bottom: 10px;
}

.cursorPointer {
  cursor: pointer;
}

.btnCreateNewFolderShowModel {
  color: #ffffff;
  background: #426dff;
  width: 100%;
}

.btnSdmHeaderDiv {
  background-color: #426dff;
  border: none;
  margin-left: 10px;
}

.sdmBodyEachFileDiv {
  background: #ffffff;
  border-radius: 7px;
  width: 100%;
  height: 300px;
  padding: 5px;
  overflow: auto;
}

.sdmBodyEachFileDivDesc {
  margin-top: 10px;
}

.sdmBodySelectedFile {
  border: 5px solid #426dff;
}

.capList {
  float: left;
  margin-top: 10px;
  color: #5c6b77;
  font-size: 16px;
}

.capList span {
  height: 100px;
  display: grid;
  align-items: center;
  overflow: auto;
}

.divClassMate {
  margin-top: 10px;
  cursor: pointer;
}

.divClassMate span {
  color: #ffffff;
}

.selectedFolder {
  background: #426dff;
  color: #ffffff;
  padding: 10px;
}
</style>

<style>
.studentPageBTabs .tab-content {
  margin-top: 30px;
}

.studentPageBTabs .nav-link {
  font-weight: bold;
}

.studentPageBTabs .nav-tabs .nav-link.active {
  background-color: #413f56;
  color: white;
  border: 5px solid #dee2e6;
}

.studentPageBTabs .nav-tabs {
  border-bottom: 5px solid #dee2e6;
}

.studentPageTourDiv .studentPageTourSpecialColor {
  color: #44d362;
}

.v-step {
  z-index: 999;
}
</style>
